import { theme, isResponsiveStyleObject, mapResponsiveStyleProp, autoAddUnit, isGradientColor, getStylePropValue, getColor, breakpointByName, media, colors } from '@helloworld1812/ws-theme';
export * from '@helloworld1812/ws-theme';
import * as React from 'react';
import React__default, { useState, useEffect, useRef, useMemo, createContext, useContext, useCallback, useLayoutEffect, createElement as createElement$2, forwardRef, isValidElement } from 'react';
import styled, { useTheme, css, keyframes, createGlobalStyle, ThemeProvider } from 'styled-components';
import { isEmpty, defaults, omitBy, isNil, get as get$1, identity, union as union$1, omit, difference as difference$1, map, debounce, isNumber, clamp, mapValues, invert, includes } from 'lodash';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import { iconByName, Info, Warning, IconError, MagicPencil, Cross, Minimize, Checkmark, WorkstreamLogo, Expand, Collapse, ChevronLeft, ChevronRight, IconChevronLeft, IconQuestionInfo, Settings, Hamburger } from '@helloworld1812/ws-icons';
import { useStaticPropsGuard } from '@helloworld1812/ws-hooks';
import _Drawer from 'antd/es/drawer';
import _Dropdown from 'antd/es/dropdown';
import _Tooltip from 'antd/es/tooltip';
import _Menu from 'antd/es/menu';
import { useDebounce, useSize } from 'ahooks';
import _Badge from 'antd/es/badge';
import { v4 } from 'uuid';
import { CSSTransition, Transition } from 'react-transition-group';
import { useLottie } from 'lottie-react';
import { unmount, render } from 'rc-util/lib/React/render';
import Dialog from 'rc-dialog';
import * as ReactIs from 'react-is';
import RcSwitch from 'rc-switch';
import _Modal from 'antd/es/modal';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$o =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$o = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$n = fails$o;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$n(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$m = fails$o;

var functionBindNative = !fails$m(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$l = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$l.bind(call$l) : function () {
  return call$l.apply(call$l, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$3 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$4 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$k = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$k, call$k);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$k.apply(fn, arguments);
  };
};

var uncurryThis$p = functionUncurryThis;

var toString$b = uncurryThis$p({}.toString);
var stringSlice$6 = uncurryThis$p(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$6(toString$b(it), 8, -1);
};

var uncurryThis$o = functionUncurryThis;
var fails$l = fails$o;
var classof$8 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$o(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$l(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$8(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$5 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$4 = isNullOrUndefined$5;

var $TypeError$h = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$7 = function (it) {
  if (isNullOrUndefined$4(it)) throw new $TypeError$h("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$6 = requireObjectCoercible$7;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$6(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$o = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$n = isCallable$o;

var isObject$d = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$n(it);
};

var global$n = global$o;
var isCallable$m = isCallable$o;

var aFunction = function (argument) {
  return isCallable$m(argument) ? argument : undefined;
};

var getBuiltIn$9 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$n[namespace]) : global$n[namespace] && global$n[namespace][method];
};

var uncurryThis$n = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$n({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$m = global$o;
var userAgent$3 = engineUserAgent;

var process$3 = global$m.process;
var Deno$1 = global$m.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION$1 = engineV8Version;
var fails$k = fails$o;
var global$l = global$o;

var $String$5 = global$l.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$k(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$8 = getBuiltIn$9;
var isCallable$l = isCallable$o;
var isPrototypeOf$5 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$8('Symbol');
  return isCallable$l($Symbol) && isPrototypeOf$5($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$4 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$k = isCallable$o;
var tryToString$3 = tryToString$4;

var $TypeError$g = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$9 = function (argument) {
  if (isCallable$k(argument)) return argument;
  throw new $TypeError$g(tryToString$3(argument) + ' is not a function');
};

var aCallable$8 = aCallable$9;
var isNullOrUndefined$3 = isNullOrUndefined$5;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$4 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$3(func) ? undefined : aCallable$8(func);
};

var call$j = functionCall;
var isCallable$j = isCallable$o;
var isObject$c = isObject$d;

var $TypeError$f = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$j(fn = input.toString) && !isObject$c(val = call$j(fn, input))) return val;
  if (isCallable$j(fn = input.valueOf) && !isObject$c(val = call$j(fn, input))) return val;
  if (pref !== 'string' && isCallable$j(fn = input.toString) && !isObject$c(val = call$j(fn, input))) return val;
  throw new $TypeError$f("Can't convert object to primitive value");
};

var sharedStore = {exports: {}};

var global$k = global$o;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$7 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$7(global$k, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$k[key] = value;
  } return value;
};

var globalThis$1 = global$o;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$1[SHARED] || defineGlobalProperty$2(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.36.1',
  mode: 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.36.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var store$2 = sharedStore.exports;

var shared$4 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$5 = requireObjectCoercible$7;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$5 = function (argument) {
  return $Object$2(requireObjectCoercible$5(argument));
};

var uncurryThis$m = functionUncurryThis;
var toObject$4 = toObject$5;

var hasOwnProperty = uncurryThis$m({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$4(it), key);
};

var uncurryThis$l = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$a = uncurryThis$l(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$a(++id + postfix, 36);
};

var global$j = global$o;
var shared$3 = shared$4;
var hasOwn$c = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$2 = global$j.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2['for'] || Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$i = function (name) {
  if (!hasOwn$c(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$1 && hasOwn$c(Symbol$2, name)
      ? Symbol$2[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$i = functionCall;
var isObject$b = isObject$d;
var isSymbol$1 = isSymbol$2;
var getMethod$3 = getMethod$4;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$h = wellKnownSymbol$i;

var $TypeError$e = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$h('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$b(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$3(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$i(exoticToPrim, input, pref);
    if (!isObject$b(result) || isSymbol$1(result)) return result;
    throw new $TypeError$e("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$i = global$o;
var isObject$a = isObject$d;

var document$3 = global$i.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$a(document$3) && isObject$a(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$e = descriptors;
var fails$j = fails$o;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$e && !fails$j(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$d = descriptors;
var call$h = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$3 = createPropertyDescriptor$4;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$b = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$d ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$b(O, P)) return createPropertyDescriptor$3(!call$h(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$c = descriptors;
var fails$i = fails$o;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$c && fails$i(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$9 = isObject$d;

var $String$3 = String;
var $TypeError$d = TypeError;

// `Assert: Type(argument) is Object`
var anObject$f = function (argument) {
  if (isObject$9(argument)) return argument;
  throw new $TypeError$d($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$b = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$e = anObject$f;
var toPropertyKey = toPropertyKey$2;

var $TypeError$c = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$b ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$e(O);
  P = toPropertyKey(P);
  anObject$e(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$e(O);
  P = toPropertyKey(P);
  anObject$e(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$c('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$a = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$4;

var createNonEnumerableProperty$8 = DESCRIPTORS$a ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$2(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$9 = descriptors;
var hasOwn$a = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$9 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$a(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$9 || (DESCRIPTORS$9 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$k = functionUncurryThis;
var isCallable$i = isCallable$o;
var store$1 = sharedStore.exports;

var functionToString = uncurryThis$k(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$i(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$h = global$o;
var isCallable$h = isCallable$o;

var WeakMap$1 = global$h.WeakMap;

var weakMapBasicDetection = isCallable$h(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$2 = shared$4;
var uid = uid$2;

var keys$1 = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$g = global$o;
var isObject$8 = isObject$d;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$8;
var hasOwn$9 = hasOwnProperty_1;
var shared$1 = sharedStore.exports;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$g.TypeError;
var WeakMap = global$g.WeakMap;
var set$1, get, has$6;

var enforce = function (it) {
  return has$6(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$8(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store.has(it)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has$6 = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$9(it, STATE)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$7(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$9(it, STATE) ? it[STATE] : {};
  };
  has$6 = function (it) {
    return hasOwn$9(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has$6,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$j = functionUncurryThis;
var fails$h = fails$o;
var isCallable$g = isCallable$o;
var hasOwn$8 = hasOwnProperty_1;
var DESCRIPTORS$8 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$2 = internalState;

var enforceInternalState = InternalStateModule$2.enforce;
var getInternalState$2 = InternalStateModule$2.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;
var stringSlice$5 = uncurryThis$j(''.slice);
var replace$5 = uncurryThis$j(''.replace);
var join = uncurryThis$j([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$8 && !fails$h(function () {
  return defineProperty$6(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$5($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$5($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$8(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$8) defineProperty$6(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$8(options, 'arity') && value.length !== options.arity) {
    defineProperty$6(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$8(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$8) defineProperty$6(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$8(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$g(this) && getInternalState$2(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$f = isCallable$o;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$7 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$f(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$1 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$5 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$4 = toIntegerOrInfinity$5;

var max$2 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$4(index);
  return integer < 0 ? max$2(integer + length, 0) : min$2(integer, length);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$5;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$2 = function (argument) {
  var len = toIntegerOrInfinity$3(argument);
  return len > 0 ? min$1(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$1 = toLength$2;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$3 = function (obj) {
  return toLength$1(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$2 = lengthOfArrayLike$3;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$2(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var uncurryThis$i = functionUncurryThis;
var hasOwn$7 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$1 = uncurryThis$i([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$7(hiddenKeys$2, key) && hasOwn$7(O, key) && push$1(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$7(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$1(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$7 = getBuiltIn$9;
var uncurryThis$h = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$d = anObject$f;

var concat$2 = uncurryThis$h([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$7('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$d(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$6 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$3 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$6(target, key) && !(exceptions && hasOwn$6(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$g = fails$o;
var isCallable$e = isCallable$o;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$e(detection) ? fails$g(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$f = global$o;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$8;
var defineBuiltIn$6 = defineBuiltIn$7;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$2 = copyConstructorProperties$3;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$f;
  } else if (STATIC) {
    target = global$f[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = global$f[TARGET] && global$f[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$2(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$2(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$6(sourceProperty, 'sham', true);
    }
    defineBuiltIn$6(target, key, sourceProperty, options);
  }
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$3 = FunctionPrototype.apply;
var call$g = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$g.bind(apply$3) : function () {
  return call$g.apply(apply$3, arguments);
});

var uncurryThis$g = functionUncurryThis;
var aCallable$7 = aCallable$9;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$g(aCallable$7(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$7 = isObject$d;

var isPossiblePrototype$1 = function (argument) {
  return isObject$7(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String$1 = String;
var $TypeError$b = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$b("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor$1 = functionUncurryThisAccessor;
var isObject$6 = isObject$d;
var requireObjectCoercible$4 = requireObjectCoercible$7;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor$1(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$4(O);
    aPossiblePrototype(proto);
    if (!isObject$6(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var defineProperty$5 = objectDefineProperty.f;

var proxyAccessor$1 = function (Target, Source, key) {
  key in Target || defineProperty$5(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

var isCallable$d = isCallable$o;
var isObject$5 = isObject$d;
var setPrototypeOf$3 = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf$3 &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$d(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject$5(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf$3($this, NewTargetPrototype);
  return $this;
};

var wellKnownSymbol$g = wellKnownSymbol$i;

var TO_STRING_TAG$2 = wellKnownSymbol$g('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$c = isCallable$o;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$f = wellKnownSymbol$i;

var TO_STRING_TAG$1 = wellKnownSymbol$f('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$7 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$c(O.callee) ? 'Arguments' : result;
};

var classof$6 = classof$7;

var $String = String;

var toString$9 = function (argument) {
  if (classof$6(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var toString$8 = toString$9;

var normalizeStringArgument$1 = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString$8(argument);
};

var isObject$4 = isObject$d;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$8;

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
var installErrorCause$1 = function (O, options) {
  if (isObject$4(options) && 'cause' in options) {
    createNonEnumerableProperty$5(O, 'cause', options.cause);
  }
};

var uncurryThis$f = functionUncurryThis;

var $Error = Error;
var replace$4 = uncurryThis$f(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

var errorStackClear = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace$4(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};

var fails$f = fails$o;
var createPropertyDescriptor$1 = createPropertyDescriptor$4;

var errorStackInstallable = !fails$f(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor$1(1, 7));
  return error.stack !== 7;
});

var createNonEnumerableProperty$4 = createNonEnumerableProperty$8;
var clearErrorStack = errorStackClear;
var ERROR_STACK_INSTALLABLE = errorStackInstallable;

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

var errorStackInstall = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty$4(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};

var getBuiltIn$6 = getBuiltIn$9;
var hasOwn$5 = hasOwnProperty_1;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$8;
var isPrototypeOf$4 = objectIsPrototypeOf;
var setPrototypeOf$2 = objectSetPrototypeOf;
var copyConstructorProperties$1 = copyConstructorProperties$3;
var proxyAccessor = proxyAccessor$1;
var inheritIfRequired = inheritIfRequired$1;
var normalizeStringArgument = normalizeStringArgument$1;
var installErrorCause = installErrorCause$1;
var installErrorStack = errorStackInstall;
var DESCRIPTORS$7 = descriptors;

var wrapErrorConstructorWithCause$1 = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn$6.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (hasOwn$5(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn$6('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty$3(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf$4(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf$2) setPrototypeOf$2(WrappedError, BaseError);
    else copyConstructorProperties$1(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS$7 && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties$1(WrappedError, OriginalError);

  try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty$3(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $$m = _export;
var global$e = global$o;
var apply$2 = functionApply;
var wrapErrorConstructorWithCause = wrapErrorConstructorWithCause$1;

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global$e[WEB_ASSEMBLY];

// eslint-disable-next-line es/no-error-cause -- feature detection
var FORCED$2 = new Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED$2);
  $$m({ global: true, constructor: true, arity: 1, forced: FORCED$2 }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED$2);
    $$m({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED$2 }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply$2(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply$2(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply$2(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply$2(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply$2(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply$2(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply$2(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply$2(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply$2(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply$2(init, this, arguments); };
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * ConditionalRenderer
 */
const ConditionalRenderer = props => {
  const {
      children,
      if: propIf,
      condition = propIf,
      wrapper,
      component,
      element
    } = props,
    restProps = __rest(props, ["children", "if", "condition", "wrapper", "component", "element"]);
  if (!condition) {
    if (/*#__PURE__*/React__default.isValidElement(children)) {
      return /*#__PURE__*/React__default.cloneElement(children, restProps);
    }
    return children !== null && children !== void 0 ? children : null;
  }
  if (wrapper) return wrapper(children, restProps);
  if (/*#__PURE__*/React__default.isValidElement(element)) {
    return /*#__PURE__*/React__default.cloneElement(element, restProps, children);
  }
  if (component) {
    return /*#__PURE__*/React__default.createElement(component, restProps, children);
  }
  throw new Error('[ConditionalRenderer]: must provide at least one of wrapper, element and component!');
};

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$6 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$c = anObject$f;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$6 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$c(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$5 = getBuiltIn$9;

var html$2 = getBuiltIn$5('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$b = anObject$f;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$b(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$e = wellKnownSymbol$i;
var create$2 = objectCreate;
var defineProperty$4 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$e('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] === undefined) {
  defineProperty$4(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$e = fails$o;

var correctPrototypeGetter = !fails$e(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$4 = hasOwnProperty_1;
var isCallable$b = isCallable$o;
var toObject$3 = toObject$5;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject$3(O);
  if (hasOwn$4(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$b(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

var fails$d = fails$o;
var isCallable$a = isCallable$o;
var isObject$3 = isObject$d;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$5 = defineBuiltIn$7;
var wellKnownSymbol$d = wellKnownSymbol$i;

var ITERATOR$6 = wellKnownSymbol$d('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$3(IteratorPrototype$2) || fails$d(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$6].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$a(IteratorPrototype$2[ITERATOR$6])) {
  defineBuiltIn$5(IteratorPrototype$2, ITERATOR$6, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$3 = objectDefineProperty.f;
var hasOwn$3 = hasOwnProperty_1;
var wellKnownSymbol$c = wellKnownSymbol$i;

var TO_STRING_TAG = wellKnownSymbol$c('toStringTag');

var setToStringTag$4 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$3(target, TO_STRING_TAG)) {
    defineProperty$3(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$4;
var setToStringTag$3 = setToStringTag$4;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$3(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var $$l = _export;
var call$f = functionCall;
var FunctionName = functionName;
var isCallable$9 = isCallable$o;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$4;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$8;
var defineBuiltIn$4 = defineBuiltIn$7;
var wellKnownSymbol$b = wellKnownSymbol$i;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$5 = wellKnownSymbol$b('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$5]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$9(CurrentIteratorPrototype[ITERATOR$5])) {
          defineBuiltIn$4(CurrentIteratorPrototype, ITERATOR$5, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$2(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$f(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$4(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$l({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$5] !== defaultIterator) {
    defineBuiltIn$4(IterablePrototype, ITERATOR$5, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$2 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS$5 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$5 && values.name !== 'values') try {
  defineProperty$2(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$d = global$o;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$8;
var setToStringTag$1 = setToStringTag$4;
var wellKnownSymbol$a = wellKnownSymbol$i;

var ITERATOR$4 = wellKnownSymbol$a('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$4] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$4, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$4] = ArrayValues;
    }
    setToStringTag$1(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$d[COLLECTION_NAME] && global$d[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

const useRawMediaQuery = media => {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    const mediaQuery = window.matchMedia(media);
    setMatches(mediaQuery.matches);
    const handleMediaQueryChange = event => {
      setMatches(event.matches);
    };
    mediaQuery.addEventListener('change', handleMediaQueryChange);
    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange);
    };
  }, [media]);
  return {
    matches,
    media
  };
};
const useMediaQuery = breakpointKeyOrOptions => {
  var _a, _b;
  const _theme = /*#__PURE__*/useTheme();
  const theme$1 = isEmpty(_theme) ? theme : _theme;
  const options = typeof breakpointKeyOrOptions === 'string' ? {
    min: breakpointKeyOrOptions
  } : breakpointKeyOrOptions;
  const findBreakpoint = key => theme$1.breakpoints.find(breakpoint => breakpoint.name === key || breakpoint.alias === key);
  const minWidth = (_a = findBreakpoint(options.min)) === null || _a === void 0 ? void 0 : _a.width;
  const maxWidth = (_b = findBreakpoint(options.max)) === null || _b === void 0 ? void 0 : _b.width;
  if (options.min && minWidth == null) {
    throw new Error(`No breakpoint found for min: ${options.min}. Check the breakpoints in your theme.`);
  }
  if (options.max && maxWidth == null) {
    throw new Error(`No breakpoint found for max: ${options.max}. Check the breakpoints in your theme.`);
  }
  const minQuery = minWidth != null ? `(min-width: ${minWidth}px)` : undefined;
  const maxQuery = maxWidth != null ? `(max-width: ${maxWidth - 1}px)` : undefined;
  return useRawMediaQuery([minQuery, maxQuery].filter(query => query != null).join(' and '));
};

function useRefs() {
  const cacheRefs = useRef(new Map());
  function getRef(key) {
    const curRef = cacheRefs.current.get(key);
    if (curRef) {
      return curRef;
    }
    const newRef = /*#__PURE__*/React.createRef();
    cacheRefs.current.set(key, newRef);
    return newRef;
  }
  function removeRef(key) {
    cacheRefs.current.delete(key);
  }
  return [getRef, removeRef];
}

var DESCRIPTORS$4 = descriptors;
var uncurryThis$e = functionUncurryThis;
var call$e = functionCall;
var fails$c = fails$o;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$5;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$1 = Object.defineProperty;
var concat$1 = uncurryThis$e([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$c(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$4 && $assign({ b: 1 }, $assign(defineProperty$1({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$4 || call$e(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$k = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$k({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

var $$j = _export;
var $includes = arrayIncludes.includes;
var fails$b = fails$o;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$b(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$j({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/** get normalized margin left, right, top, bottom from spacing props */
const normalizeMarginValues = props => {
  const {
    m,
    margin = m
  } = props;
  const groupedMarginProps = typeof margin === 'object' && !Array.isArray(margin) && !isResponsiveStyleObject(margin) ? margin : undefined;
  const {
    mx,
    marginX = mx !== null && mx !== void 0 ? mx : groupedMarginProps === null || groupedMarginProps === void 0 ? void 0 : groupedMarginProps.x,
    my,
    marginY = my !== null && my !== void 0 ? my : groupedMarginProps === null || groupedMarginProps === void 0 ? void 0 : groupedMarginProps.y,
    mt,
    marginTop = mt !== null && mt !== void 0 ? mt : groupedMarginProps === null || groupedMarginProps === void 0 ? void 0 : groupedMarginProps.top,
    mb,
    marginBottom = mb !== null && mb !== void 0 ? mb : groupedMarginProps === null || groupedMarginProps === void 0 ? void 0 : groupedMarginProps.bottom,
    ml,
    marginLeft = ml !== null && ml !== void 0 ? ml : groupedMarginProps === null || groupedMarginProps === void 0 ? void 0 : groupedMarginProps.left,
    mr,
    marginRight = mr !== null && mr !== void 0 ? mr : groupedMarginProps === null || groupedMarginProps === void 0 ? void 0 : groupedMarginProps.right,
    mxt,
    marginExceptTop = mxt,
    mxb,
    marginExceptBottom = mxb,
    mxl,
    marginExceptLeft = mxl,
    mxr,
    marginExceptRight = mxr
  } = props;
  // throw error if more than one of marginExceptTop, marginExceptBottom, marginExceptLeft, marginExceptRight is set
  const marginExcepts = [marginExceptTop, marginExceptBottom, marginExceptLeft, marginExceptRight].filter(v => v != null);
  if (marginExcepts.length > 1) {
    throw new Error('Only one of marginExceptTop, marginExceptBottom, marginExceptLeft, marginExceptRight can be set at once!');
  }
  const marginProps = [marginX, marginY, marginTop, marginBottom, marginLeft, marginRight, ...marginExcepts].filter(v => v != null);
  if (!marginProps.length && typeof margin !== 'object') {
    return margin;
  }
  const normalizedMargin = margin != null ? Array.isArray(margin) ? {
    top: margin[0],
    right: margin[1],
    bottom: margin[2],
    left: margin[3]
  } : typeof margin !== 'object' || isResponsiveStyleObject(margin) ? {
    all: margin
  } :
  // ignore grouped margin props
  undefined : margin;
  const normalizedMarginX = marginX != null ? Array.isArray(marginX) ? {
    left: marginX[0],
    right: marginX[1]
  } : {
    left: marginX,
    right: marginX
  } : marginX;
  const normalizedMarginY = marginY != null ? Array.isArray(marginY) ? {
    top: marginY[0],
    bottom: marginY[1]
  } : {
    top: marginY,
    bottom: marginY
  } : marginY;
  const normalizedMarginExceptTop = marginExceptTop != null ? {
    right: marginExceptTop,
    bottom: marginExceptTop,
    left: marginExceptTop
  } : undefined;
  const normalizedMarginExceptBottom = marginExceptBottom != null ? {
    top: marginExceptBottom,
    right: marginExceptBottom,
    left: marginExceptBottom
  } : undefined;
  const normalizedMarginExceptLeft = marginExceptLeft != null ? {
    top: marginExceptLeft,
    right: marginExceptLeft,
    bottom: marginExceptLeft
  } : undefined;
  const normalizedMarginExceptRight = marginExceptRight != null ? {
    top: marginExceptRight,
    left: marginExceptRight,
    bottom: marginExceptRight
  } : undefined;
  const normalizedMarginLeft = marginLeft != null ? {
    left: marginLeft
  } : undefined;
  const normalizedMarginRight = marginRight != null ? {
    right: marginRight
  } : undefined;
  const normalizedMarginTop = marginTop != null ? {
    top: marginTop
  } : undefined;
  const normalizedMarginBottom = marginBottom != null ? {
    bottom: marginBottom
  } : undefined;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, normalizedMargin), normalizedMarginExceptTop), normalizedMarginExceptBottom), normalizedMarginExceptLeft), normalizedMarginExceptRight), normalizedMarginX), normalizedMarginY), normalizedMarginLeft), normalizedMarginRight), normalizedMarginTop), normalizedMarginBottom);
};
/** get normalized padding left, right, top, bottom from spacing props */
const normalizePaddingValues = props => {
  const {
    p,
    padding = p
  } = props;
  const groupedPaddingProps = typeof padding === 'object' && !Array.isArray(padding) && !isResponsiveStyleObject(padding) ? padding : undefined;
  const {
    px,
    paddingX = px !== null && px !== void 0 ? px : groupedPaddingProps === null || groupedPaddingProps === void 0 ? void 0 : groupedPaddingProps.x,
    py,
    paddingY = py !== null && py !== void 0 ? py : groupedPaddingProps === null || groupedPaddingProps === void 0 ? void 0 : groupedPaddingProps.y,
    pt,
    paddingTop = pt !== null && pt !== void 0 ? pt : groupedPaddingProps === null || groupedPaddingProps === void 0 ? void 0 : groupedPaddingProps.top,
    pb,
    paddingBottom = pb !== null && pb !== void 0 ? pb : groupedPaddingProps === null || groupedPaddingProps === void 0 ? void 0 : groupedPaddingProps.bottom,
    pl,
    paddingLeft = pl !== null && pl !== void 0 ? pl : groupedPaddingProps === null || groupedPaddingProps === void 0 ? void 0 : groupedPaddingProps.left,
    pr,
    paddingRight = pr !== null && pr !== void 0 ? pr : groupedPaddingProps === null || groupedPaddingProps === void 0 ? void 0 : groupedPaddingProps.right,
    pxt,
    paddingExceptTop = pxt,
    pxb,
    paddingExceptBottom = pxb,
    pxl,
    paddingExceptLeft = pxl,
    pxr,
    paddingExceptRight = pxr
  } = props;
  // throw error if more than one of paddingExceptTop, paddingExceptBottom, paddingExceptLeft, paddingExceptRight is set
  const paddingExcepts = [paddingExceptTop, paddingExceptBottom, paddingExceptLeft, paddingExceptRight].filter(v => v != null);
  if (paddingExcepts.length > 1) {
    throw new Error('Only one of paddingExceptTop, paddingExceptBottom, paddingExceptLeft, paddingExceptRight can be set at once!');
  }
  const paddingProps = [paddingX, paddingY, paddingTop, paddingBottom, paddingLeft, paddingRight, ...paddingExcepts].filter(v => v != null);
  if (!paddingProps.length && typeof padding !== 'object') {
    return padding !== null && padding !== void 0 ? padding : {};
  }
  const normalizedPadding = padding != null ? Array.isArray(padding) ? {
    top: padding[0],
    right: padding[1],
    bottom: padding[2],
    left: padding[3]
  } : typeof padding !== 'object' || isResponsiveStyleObject(padding) ? {
    all: padding
  } :
  // ignore grouped padding props
  undefined : padding;
  const normalizedPaddingX = paddingX != null ? Array.isArray(paddingX) ? {
    left: paddingX[0],
    right: paddingX[1]
  } : {
    left: paddingX,
    right: paddingX
  } : paddingX;
  const normalizedPaddingY = paddingY != null ? Array.isArray(paddingY) ? {
    top: paddingY[0],
    bottom: paddingY[1]
  } : {
    top: paddingY,
    bottom: paddingY
  } : paddingY;
  const normalizedPaddingExceptTop = paddingExceptTop != null ? {
    right: paddingExceptTop,
    bottom: paddingExceptTop,
    left: paddingExceptTop
  } : undefined;
  const normalizedPaddingExceptBottom = paddingExceptBottom != null ? {
    top: paddingExceptBottom,
    right: paddingExceptBottom,
    left: paddingExceptBottom
  } : undefined;
  const normalizedPaddingExceptLeft = paddingExceptLeft != null ? {
    top: paddingExceptLeft,
    right: paddingExceptLeft,
    bottom: paddingExceptLeft
  } : undefined;
  const normalizedPaddingExceptRight = paddingExceptRight != null ? {
    top: paddingExceptRight,
    left: paddingExceptRight,
    bottom: paddingExceptRight
  } : undefined;
  const normalizedPaddingLeft = paddingLeft != null ? {
    left: paddingLeft
  } : undefined;
  const normalizedPaddingRight = paddingRight != null ? {
    right: paddingRight
  } : undefined;
  const normalizedPaddingTop = paddingTop != null ? {
    top: paddingTop
  } : undefined;
  const normalizedPaddingBottom = paddingBottom != null ? {
    bottom: paddingBottom
  } : undefined;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, normalizedPadding), normalizedPaddingExceptTop), normalizedPaddingExceptBottom), normalizedPaddingExceptLeft), normalizedPaddingExceptRight), normalizedPaddingX), normalizedPaddingY), normalizedPaddingLeft), normalizedPaddingRight), normalizedPaddingTop), normalizedPaddingBottom);
};

const spaceCssFromNormalized = (key, responsiveValueOrMap) => ({
  theme: propTheme
}) => {
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  if (typeof responsiveValueOrMap === 'string') {
    return `${key}: ${theme$1.getSpacing(responsiveValueOrMap)};`;
  }
  if (typeof responsiveValueOrMap === 'number') {
    return `${key}: ${theme$1.getSpacing(responsiveValueOrMap)};`;
  }
  return ['all', 'left', 'right', 'top', 'bottom'].map(dir => {
    const responsiveValue = responsiveValueOrMap[dir];
    if (responsiveValue == null) {
      return undefined;
    }
    if (dir === 'all') {
      return mapResponsiveStyleProp(responsiveValue, value => {
        const valueArray = Array.isArray(value) ? value : [value];
        return `${key}: ${valueArray.map(v => theme$1.getSpacing(v))};`;
      });
    }
    return mapResponsiveStyleProp(responsiveValue, v => `${key}-${dir}: ${theme$1.getSpacing(v)};`);
  });
};
// A Box component accepts props of theme
const Box = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: prop => !['display', 'width', 'height', 'color'].includes(prop) && isPropValid(prop),
  displayName: "box__Box",
  componentId: "sc-rbiygf-0"
})(props => {
  const normalizedMargin = normalizeMarginValues(props);
  const normalizedPadding = normalizePaddingValues(props);
  const {
    theme: propTheme,
    // block styles
    display,
    w,
    width = w,
    h,
    height = h,
    minWidth,
    maxWidth,
    minHeight,
    maxHeight,
    // position props
    position,
    top,
    right,
    bottom,
    left,
    // color props
    color,
    $color = color,
    bgColor,
    backgroundColor = bgColor,
    borderColor,
    // border props
    border,
    borderTop,
    borderRight,
    borderBottom,
    borderLeft,
    borderStyle,
    cornerRadius,
    borderRadius = cornerRadius,
    // elevation props
    elevation,
    boxShadow = elevation,
    zIndex
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  const hasBorderWidthProps = [border, borderTop, borderRight, borderBottom, borderLeft].filter(x => x != null).length > 0;
  const defaultBorderWidth = hasBorderWidthProps ? 0 : 1;
  return css(["", " box-sizing:border-box;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], mapResponsiveStyleProp(display, v => `display: ${v};`), mapResponsiveStyleProp(width, v => `width: ${theme$1.getSpacing(v)};`), mapResponsiveStyleProp(height, v => `height: ${theme$1.getSpacing(v)};`), mapResponsiveStyleProp(minWidth, v => `min-width: ${theme$1.getSpacing(v)};`), mapResponsiveStyleProp(maxWidth, v => `max-width: ${theme$1.getSpacing(v)};`), mapResponsiveStyleProp(minHeight, v => `min-height: ${theme$1.getSpacing(v)};`), mapResponsiveStyleProp(maxHeight, v => `max-height: ${theme$1.getSpacing(v)};`), mapResponsiveStyleProp(position, v => v === 'centered' ? `
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
          ` : `position: ${v};`), mapResponsiveStyleProp(top, v => `top: ${theme$1.getSpacing(v)};`), mapResponsiveStyleProp(right, v => `right: ${theme$1.getSpacing(v)};`), mapResponsiveStyleProp(bottom, v => `bottom: ${theme$1.getSpacing(v)};`), mapResponsiveStyleProp(left, v => `left: ${theme$1.getSpacing(v)};`), mapResponsiveStyleProp(border, v => `border: ${autoAddUnit(v)};`), mapResponsiveStyleProp(borderTop, v => `border-top: ${autoAddUnit(v)};`), mapResponsiveStyleProp(borderRight, v => `border-right: ${autoAddUnit(v)};`), mapResponsiveStyleProp(borderBottom, v => `border-bottom: ${autoAddUnit(v)};`), mapResponsiveStyleProp(borderLeft, v => `border-left: ${autoAddUnit(v)};`), mapResponsiveStyleProp(borderStyle, v => `border-style: ${v};`), borderColor && css(["", " ", " ", ""], borderStyle == null && `border-style: solid;`, !hasBorderWidthProps && `border-width: 1px;`, mapResponsiveStyleProp(borderColor, (v, breakpointKey) => {
    var _a, _b;
    return isGradientColor(v) ? css(["border-style:none;position:relative;background-clip:padding-box;background-color:white;z-index:1;", " &:before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;border-radius:inherit;-webkit-mask:linear-gradient(#fff 0 0) content-box,linear-gradient(#fff 0 0);-webkit-mask-composite:xor;mask-composite:exclude;z-index:-1;background:", ";padding:", ";}"], isEmpty(normalizedPadding) && css(["padding:", ";"], autoAddUnit((_a = getStylePropValue(border, breakpointKey)) !== null && _a !== void 0 ? _a : defaultBorderWidth)), theme$1.getColor(v), autoAddUnit((_b = getStylePropValue(border, breakpointKey)) !== null && _b !== void 0 ? _b : defaultBorderWidth)) : css(["border-color:", ";"], theme$1.getColor(v));
  })), mapResponsiveStyleProp($color, v => `color: ${theme$1.getColor(v)};`), mapResponsiveStyleProp(backgroundColor, v => `background-color: ${theme$1.getColor(v)};`), mapResponsiveStyleProp(zIndex, v => `z-index: ${typeof v === 'number' ? v : theme$1.zIndex[v]};`), mapResponsiveStyleProp(boxShadow, v => `box-shadow: ${theme$1.boxShadows[v]};`), mapResponsiveStyleProp(borderRadius, v => `border-radius: ${theme$1.borderRadius[v]};`), normalizedMargin != null && spaceCssFromNormalized('margin', normalizedMargin), spaceCssFromNormalized('padding', normalizedPadding));
});

/**
 * Just an adapter for reflexbox4 Box
 * @deprecated please use Box directly instead
 * */
const Reflexbox4Box = /*#__PURE__*/styled(Box).attrs({
  margin: 0,
  minWidth: 0
}).withConfig({
  displayName: "box__Reflexbox4Box",
  componentId: "sc-abopeh-0"
})([""]);

const defaultBoxProps = {
  display: 'flex'
};
const FlexBox = /*#__PURE__*/styled(Box).withConfig({
  shouldForwardProp: prop => !['auto', 'column', 'direction', 'wrap'].includes(prop) && isPropValid(prop),
  displayName: "flex-box__FlexBox",
  componentId: "sc-1d8eqmq-0"
}).attrs(({
  display,
  color
}) => Object.assign(Object.assign(Object.assign({}, defaultBoxProps), display != null && {
  display
}), {
  $color: color
}))(props => {
  const {
    theme: propTheme,
    auto,
    flex = auto ? '1 1 auto' : undefined,
    column,
    direction,
    flexDirection = column ? 'column' : direction,
    align,
    alignItems = align,
    justify,
    justifyContent = justify,
    wrap,
    flexWrap = wrap === true ? 'wrap' : wrap,
    shrink,
    grow,
    basis,
    order,
    alignSelf,
    gap
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return css(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], mapResponsiveStyleProp(flex, v => `flex: ${v};`), mapResponsiveStyleProp(flexDirection, v => `flex-direction: ${v};`), mapResponsiveStyleProp(alignItems, v => `align-items: ${v};`), mapResponsiveStyleProp(justifyContent, v => `justify-content: ${v};`), mapResponsiveStyleProp(flexWrap, v => `flex-wrap: ${v};`), mapResponsiveStyleProp(shrink, v => `flex-shrink: ${v};`), mapResponsiveStyleProp(grow, v => `flex-grow: ${v};`), mapResponsiveStyleProp(basis, v => `flex-basis: ${theme$1.getSpacing(v)};`), mapResponsiveStyleProp(order, v => `order: ${v};`), mapResponsiveStyleProp(alignSelf, v => `align-self: ${v};`), mapResponsiveStyleProp(gap, v => `gap: ${theme$1.getSpacing(v)};`));
});

/**
 * Just an adapter for reflexbox4
 * @deprecated please use FlexBox directly instead
 * */
const Reflexbox4Flex = /*#__PURE__*/styled(FlexBox).attrs({
  margin: 0,
  minWidth: 0
}).withConfig({
  displayName: "flex-box__Reflexbox4Flex",
  componentId: "sc-sx8b07-0"
})([""]);
/**
 * Just an adapter for theme-ui Flex
 * @deprecated please use FlexBox directly instead
 * */
const ThemeUiFlex = /*#__PURE__*/styled(FlexBox).attrs({
  margin: 0,
  minWidth: 0
}).withConfig({
  displayName: "flex-box__ThemeUiFlex",
  componentId: "sc-sx8b07-1"
})([""]);

const fontWeightByName$1 = {
  bold: 'bold',
  regular: 'normal',
  normal: 'normal',
  semibold: 600,
  inherit: 'inherit'
};
const defaultPropsByVariant$8 = {
  title: {
    component: 'h1',
    fontWeight: 'bold',
    fontSize: 54,
    lineHeight: '67px'
  },
  h1: {
    component: 'h1',
    fontWeight: 'bold',
    fontSize: 24,
    lineHeight: '34px'
  },
  h2: {
    component: 'h2',
    fontWeight: 'bold',
    fontSize: 18,
    lineHeight: '25px'
  },
  h3: {
    component: 'h3',
    fontWeight: 'semibold',
    fontSize: 16,
    lineHeight: '22px'
  },
  body: {
    component: 'p',
    fontWeight: 'regular',
    fontSize: 14,
    lineHeight: '20px'
  },
  caption: {
    component: 'p',
    fontWeight: 'regular',
    fontSize: 12,
    lineHeight: '17px'
  },
  default: {
    component: 'span',
    color: 'inherit'
  },
  link: {
    component: 'a',
    color: 'textLink',
    style: {
      display: 'block'
    }
  },
  linkInline: {
    component: 'a',
    color: 'textLink',
    underline: true
  }
};

/**
 * Build typography style from style props
 */
const buildTypographyStyle = ({
  fontFamily,
  fontSize,
  fontWeight,
  lineHeight,
  textAlign,
  ellipsis,
  id,
  maxCh,
  disabled,
  underline,
  italic,
  component,
  letterSpacing,
  textWrap
}) => {
  return css(["font-family:", " var(--font-plus-jakarta-sans),'Plus Jakarta Sans','Segoe UI',Arial,Helvetica,sans-serif;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], fontFamily ? `${fontFamily}, ` : '', mapResponsiveStyleProp(fontSize !== null && fontSize !== void 0 ? fontSize : 'inherit', fz => `font-size: ${autoAddUnit(fz)};`), mapResponsiveStyleProp(lineHeight !== null && lineHeight !== void 0 ? lineHeight : 'inherit', lh => `line-height: ${typeof lh === 'number' && lh < 10 ? lh : autoAddUnit(lh)};`), mapResponsiveStyleProp(fontWeight !== null && fontWeight !== void 0 ? fontWeight : 'inherit', fw => `font-weight: ${typeof fw === 'string' ? fontWeightByName$1[fw] : fw};`), letterSpacing && `letter-spacing: ${autoAddUnit(letterSpacing)};`, textAlign && css(["text-align:", ";"], textAlign), ellipsis && css(["display:-webkit-box;overflow:hidden;white-space:normal;-webkit-box-orient:vertical;-webkit-line-clamp:", ";"], ellipsis), id && 'scroll-margin-top: 100px;', maxCh && css(["max-width:", "ch;"], maxCh), component === 'a' && css(["cursor:pointer;&:hover{color:", ";", "}"], getColor('blue600'), underline && 'text-decoration: underline;'), underline && 'text-decoration: underline;', italic && 'font-style: italic;', disabled && css(["cursor:not-allowed;"]), textWrap && `text-wrap: ${textWrap};`);
};
const Typography$1 = /*#__PURE__*/styled(Box).withConfig({
  shouldForwardProp: prop => !['fontSize', 'fontWeight', 'variant', 'fontFamily'].includes(prop) && isPropValid(prop)
}).attrs(props => {
  const {
      theme: propTheme
    } = props,
    restProps = __rest(props, ["theme"]);
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return Object.assign({
    theme: theme$1
  }, restProps);
}).withConfig({
  displayName: "typographystyle__Typography",
  componentId: "sc-o5gqiw-0"
})(["", ""], props => buildTypographyStyle(props));
const S$a = {
  Typography: Typography$1
};

const Typography = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  var _a;
  const variant = props.variant || 'default';
  const defaultProps = defaultPropsByVariant$8[variant];
  // Don't use defaults(props, defaultProps) here;
  const mergedProps = defaults(Object.assign({}, props), defaultProps);
  const _b = Object.assign(Object.assign({}, mergedProps), props),
    {
      color: mergedPropColor = 'textPrimary',
      disabledColor = 'textDisabled',
      disabled,
      href,
      target,
      rel,
      anchorProps: propAnchorProps
    } = _b,
    restProps = __rest(_b, ["color", "disabledColor", "disabled", "href", "target", "rel", "anchorProps"]);
  const color = (_a = props.color) !== null && _a !== void 0 ? _a : disabled ? disabledColor : mergedPropColor;
  const anchorProps = restProps.component === 'a' ? Object.assign(Object.assign({}, propAnchorProps), {
    href,
    target,
    rel
  }) : {};
  return jsx(S$a.Typography, Object.assign({
    ref: ref,
    variant: variant,
    // m has the lowest priority, so we need to set it to 0 instead of margin or marginTop&marginBottom
    m: 0,
    // code is correct, but type has issue here. TODO: fix the type issue
    as: restProps.component
  }, restProps, anchorProps, {
    color: color,
    disabled: disabled
  }));
});

const Link = _a => {
  var {
      inline
    } = _a,
    props = __rest(_a, ["inline"]);
  return jsx(Typography, Object.assign({
    variant: inline ? 'linkInline' : 'link'
  }, props, {
    component: "a"
  }));
};

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$d = functionUncurryThis;
var requireObjectCoercible$3 = requireObjectCoercible$7;
var toString$7 = toString$9;
var whitespaces$1 = whitespaces$2;

var replace$3 = uncurryThis$d(''.replace);
var ltrim = RegExp('^[' + whitespaces$1 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$1 + '])[' + whitespaces$1 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$1 = function (TYPE) {
  return function ($this) {
    var string = toString$7(requireObjectCoercible$3($this));
    if (TYPE & 1) string = replace$3(string, ltrim, '');
    if (TYPE & 2) string = replace$3(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$1(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$1(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$1(3)
};

var global$c = global$o;
var fails$a = fails$o;
var uncurryThis$c = functionUncurryThis;
var toString$6 = toString$9;
var trim = stringTrim.trim;
var whitespaces = whitespaces$2;

var $parseInt$1 = global$c.parseInt;
var Symbol$1 = global$c.Symbol;
var ITERATOR$3 = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec$2 = uncurryThis$c(hex.exec);
var FORCED$1 = $parseInt$1(whitespaces + '08') !== 8 || $parseInt$1(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$3 && !fails$a(function () { $parseInt$1(Object(ITERATOR$3)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$1 ? function parseInt(string, radix) {
  var S = trim(toString$6(string));
  return $parseInt$1(S, (radix >>> 0) || (exec$2(hex, S) ? 16 : 10));
} : $parseInt$1;

var $$i = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$i({ global: true, forced: parseInt !== $parseInt }, {
  parseInt: $parseInt
});

var anObject$a = anObject$f;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$a(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$9 = fails$o;
var global$b = global$o;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$b.RegExp;

var UNSUPPORTED_Y$1 = fails$9(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$9(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$9(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

var fails$8 = fails$o;
var global$a = global$o;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$a.RegExp;

var regexpUnsupportedDotAll = fails$8(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$7 = fails$o;
var global$9 = global$o;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$9.RegExp;

var regexpUnsupportedNcg = fails$7(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$d = functionCall;
var uncurryThis$b = functionUncurryThis;
var toString$5 = toString$9;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = uncurryThis$b(''.charAt);
var indexOf = uncurryThis$b(''.indexOf);
var replace$2 = uncurryThis$b(''.replace);
var stringSlice$4 = uncurryThis$b(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$d(nativeExec, re1, 'a');
  call$d(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$5(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$d(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$d(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$2(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$4(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$d(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$4(match.input, charsAdded);
        match[0] = stringSlice$4(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$d(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$h = _export;
var exec$1 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$h({ target: 'RegExp', proto: true, forced: /./.exec !== exec$1 }, {
  exec: exec$1
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var $$g = _export;
var call$c = functionCall;
var isCallable$8 = isCallable$o;
var anObject$9 = anObject$f;
var toString$4 = toString$9;

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$$g({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject$9(this);
    var string = toString$4(S);
    var exec = R.exec;
    if (!isCallable$8(exec)) return call$c(nativeTest, R, string);
    var result = call$c(exec, R, string);
    if (result === null) return false;
    anObject$9(result);
    return true;
  }
});

var call$b = functionCall;
var hasOwn$2 = hasOwnProperty_1;
var isPrototypeOf$3 = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$2 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$2) && !hasOwn$2(R, 'flags') && isPrototypeOf$3(RegExpPrototype$2, R)
    ? call$b(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn$3 = defineBuiltIn$7;
var anObject$8 = anObject$f;
var $toString = toString$9;
var fails$6 = fails$o;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$6(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$3(RegExpPrototype$1, TO_STRING, function toString() {
    var R = anObject$8(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$a = functionCall;
var defineBuiltIn$2 = defineBuiltIn$7;
var regexpExec$1 = regexpExec$2;
var fails$5 = fails$o;
var wellKnownSymbol$9 = wellKnownSymbol$i;
var createNonEnumerableProperty = createNonEnumerableProperty$8;

var SPECIES$3 = wellKnownSymbol$9('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$9(KEY);

  var DELEGATES_TO_SYMBOL = !fails$5(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$5(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$3] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call$a(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$a(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$2(String.prototype, KEY, methods[0]);
    defineBuiltIn$2(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var uncurryThis$a = functionUncurryThis;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$5;
var toString$3 = toString$9;
var requireObjectCoercible$2 = requireObjectCoercible$7;

var charAt$2 = uncurryThis$a(''.charAt);
var charCodeAt = uncurryThis$a(''.charCodeAt);
var stringSlice$3 = uncurryThis$a(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$3(requireObjectCoercible$2($this));
    var position = toIntegerOrInfinity$2(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$3(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var uncurryThis$9 = functionUncurryThis;
var toObject$1 = toObject$5;

var floor = Math.floor;
var charAt = uncurryThis$9(''.charAt);
var replace$1 = uncurryThis$9(''.replace);
var stringSlice$2 = uncurryThis$9(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$1(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$2(str, 0, position);
      case "'": return stringSlice$2(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$2(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var call$9 = functionCall;
var anObject$7 = anObject$f;
var isCallable$7 = isCallable$o;
var classof$5 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$a = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$7(exec)) {
    var result = call$9(exec, R, S);
    if (result !== null) anObject$7(result);
    return result;
  }
  if (classof$5(R) === 'RegExp') return call$9(regexpExec, R, S);
  throw new $TypeError$a('RegExp#exec called on incompatible receiver');
};

var apply$1 = functionApply;
var call$8 = functionCall;
var uncurryThis$8 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var fails$4 = fails$o;
var anObject$6 = anObject$f;
var isCallable$6 = isCallable$o;
var isNullOrUndefined$2 = isNullOrUndefined$5;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$5;
var toLength = toLength$2;
var toString$2 = toString$9;
var requireObjectCoercible$1 = requireObjectCoercible$7;
var advanceStringIndex = advanceStringIndex$1;
var getMethod$2 = getMethod$4;
var getSubstitution = getSubstitution$1;
var regExpExec = regexpExecAbstract;
var wellKnownSymbol$8 = wellKnownSymbol$i;

var REPLACE = wellKnownSymbol$8('replace');
var max$1 = Math.max;
var min = Math.min;
var concat = uncurryThis$8([].concat);
var push = uncurryThis$8([].push);
var stringIndexOf$1 = uncurryThis$8(''.indexOf);
var stringSlice$1 = uncurryThis$8(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$4(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$1(this);
      var replacer = isNullOrUndefined$2(searchValue) ? undefined : getMethod$2(searchValue, REPLACE);
      return replacer
        ? call$8(replacer, searchValue, O, replaceValue)
        : call$8(nativeReplace, toString$2(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$6(this);
      var S = toString$2(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf$1(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$6(replaceValue);
      if (!functionalReplace) replaceValue = toString$2(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString$2(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$2(result[0]);
        var position = max$1(min(toIntegerOrInfinity$1(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          replacement = toString$2(apply$1(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$1(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice$1(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

const transformColorFromHexToRgb = hex => {
  const cPattern = /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;
  if (!cPattern.test(hex)) {
    throw new Error('Invalid hex color');
  }
  const hexColor = hex.replace('#', '');
  const r = parseInt(hexColor.substring(0, 2), 16);
  const g = parseInt(hexColor.substring(2, 4), 16);
  const b = parseInt(hexColor.substring(4, 6), 16);
  return {
    r,
    g,
    b
  };
};
const transformColorFromRgbToHex = rgb => {
  Object.values(rgb).forEach(val => {
    if (val < 0 || val > 255) {
      throw new Error('Invalid RGB color');
    }
  });
  return `#${rgb.r.toString(16)}${rgb.g.toString(16)}${rgb.b.toString(16)}`;
};

const interactionColor = {
  hover: {
    color: '#23272F',
    opacity: 0.08
  },
  focus: {
    color: '#23272F',
    opacity: 0.12
  },
  pressed: {
    color: '#23272F',
    opacity: 0.1
  }
};
const alphaColorCalc = (baseColor, interactionColorObj) => {
  const {
    color: interactionColor,
    opacity
  } = interactionColorObj;
  const interactionColorValue = transformColorFromHexToRgb(interactionColor);
  const baseColorValue = transformColorFromHexToRgb(getColor(baseColor));
  const alphaColorValue = {
    r: Math.round(interactionColorValue.r * opacity + baseColorValue.r * (1 - opacity)),
    g: Math.round(interactionColorValue.g * opacity + baseColorValue.g * (1 - opacity)),
    b: Math.round(interactionColorValue.b * opacity + baseColorValue.b * (1 - opacity))
  };
  return alphaColorValue;
};
const getInterractionColorForButtonStatus = (baseColor, status) => {
  const interactionColorObj = interactionColor[status];
  return transformColorFromRgbToHex(alphaColorCalc(baseColor, interactionColorObj));
};

const spinner = /*#__PURE__*/keyframes(["to{transform:rotate(360deg);}"]);
const spinnerStyle = /*#__PURE__*/css(["color:transparent !important;&:before{content:'';box-sizing:border-box;position:absolute;top:50%;left:50%;width:20px;height:20px;margin-top:-10px;margin-left:-10px;border-radius:50%;border:2px solid transparent;border-top:2px solid #fff;border-right:2px solid #fff;border-left:2px solid #fff;animation:", " 0.6s linear infinite;}"], spinner);
const spinnerGreyStyle = /*#__PURE__*/css(["&:before{border-top:2px solid rgba(43,45,51,0.24);border-right:2px solid rgba(43,45,51,0.24);border-left:2px solid rgba(43,45,51,0.24);}"]);
const buttonStylePropsByVariant = {
  primary: {
    bgColor: 'blue500',
    borderColor: 'blue500',
    hoverBgColor: getInterractionColorForButtonStatus('blue500', 'hover'),
    hoverBorderColor: getInterractionColorForButtonStatus('blue500', 'hover'),
    pressedBgColor: getInterractionColorForButtonStatus('blue500', 'pressed'),
    pressedBorderColor: getInterractionColorForButtonStatus('blue500', 'pressed'),
    focusedBgColor: getInterractionColorForButtonStatus('blue500', 'focus'),
    focusedBorderColor: getInterractionColorForButtonStatus('blue500', 'focus'),
    disabledBgColor: 'blue200',
    disabledBorderColor: 'blue200',
    textColor: '#FFFFFF',
    disabledTextColor: '#FFFFFF'
  },
  secondary: {
    bgColor: '#FFFFFF',
    borderColor: 'gray400',
    hoverBgColor: getInterractionColorForButtonStatus('#FFFFFF', 'hover'),
    hoverBorderColor: 'gray400',
    pressedBgColor: getInterractionColorForButtonStatus('#FFFFFF', 'pressed'),
    pressedBorderColor: 'gray400',
    focusedBgColor: getInterractionColorForButtonStatus('#FFFFFF', 'focus'),
    focusedBorderColor: 'gray600',
    disabledBgColor: '#FFFFFF',
    disabledBorderColor: 'gray400',
    textColor: 'gray800',
    disabledTextColor: 'gray400'
  },
  link: {
    bgColor: '#FFFFFF',
    borderColor: 'rgba(0, 0, 0, 0)',
    hoverBgColor: getInterractionColorForButtonStatus('#FFFFFF', 'hover'),
    hoverBorderColor: 'gray400',
    pressedBgColor: getInterractionColorForButtonStatus('#FFFFFF', 'pressed'),
    pressedBorderColor: 'rgba(0, 0, 0, 0)',
    focusedBgColor: getInterractionColorForButtonStatus('#FFFFFF', 'focus'),
    focusedBorderColor: 'rgba(0, 0, 0, 0)',
    disabledBgColor: '#FFFFFF',
    disabledBorderColor: 'rgba(0, 0, 0, 0)',
    textColor: 'gray800',
    disabledTextColor: 'gray400'
  },
  danger: {
    bgColor: 'red500',
    borderColor: 'red500',
    hoverBgColor: getInterractionColorForButtonStatus('red500', 'hover'),
    hoverBorderColor: getInterractionColorForButtonStatus('red500', 'hover'),
    pressedBgColor: getInterractionColorForButtonStatus('red500', 'pressed'),
    pressedBorderColor: getInterractionColorForButtonStatus('blue500', 'pressed'),
    focusedBgColor: getInterractionColorForButtonStatus('red500', 'focus'),
    focusedBorderColor: getInterractionColorForButtonStatus('red500', 'focus'),
    disabledBgColor: 'red200',
    disabledBorderColor: 'red200',
    textColor: '#FFFFFF',
    disabledTextColor: '#FFFFFF'
  }
};
const buttonBoxStyleBySize = {
  small: {
    fontSize: '14px',
    lineHeight: '14px',
    padding: '10px  16px  10px 16px',
    height: '32px',
    minWidth: '80px'
  },
  medium: {
    fontSize: '14px',
    lineHeight: '14px',
    padding: '10px  16px  10px 16px',
    height: '40px',
    minWidth: '100px'
  },
  large: {
    fontSize: '16px',
    lineHeight: '22px',
    padding: '10px  16px  10px 16px',
    height: '48px',
    minWidth: '120px'
  }
};
const iconButtonStyleBySize = {
  small: {
    padding: '3px',
    height: '32px',
    minWidth: '32px',
    fontSize: 'initial',
    lineHeight: 'initial'
  },
  medium: {
    padding: '7px',
    height: '40px',
    minWidth: '40px',
    fontSize: 'initial',
    lineHeight: 'initial'
  },
  large: {
    padding: '11px',
    height: '48px',
    minWidth: '48px',
    fontSize: 'initial',
    lineHeight: 'initial'
  }
};
const Button = /*#__PURE__*/styled(Box).withConfig({
  shouldForwardProp(prop) {
    return !['size', 'htmlType', 'loading', 'icon', 'iconPosition'].includes(prop);
  }
}).attrs(() => ({
  as: 'button'
})).withConfig({
  displayName: "button-newstyles__Button",
  componentId: "sc-1rjtlrf-0"
})(["", ""], props => {
  const {
      display,
      size = 'medium',
      buttonType = 'secondary',
      loading,
      theme: propTheme,
      textColor,
      color,
      bgColor,
      backgroundColor,
      hasChildren
    } = props,
    restProps = __rest(props, ["display", "size", "buttonType", "loading", "theme", "textColor", "color", "bgColor", "backgroundColor", "hasChildren"]);
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  const buttonSize = size;
  const buttonSizeStyle = hasChildren ? buttonBoxStyleBySize[buttonSize] : iconButtonStyleBySize[buttonSize];
  const styleFromProps = Object.assign({
    textColor: textColor || color,
    bgColor: bgColor || backgroundColor
  }, restProps);
  const mergedStyle = Object.assign(Object.assign(Object.assign({}, buttonStylePropsByVariant[buttonType] || {}), buttonSizeStyle), omitBy(styleFromProps, isNil));
  return css(["display:", ";align-items:center;justify-content:center;column-gap:4px;border-radius:8px;font-weight:600;font-family:'Plus Jakarta Sans','Segoe UI',Arial,Helvetica,sans-serif;position:relative;cursor:pointer;font-size:", ";line-height:", ";height:", ";padding:", ";min-width:", ";color:", ";border:1px solid ", ";background:", ";&:hover,&.btn-hovered{background:", ";border-color:", ";}&:active,&.btn-pressed{background:", ";border-color:", ";}&:focus,&.btn-focused{background:", ";border-color:", ";}&[disabled]{cursor:not-allowed;background:", ";border-color:", ";color:", ";}", " ", ""], display || 'inline-flex', mergedStyle.fontSize, mergedStyle.lineHeight, mergedStyle.height, mergedStyle.padding, mergedStyle.minWidth, theme$1.getColor(mergedStyle.textColor), theme$1.getColor(mergedStyle.borderColor), theme$1.getColor(mergedStyle.bgColor), theme$1.getColor(mergedStyle.hoverBgColor), theme$1.getColor(mergedStyle.hoverBorderColor), theme$1.getColor(mergedStyle.pressedBgColor), theme$1.getColor(mergedStyle.pressedBorderColor), theme$1.getColor(mergedStyle.focusedBgColor), theme$1.getColor(mergedStyle.focusedBorderColor), theme$1.getColor(mergedStyle.disabledBgColor), theme$1.getColor(mergedStyle.disabledBorderColor), theme$1.getColor(mergedStyle.disabledTextColor), loading && spinnerStyle, buttonType === 'secondary' && spinnerGreyStyle);
});
const ButtonGroup$1 = /*#__PURE__*/styled(Box).attrs(props => {
  const {
    theme: propTheme,
    type = 'primary'
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return {
    theme: theme$1,
    type
  };
}).withConfig({
  displayName: "button-newstyles__ButtonGroup",
  componentId: "sc-1rjtlrf-1"
})(["display:flex;align-items:center;justify-content:flex-start;> ", "{border-radius:0;&:first-child{border-top-left-radius:8px;border-bottom-left-radius:8px;}&:last-child{border-top-right-radius:8px;border-bottom-right-radius:8px;}&:not(:last-child){border-right-color:", ";}}"], Button, ({
  type,
  theme
}) => type === 'primary' ? theme.getColor('blue600') : 'transparent');
const S$9 = {
  Button,
  ButtonGroup: ButtonGroup$1
};

const ButtonNew$1 = _a => {
  var {
      htmlType = 'button',
      children,
      icon = undefined,
      iconPosition = 'left',
      type: propType = 'secondary',
      variant
    } = _a,
    restProps = __rest(_a, ["htmlType", "children", "icon", "iconPosition", "type", "variant"]);
  const {
    size
  } = restProps;
  const type = variant || propType;
  const Icon = typeof icon === 'string' && get$1(iconByName, icon) ? get$1(iconByName, icon) : icon;
  const renderIcon = () => {
    if (typeof Icon === 'function') {
      return jsx(Icon, {
        size: size === 'large' ? 24 : 20
      });
    }
    return Icon;
  };
  return jsxs(S$9.Button, Object.assign({
    type: htmlType,
    buttonType: type,
    hasChildren: !!children
  }, restProps, {
    children: [iconPosition === 'left' && renderIcon(), children, iconPosition === 'right' && renderIcon()]
  }));
};

const ButtonGroup = props => {
  const {
      children,
      type = 'primary'
    } = props,
    restProps = __rest(props, ["children", "type"]);
  return jsx(S$9.ButtonGroup, Object.assign({
    type: type
  }, restProps, {
    children: children
  }));
};

const ButtonNew = ButtonNew$1;
ButtonNew.Group = ButtonGroup;

// REMOVE this if not needed
const defaultPropsByVariant$7 = {
  info: {
    bgColor: 'blue100',
    borderColor: 'blue300',
    icon: jsx(Info, {
      color: "blue500"
    })
  },
  warning: {
    bgColor: 'gold100',
    borderColor: 'gold300',
    icon: jsx(Warning, {
      color: "gold500"
    })
  },
  error: {
    bgColor: 'red100',
    borderColor: 'red300',
    icon: jsx(IconError, {
      color: "red500"
    })
  },
  ai: {
    bgColor: 'surfaceBackground',
    borderColor: 'purple-coral',
    icon: jsx(MagicPencil, {
      color: "purple-coral"
    })
  }
};

/**
 * Alert
 */
const Alert = props => {
  const {
      type,
      variant = type
    } = props,
    restProps = __rest(props, ["type", "variant"]);
  const defaultProps = defaultPropsByVariant$7[variant !== null && variant !== void 0 ? variant : 'info'];
  const _a = Object.assign(Object.assign({}, defaultProps), restProps),
    {
      className,
      message,
      children = message,
      icon,
      cta,
      onCtaClick,
      ctaButtonProps,
      rightSection,
      textCta,
      onTextCtaClick,
      textCtaHref,
      textCtaProps,
      rightSectionWrapperStyle = {}
    } = _a,
    styleProps = __rest(_a, ["className", "message", "children", "icon", "cta", "onCtaClick", "ctaButtonProps", "rightSection", "textCta", "onTextCtaClick", "textCtaHref", "textCtaProps", "rightSectionWrapperStyle"]);
  const _b = ctaButtonProps || {},
    {
      style: ctaButtonStyle
    } = _b,
    restCtaButtonProps = __rest(_b, ["style"]);
  return jsxs(FlexBox, Object.assign({
    role: "alert",
    width: "100%",
    paddingX: 16,
    gap: 12,
    borderRadius: "elements",
    align: "flex-start",
    className: classNames('Alert', className)
  }, styleProps, {
    children: [jsx(Box, {
      marginY: 16,
      children: icon
    }), jsxs(Typography, {
      variant: "body",
      marginY: 16,
      children: [children, textCta && jsx(Box, Object.assign({
        display: "inline-block"
      }, textCtaHref ? {
        as: 'a',
        href: textCtaHref
      } : {
        as: 'span'
      }, {
        onClick: onTextCtaClick,
        style: {
          cursor: 'pointer'
        },
        color: "textLink"
      }, textCtaProps, {
        children: textCta
      }))]
    }), rightSection && jsx(Box, {
      marginY: 16,
      style: Object.assign({
        flexShrink: 0,
        marginLeft: 'auto'
      }, rightSectionWrapperStyle),
      children: rightSection
    }), cta && jsx(ButtonNew, Object.assign({
      size: "small",
      onClick: onCtaClick
    }, restCtaButtonProps, {
      style: Object.assign({
        flexShrink: 0,
        marginLeft: 'auto',
        alignSelf: 'center'
      }, ctaButtonStyle),
      children: cta
    }))]
  }));
};

const Avatar$1 = /*#__PURE__*/styled(Box).withConfig({
  displayName: "avatarstyle__Avatar",
  componentId: "sc-12abo2p-0"
})(props => {
  return css(["position:relative;display:flex;align-items:center;justify-content:center;overflow:hidden;border-radius:50%;> img{width:100%;height:100%;object-fit:cover;}"]);
});
const S$8 = {
  Avatar: Avatar$1
};

const defaultAvatarBgColors = ['blue800', 'blue700', 'blue500', 'green800', 'green700', 'green500', 'red800', 'red700', 'red500', 'gold800', 'gold500', 'gray900', 'gray700'];
const getColorsBySeed = str => {
  const charCode = str.charCodeAt(0);
  const index = charCode % defaultAvatarBgColors.length;
  return {
    color: 'white',
    bgColor: defaultAvatarBgColors[index]
  };
};
/**
 * @param alt
 * @returns seed
 *
 * '' => ''
 * Stupid => ST
 * Sun Feng => SF
 */
const getAbbrFromString = alt => {
  // '' => ''
  if (!alt) return '';
  const fragments = alt.split(' ');
  if (fragments.length === 1) {
    // Stupid => ST
    return alt.substring(0, 2).toUpperCase();
  }
  // Sun Feng => SF
  return (fragments[0][0] + fragments[1][0]).toUpperCase();
};
const defaultPropsBySize$1 = {
  small: {
    width: 28,
    height: 28,
    titleTypographyProps: {
      fontSize: 12,
      lineHeight: 17
    }
  },
  medium: {
    width: 40,
    height: 40,
    titleTypographyProps: {
      fontSize: 14,
      lineHeight: 20
    }
  },
  large: {
    width: 60,
    height: 60,
    titleTypographyProps: {
      fontSize: 20,
      lineHeight: 28
    }
  }
};

const Avatar = props => {
  useStaticPropsGuard(props, ['getAbbrFromString', 'getColorsBySeed'], 'Avatar');
  const {
    $size = 'medium',
    $bgColor
  } = props;
  const [srcBroken, setSrcBroken] = useState(false);
  const mergedProps = defaults(Object.assign({}, props), defaultPropsBySize$1[$size]);
  const {
      src,
      alt,
      seed,
      title: propTitle,
      children,
      titleTypographyProps,
      color: propColor,
      getAbbrFromString: getAbbrFromString$1 = getAbbrFromString,
      getColorsBySeed: getColorsBySeed$1 = getColorsBySeed
    } = mergedProps,
    restProps = __rest(mergedProps, ["src", "alt", "seed", "title", "children", "titleTypographyProps", "color", "getAbbrFromString", "getColorsBySeed"]);
  const abbr = useMemo(() => {
    return getAbbrFromString$1(typeof children === 'string' ? children : alt);
  }, [children, getAbbrFromString$1, alt]);
  const {
    color,
    bgColor
  } = useMemo(() => defaults({
    color: propColor,
    bgColor: $bgColor
  }, getColorsBySeed$1(seed || abbr || 'AA')), [$bgColor, seed, abbr, propColor, getColorsBySeed$1]);
  return jsxs(S$8.Avatar, Object.assign({
    color: color,
    bgColor: bgColor
  }, restProps, {
    children: [src && jsx("img", {
      src: src,
      alt: alt,
      onLoad: /* istanbul ignore next */() => setSrcBroken(false),
      onError: () => setSrcBroken(true),
      style: {
        zIndex: 1,
        opacity: srcBroken ? 0 : 1
      }
    }), abbr ? jsx(Typography, Object.assign({
      position: "absolute",
      variant: "caption",
      fontWeight: 600,
      color: "inherit"
    }, titleTypographyProps, {
      children: abbr !== null && abbr !== void 0 ? abbr : '--'
    })) : children !== null && children !== void 0 ? children : '--']
  }));
};

const defaultPropsBySize = {
  large: {
    titleVariant: 'h3',
    subtitleVariant: 'body',
    gap: 20,
    titleGap: '4px'
  },
  medium: {
    titleVariant: 'body',
    subtitleVariant: 'caption',
    gap: 12,
    titleGap: '4px'
  },
  small: {
    titleVariant: 'caption',
    subtitleVariant: 'caption',
    gap: 8,
    titleGap: 0
  }
};
const AvatarWithLabel = props => {
  const {
    $size = 'medium'
  } = props;
  const mergedProps = defaults(Object.assign({}, props), defaultPropsBySize[$size]);
  const {
      gap,
      title,
      subtitle,
      titleGap,
      titleVariant,
      subtitleVariant,
      rootProps,
      children
    } = mergedProps,
    restProps = __rest(mergedProps, ["gap", "title", "subtitle", "titleGap", "titleVariant", "subtitleVariant", "rootProps", "children"]);
  return jsxs(FlexBox, Object.assign({
    alignItems: "center",
    gap: gap
  }, rootProps, {
    children: [jsx(Avatar, Object.assign({
      "$size": $size
    }, restProps, {
      children: title !== null && title !== void 0 ? title : '--'
    })), jsxs(FlexBox, {
      direction: "column",
      gap: titleGap,
      children: [jsx(Typography, {
        variant: titleVariant,
        fontWeight: 700,
        children: title !== null && title !== void 0 ? title : '--'
      }), jsx(Typography, {
        variant: subtitleVariant,
        fontWeight: 400,
        children: subtitle !== null && subtitle !== void 0 ? subtitle : '--'
      })]
    })]
  }));
};

const Drawer$1 = /*#__PURE__*/styled(_Drawer).withConfig({
  displayName: "drawerstyle__Drawer",
  componentId: "sc-1spes69-0"
})(props => {
  const {
    variant,
    placement
  } = props;
  return css(["", ""], variant === 'secondary' && css([".ant4-drawer-header{height:64px;}", ""], placement === 'right' && css([".ant4-drawer-header-title{display:flex;flex-direction:row-reverse;justify-content:space-between;}.ant4-drawer-close{margin-right:0;}"])));
});
const DrawerS = {
  Drawer: Drawer$1
};

// REMOVE this if not needed
const defaultPropsByVariant$6 = {
  primary: {
    width: 376,
    closable: false,
    placement: 'left'
  },
  secondary: {
    width: 350,
    drawerStyle: {
      paddingTop: 62
    },
    closable: true,
    placement: 'right',
    closeIcon: jsx(Cross, {
      color: "#000",
      "data-testid": "drawer-close-btn"
    }),
    mask: false
  }
};

/**
 * Drawer
 */
const Drawer = props => {
  const {
    variant = 'primary'
  } = props;
  const _theme = /*#__PURE__*/useTheme();
  const theme$1 = isEmpty(_theme) ? theme : _theme;
  const defaultProps = defaultPropsByVariant$6[variant];
  const defaultZIndex = variant === 'secondary' ? theme$1.zIndex.appBar - 1 : undefined;
  return jsx(DrawerS.Drawer, Object.assign({
    zIndex: defaultZIndex
  }, defaultProps, props, {
    variant: variant
  }));
};

const getTheme$1 = theme$1 => {
  return isEmpty(theme$1) ? theme : theme$1;
};
const rawMenuItemStyles = {
  default: css(["color:", ";background-color:", ";", ";"], ({
    theme,
    $color: _$color = 'textPrimary'
  }) => getTheme$1(theme).getColor(_$color), ({
    theme,
    $bgColor: _$bgColor = 'transparent'
  }) => getTheme$1(theme).getColor(_$bgColor), ({
    $fontWeight
  }) => $fontWeight && `font-weight: ${$fontWeight};`),
  hovered: css(["color:", ";background-color:", ";", ";"], ({
    theme,
    $hoverColor: _$hoverColor = 'textPrimary'
  }) => getTheme$1(theme).getColor(_$hoverColor), ({
    theme,
    $hoverBgColor: _$hoverBgColor = 'surfaceBackground'
  }) => getTheme$1(theme).getColor(_$hoverBgColor), ({
    $hoverFontWeight
  }) => $hoverFontWeight && `font-weight: ${$hoverFontWeight};`),
  selected: css(["color:", ";background-color:", ";", ";"], ({
    theme,
    $selectedColor: _$selectedColor = 'textPrimary'
  }) => getTheme$1(theme).getColor(_$selectedColor), ({
    theme,
    $selectedBgColor: _$selectedBgColor = 'transparent'
  }) => getTheme$1(theme).getColor(_$selectedBgColor), ({
    $selectedFontWeight
  }) => $selectedFontWeight && `font-weight: ${$selectedFontWeight};`)
};
const menuItemStyles = Object.assign(Object.assign({}, rawMenuItemStyles), {
  hoveredWithCssSelector: css(["&&:hover{", "}"], rawMenuItemStyles.hovered),
  selectedWithCssSelector: css(["&&.ant4-menu-item-selected{", "}"], rawMenuItemStyles.selected)
});
const Menu$1 = /*#__PURE__*/styled(_Menu).withConfig({
  displayName: "menustyle__Menu",
  componentId: "sc-1fppl71-0"
})(props => {
  const {
    $colorTheme,
    theme: propTheme,
    $collapsed,
    $width
  } = props;
  const theme = getTheme$1(propTheme);
  return css(["&&&{background-color:inherit;padding:8px 0;color:", ";background:", " !important;width:", ";border-right:none;border-radius:8px;.ant4-menu-item{margin-top:0;margin-bottom:0;}.ant4-menu-item > svg.ant4-menu-item-icon,.ant4-menu-submenu-title > svg,.ant4-menu-item > .ant4-badge.ant4-menu-item-icon > svg:first-child{width:20px;height:20px;}.ant4-menu-item > .ant4-badge.ant4-menu-item-icon{flex:none;color:inherit;}&.ant4-menu-inline .ant4-menu-item{width:100%;}&.ant4-menu-inline-collapsed{.ant4-menu-item{padding:0 calc(50% - 10px);}> .ant4-menu-item-group > .ant4-menu-item-group-list{> .ant4-menu-submenu > .ant4-menu-submenu-title,> .ant4-menu-item{padding:0 calc(50% - 10px);}}}.ant4-menu-sub{background-color:inherit;}&.ant4-dropdown-menu-root{box-shadow:0px 4px 20px 0px #00000014;}.ant4-menu-item-group-title{color:", ";padding:0;margin:20px 20px 10px 24px;font-size:12px;height:20px;line-height:20px;text-transform:uppercase;white-space:nowrap;transition:margin,width,clip-path,content-visibility,color 0.3s;", "}}"], theme.getColor($colorTheme === 'dark' ? 'textDisabled' : 'gray800'), theme.getColor($colorTheme === 'dark' ? 'gray900' : 'white'), $width ? theme.getSpacing($width) : '100%', theme.getColor('gray500'), $collapsed && css(["content-visibility:hidden;color:transparent;width:42px;background:", ";clip-path:inset(9px 0 10px);margin-left:auto;margin-right:auto;"], theme.getColor($colorTheme === 'dark' ? 'gray600' : 'gray400')));
});
const MenuItem$1 = /*#__PURE__*/styled(_Menu.Item).withConfig({
  displayName: "menustyle__MenuItem",
  componentId: "sc-1fppl71-1"
})(props => {
  const {
    theme: propTheme,
    $hovered,
    $selectedBackgroundShape,
    $itemBaseHeight = 44,
    $selectedIndicator
  } = props;
  const theme = getTheme$1(propTheme);
  return css(["&[role='menuitem']{display:flex;align-items:center;margin:0;height:", ";min-height:", ";line-height:initial;cursor:pointer;a,a:hover{color:inherit;}", " ", " ", " .ant4-menu-title-content{flex:1;width:100%;height:100%;display:flex;align-items:center;> a{width:100%;height:100%;display:flex;align-items:center;}}.ant4-menu-item-icon + .ant4-menu-title-content{margin-left:8px;}&::after{display:none;}", " ", "}&&.ant4-menu-item-active{color:inherit;background:inherit;}"], theme.getSpacing($itemBaseHeight), theme.getSpacing($itemBaseHeight), menuItemStyles.default, menuItemStyles.hoveredWithCssSelector, menuItemStyles.selectedWithCssSelector, $selectedBackgroundShape === 'chip' && 'clip-path: inset(0 12px round 6px);', $selectedIndicator !== 'background' && css(["&.ant4-menu-item-selected:hover{", "}", ""], menuItemStyles.hovered, $hovered && css(["&,&&.ant4-menu-item-selected{", "}"], menuItemStyles.hovered)));
});
const SubMenu$1 = /*#__PURE__*/styled(_Menu.SubMenu).withConfig({
  displayName: "menustyle__SubMenu",
  componentId: "sc-1fppl71-2"
})(props => {
  const {
    $hovered,
    $selectedBackgroundShape,
    $open
  } = props;
  return css(["&.ant4-menu-submenu{", " &:hover > .ant4-menu-submenu-title{", "}.ant4-menu-submenu-title{padding-right:16px;display:flex;align-items:center;margin:0;height:40px;", " ", " &::after{display:none;}}&[role='none'].ant4-menu-submenu-selected > .ant4-menu-submenu-title{", "}.ant4-menu-title-content{flex:1;margin-left:4px;}.ant4-menu-item-icon + .ant4-menu-title-content{margin-left:8px;}.ant4-menu-submenu-arrow{color:inherit;width:16px;&::before,&::after{width:7.5px;}&::before{transform:rotate(45deg) translateY(-3px);}&::after{transform:rotate(-45deg) translateY(3px);}}&.ant4-menu-submenu-inline > .ant4-menu-submenu-title > .ant4-menu-submenu-arrow{color:inherit;transform:translateY(", ");&::before{transform:rotate(", ") translateX(3px);}&::after{transform:rotate(", ") translateX(-3px);}}}&&.ant4-menu-submenu-active{color:inherit;}"], menuItemStyles.default, menuItemStyles.hovered, $hovered && menuItemStyles.hovered, $selectedBackgroundShape === 'chip' && 'clip-path: inset(0 12px round 6px);', menuItemStyles.selected, $open ? '-2px' : '2px', $open ? '45deg' : '-45deg', $open ? '-45deg' : '45deg');
});
// TODO: use our own Tooltip to replace antd's Tooltip
const IconTooltip = /*#__PURE__*/styled(_a => {
  var {
      className
    } = _a,
    restProps = __rest(_a, ["className"]);
  return jsx(_Tooltip, Object.assign({}, restProps, {
    overlayClassName: className
  }));
}).attrs({
  placement: 'right',
  arrowPointAtCenter: true,
  mouseEnterDelay: 0.3,
  mouseLeaveDelay: 0.3
}).withConfig({
  displayName: "menustyle__IconTooltip",
  componentId: "sc-1fppl71-3"
})(props => {
  const {
    theme: propTheme
  } = props;
  const theme = getTheme$1(propTheme);
  return css([".ant4-tooltip-inner{padding:8px 8px 8px 10px;line-height:17px;border-radius:8px;color:", ";background-color:", ";}.ant4-tooltip-arrow{width:15px;height:15px;}.ant4-tooltip-arrow-content{width:11.5px;height:11.5px;transform:translateX(6px) rotate(45deg);background-color:", ";}"], theme.getColor('gray300'), theme.getColor('gray900'), theme.getColor('gray900'));
});
const MenuS = {
  Menu: Menu$1,
  MenuItem: MenuItem$1,
  SubMenu: SubMenu$1,
  IconTooltip
};

const MenuContext = /*#__PURE__*/React__default.createContext({
  variant: 'dropdown',
  $colorTheme: 'light'
});
const defaultPropsByVariant$5 = {
  dropdown: {
    mode: 'vertical',
    $selectedIndicator: 'background',
    $width: 240
  },
  navigation: {
    mode: 'inline',
    $selectedIndicator: 'background',
    $itemBaseHeight: 40
  },
  select: {
    $selectedIndicator: 'check-mark',
    $width: 240
  },
  multiselect: {
    $selectedIndicator: 'checkbox',
    $width: 240
  }
};
const menuItemStyleRules = [{
  filters: {
    variant: 'dropdown'
  },
  defaultProps: {
    $color: 'textPrimary',
    $bgColor: 'white',
    $hoverColor: 'textPrimary',
    $hoverBgColor: 'gray100',
    $selectedColor: 'textPrimary',
    $selectedBgColor: 'gray200',
    $selectedFontWeight: 500
  }
}, {
  filters: {
    variant: 'navigation',
    // default to light theme and item type
    $colorTheme: 'light',
    type: 'item'
  },
  defaultProps: {
    $fontWeight: 600,
    $color: 'textSecondary',
    $bgColor: 'transparent',
    $hoverColor: 'textPrimary',
    $hoverBgColor: 'gray100',
    $selectedColor: 'textPrimary',
    $selectedBgColor: 'gray200',
    $selectedFontWeight: 700
  }
}, {
  filters: {
    variant: 'navigation',
    type: 'sub-menu',
    // default to light theme
    $colorTheme: 'light'
  },
  defaultProps: {
    $fontWeight: 600,
    $color: 'textSecondary',
    $bgColor: 'transparent',
    $hoverColor: 'textPrimary',
    $hoverBgColor: 'gray100',
    $selectedColor: 'textPrimary',
    // only difference between sub-menu and item is the selected bg color
    $selectedBgColor: 'inherit',
    $selectedFontWeight: 700
  }
}, {
  filters: {
    variant: 'navigation',
    $colorTheme: 'dark',
    // default to item type
    type: 'item'
  },
  defaultProps: {
    $fontWeight: 600,
    $color: 'gray300',
    $bgColor: 'transparent',
    $hoverColor: 'gray100',
    $hoverBgColor: 'gray800',
    $selectedColor: 'gray100',
    $selectedBgColor: 'gray700',
    $selectedFontWeight: 700
  }
}, {
  filters: {
    variant: 'navigation',
    $colorTheme: 'dark',
    type: 'sub-menu'
  },
  defaultProps: {
    $fontWeight: 600,
    $color: 'gray300',
    $bgColor: 'transparent',
    $hoverColor: 'gray100',
    $hoverBgColor: 'gray800',
    $selectedColor: 'gray100',
    // only difference between sub-menu and item is the selected bg color
    $selectedBgColor: 'inherit',
    $selectedFontWeight: 700
  }
}, {
  filters: {
    variant: 'select',
    $colorTheme: 'light'
  },
  defaultProps: {
    $color: 'textPrimary',
    $bgColor: 'white',
    $fontWeight: 300,
    $hoverColor: 'textPrimary',
    $hoverBgColor: 'surfaceBackground',
    $selectedColor: 'textPrimary',
    $selectedBgColor: 'white',
    $selectedFontWeight: 700
  }
}];
const getMenuItemStyle = ({
  variant,
  $colorTheme,
  type: _type = 'item'
}) => menuItemStyleRules.find(({
  filters
}) => filters.variant === variant && (!filters.$colorTheme || filters.$colorTheme === $colorTheme) && (!filters.type || filters.type === _type));

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty = objectDefineProperty;

var defineBuiltInAccessor$2 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

var $$f = _export;
var DESCRIPTORS$3 = descriptors;
var global$8 = global$o;
var uncurryThis$7 = functionUncurryThis;
var hasOwn$1 = hasOwnProperty_1;
var isCallable$5 = isCallable$o;
var isPrototypeOf$2 = objectIsPrototypeOf;
var toString$1 = toString$9;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$2;
var copyConstructorProperties = copyConstructorProperties$3;

var NativeSymbol = global$8.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS$3 && isCallable$5(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$1(arguments[0]);
    var result = isPrototypeOf$2(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis$7(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$7(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis$7(''.replace);
  var stringSlice = uncurryThis$7(''.slice);

  defineBuiltInAccessor$1(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn$1(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$f({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

var isObject$2 = isObject$d;
var classof$4 = classofRaw$2;
var wellKnownSymbol$7 = wellKnownSymbol$i;

var MATCH$1 = wellKnownSymbol$7('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$2(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$4(it) === 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError$9 = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError$9("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$6 = wellKnownSymbol$i;

var MATCH = wellKnownSymbol$6('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$e = _export;
var uncurryThis$6 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$7;
var toString = toString$9;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis$6(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$e({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

const size$5 = 20;
const CheckboxGroupContext = /*#__PURE__*/createContext(null);

const defaultColorsByStatus$1 = {
  default: {
    borderColor: 'borderDefault',
    bgColor: 'white',
    color: 'white'
  },
  checked: {
    borderColor: 'gray600',
    bgColor: 'gray600',
    color: 'white'
  },
  disabled: {
    borderColor: 'gray400',
    bgColor: 'gray400',
    color: 'white'
  },
  error: {
    borderColor: 'statusError',
    bgColor: 'white',
    color: 'statusError'
  }
};
const Checkbox$2 = /*#__PURE__*/styled.label.withConfig({
  displayName: "checkboxstyle__Checkbox",
  componentId: "sc-1gpyztc-0"
})(props => {
  const {
    indeterminate,
    checked,
    error,
    disabled,
    theme: propTheme
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  const status = error ? 'error' : disabled ? 'disabled' : checked || indeterminate ? 'checked' : 'default';
  const defaultColors = defaultColorsByStatus$1[status];
  return css(["display:inline-flex;align-items:flex-start;justify-content:start;gap:8px;cursor:pointer;position:relative;> input[type='checkbox']{position:absolute;inset:0;z-index:1;opacity:0;margin:0;cursor:", ";}.Checkbox-fake-input{width:", "px;height:", "px;color:", ";background:", ";border-width:1px;border-style:solid;border-color:", ";border-radius:4px;display:flex;align-items:center;justify-content:center;}", ""], disabled ? 'not-allowed' : 'pointer', size$5, size$5, theme$1.getColor(defaultColors.color), theme$1.getColor(defaultColors.bgColor), theme$1.getColor(defaultColors.borderColor), status === 'default' && css(["&:hover .Checkbox-fake-input{border-color:", ";}"], theme$1.getColor('borderActive')));
});
const CheckboxS = {
  Checkbox: Checkbox$2
};

const Checkbox$1 = props => {
  var _a, _b;
  const group = useContext(CheckboxGroupContext);
  const [stateChecked, setStateChecked] = React__default.useState(props.defaultChecked);
  const {
      defaultChecked,
      className,
      indeterminate,
      disabled,
      checked: propChecked,
      variant,
      children,
      label = children,
      labelProps,
      description,
      descriptionProps,
      value,
      name,
      id: propId = name,
      onChange: propOnChange,
      error,
      inputProps,
      wrapperProps,
      fakeInputProps
    } = props,
    restProps = __rest(props, ["defaultChecked", "className", "indeterminate", "disabled", "checked", "variant", "children", "label", "labelProps", "description", "descriptionProps", "value", "name", "id", "onChange", "error", "inputProps", "wrapperProps", "fakeInputProps"]);
  const checked = (_b = propChecked !== null && propChecked !== void 0 ? propChecked : (_a = group === null || group === void 0 ? void 0 : group.value) === null || _a === void 0 ? void 0 : _a.includes(value)) !== null && _b !== void 0 ? _b : stateChecked;
  const id = useMemo(() => propId !== null && propId !== void 0 ? propId : v4(), [propId]);
  const onChange = e => {
    var _a, _b;
    const newChecked = e.target.checked;
    const prevValues = (_a = group === null || group === void 0 ? void 0 : group.value) !== null && _a !== void 0 ? _a : [];
    const newValues = newChecked ? [...prevValues, value] : prevValues === null || prevValues === void 0 ? void 0 : prevValues.filter(item => item !== value);
    (_b = group === null || group === void 0 ? void 0 : group.onChange) === null || _b === void 0 ? void 0 : _b.call(group, newValues);
    if (propOnChange) {
      propOnChange(e);
    } else {
      setStateChecked(newChecked);
    }
  };
  return jsxs(CheckboxS.Checkbox, Object.assign({
    className: className,
    indeterminate: indeterminate,
    variant: variant,
    checked: checked,
    error: error,
    htmlFor: id,
    disabled: disabled
  }, restProps, {
    children: [jsx("input", Object.assign({
      type: "checkbox",
      disabled: disabled,
      checked: checked,
      defaultChecked: defaultChecked,
      onChange: onChange,
      name: name,
      value: value,
      id: id
    }, inputProps)), jsx(FlexBox, Object.assign({
      shrink: 0
    }, fakeInputProps, {
      className: "Checkbox-fake-input",
      children: indeterminate ? jsx(Minimize, {
        size: size$5 / 20 * 15,
        color: "inherit",
        strokeWidth: 3,
        stroke: "currentColor"
      }) : checked && jsx(Checkmark, {
        size: size$5 / 20 * 17,
        color: "inherit",
        strokeWidth: 2,
        stroke: "currentColor"
      })
    })), label && jsxs(FlexBox, Object.assign({
      direction: "column",
      gap: "4px"
    }, wrapperProps, {
      children: [jsx(Typography, Object.assign({
        variant: "body"
      }, labelProps, {
        children: label
      })), description && jsx(Typography, Object.assign({
        color: disabled ? 'textDisabled' : 'textSecondary',
        fontSize: 14,
        lineHeight: 20,
        fontWeight: 400
      }, descriptionProps, {
        children: description
      }))]
    }))]
  }));
};

const CheckboxGroup = props => {
  var _a;
  const [stateValue, setStateValue] = useState((_a = props.defaultValue) !== null && _a !== void 0 ? _a : []);
  const {
      defaultValue,
      flexDirection,
      gap,
      options: propOptions,
      name,
      value = stateValue,
      disabled,
      onChange: propOnChange,
      children
    } = props,
    restProps = __rest(props, ["defaultValue", "flexDirection", "gap", "options", "name", "value", "disabled", "onChange", "children"]);
  const options = propOptions === null || propOptions === void 0 ? void 0 : propOptions.map(option => typeof option === 'object' ? option : {
    label: option,
    value: option
  });
  const onChange = val => {
    propOnChange === null || propOnChange === void 0 ? void 0 : propOnChange(val);
    setStateValue(val);
  };
  return jsx(FlexBox, Object.assign({
    gap: "12px"
  }, restProps, {
    children: jsx(CheckboxGroupContext.Provider, {
      value: {
        onChange,
        value,
        disabled,
        name,
        defaultValue
      },
      children: children !== null && children !== void 0 ? children : options === null || options === void 0 ? void 0 : options.map((option, index) => {
        var _a;
        return jsx(Checkbox$1, Object.assign({}, option), (_a = option.id) !== null && _a !== void 0 ? _a : index);
      })
    })
  }));
};

const Checkbox = Checkbox$1;
Checkbox.Group = CheckboxGroup;

const MenuItem = props => {
  var _a;
  const menuContext = useContext(MenuContext);
  const {
    $collapsed,
    onMenuItemClick,
    selectedKeys,
    $selectedIndicator,
    $selectedBackgroundShape,
    $itemBaseHeight = 44,
    renderLabel: contextRenderLabel = identity
  } = menuContext;
  const menuItemRule = getMenuItemStyle(Object.assign(Object.assign({}, menuContext), {
    type: props.parentType === 'submenu' ? 'sub-menu-item' : 'item'
  }));
  const mergedProps = useMemo(() => {
    if (!menuItemRule) return props;
    return defaults(Object.assign({}, props), menuItemRule.defaultProps);
  }, [menuItemRule, props]);
  const {
      item,
      label,
      description,
      onClick: propOnClick
    } = mergedProps,
    restProps = __rest(mergedProps, ["item", "label", "description", "onClick"]);
  const {
    renderLabel = contextRenderLabel,
    badge,
    collapsedBadge = badge
  } = item;
  const onClick = useCallback(e => {
    propOnClick === null || propOnClick === void 0 ? void 0 : propOnClick(e);
    onMenuItemClick === null || onMenuItemClick === void 0 ? void 0 : onMenuItemClick(e);
  }, [propOnClick, onMenuItemClick]);
  const $selected = (_a = restProps.$selected) !== null && _a !== void 0 ? _a : selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.includes(item.index);
  return jsx(ConditionalRenderer, {
    condition: $collapsed,
    wrapper: children => jsx(MenuS.IconTooltip, {
      title: label,
      align: {
        offset: [8]
      },
      children: children
    }),
    children: jsx(MenuS.MenuItem, Object.assign({
      "$itemBaseHeight": description ? $itemBaseHeight + 21 : $itemBaseHeight,
      "$selectedIndicator": $selectedIndicator,
      "$selectedBackgroundShape": $selectedBackgroundShape
    }, restProps, {
      "$selected": $selected,
      onClick: onClick,
      "data-testid": `menu-item-${item.index}`,
      icon: $selectedIndicator === 'checkbox' ? jsx(FlexBox, {
        height: 20,
        alignItems: "center",
        children: jsx(Checkbox, {
          checked: $selected === true,
          indeterminate: $selected === 'partial'
        })
      }) : jsx(ConditionalRenderer, {
        condition: $collapsed && !!collapsedBadge,
        wrapper: children => jsx(_Badge, {
          className: "ant4-menu-item-icon",
          dot: true,
          count: collapsedBadge,
          offset: [4, 16],
          children: children
        }),
        children: restProps.icon
      }),
      title: null,
      children: renderLabel(jsx(ConditionalRenderer, {
        condition: !!description,
        wrapper: children => jsxs(FlexBox, {
          width: "100%",
          flexDirection: "column",
          gap: "4px",
          children: [children, typeof description === 'string' ? jsx(Typography, {
            variant: "caption",
            color: "textSecondary",
            ellipsis: 1,
            children: description
          }) : description]
        }),
        children: jsx(ConditionalRenderer, {
          condition: $selected && $selectedIndicator === 'check-mark' || !!badge,
          wrapper: children => jsxs(FlexBox, {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [children, badge !== null && badge !== void 0 ? badge : jsx(Checkmark, {})]
          }),
          children: jsx(Typography, {
            variant: "body",
            color: "inherit",
            fontWeight: "inherit",
            children: label
          })
        })
      }), item)
    }))
  });
};

const ItemGroup = props => {
  const {
      item,
      title
    } = props,
    restProps = __rest(props, ["item", "title"]);
  const {
    hideIfNoChildrenRendered
  } = item;
  const [hideWhenNoChildren, setHideWhenNoChildren] = React__default.useState(false);
  const titleRef = React__default.useRef(null);
  const titleElement = titleRef.current;
  useLayoutEffect(() => {
    if (!hideIfNoChildrenRendered) return;
    const checkChildren = () => {
      var _a;
      if (!titleRef.current) return;
      const itemGroupElement = (_a = titleRef.current.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
      if (!itemGroupElement) return;
      const childrenItem = itemGroupElement.querySelector('li.ant4-menu-item');
      setHideWhenNoChildren(!childrenItem);
    };
    checkChildren();
    const interval = setInterval(checkChildren, 1000);
    return () => clearInterval(interval);
  }, [hideIfNoChildrenRendered, titleElement]);
  return jsx(_Menu.ItemGroup, Object.assign({
    style: {
      display: hideWhenNoChildren ? 'none' : 'block'
    },
    title: typeof title === 'string' ? jsx(Typography, {
      ref: titleRef,
      variant: "caption",
      color: "gray500",
      letterSpacing: 0.6,
      fontWeight: 600,
      children: title
    }) : jsx("span", {
      ref: titleRef,
      children: title
    })
  }, restProps, {
    "data-testid": `item-group-${item.index}`
  }));
};

const SubMenu = props => {
  var _a;
  const menuContext = useContext(MenuContext);
  const {
    $collapsed,
    onSubMenuTitleClick,
    debouncedCollapsed,
    openKeys,
    $selectedBackgroundShape,
    $itemBaseHeight
  } = menuContext;
  const menuItemRule = getMenuItemStyle(Object.assign(Object.assign({}, menuContext), {
    type: 'sub-menu'
  }));
  const mergedProps = useMemo(() => {
    if (!menuItemRule) return props;
    return defaults(Object.assign({}, props), menuItemRule.defaultProps);
  }, [menuItemRule, props]);
  const {
      item,
      label,
      title,
      children
    } = mergedProps,
    restProps = __rest(mergedProps, ["item", "label", "title", "children"]);
  const $open = (_a = restProps.$open) !== null && _a !== void 0 ? _a : openKeys === null || openKeys === void 0 ? void 0 : openKeys.includes(item.index);
  return jsx(MenuS.SubMenu, Object.assign({
    "$itemBaseHeight": $itemBaseHeight,
    "$selectedBackgroundShape": $selectedBackgroundShape
  }, restProps, {
    "$open": $open,
    title: !$collapsed && (typeof title === 'string' ? jsx(Typography, {
      variant: "body",
      color: "inherit",
      fontWeight: "inherit",
      children: title
    }) : title),
    icon: $collapsed ? jsx(MenuS.IconTooltip, {
      title: title,
      align: {
        offset: [32]
      },
      children: item.icon
    }) : item.icon,
    onTitleClick: onSubMenuTitleClick,
    "data-testid": `submenu-${item.index}`,
    children: !$collapsed &&
    // Check debounced collapsed state to prevent submenu from flickering when expanding
    !debouncedCollapsed && children
  }));
};

const Divider = () => {
  return jsx(Box, {
    borderBottom: 1,
    borderColor: "gray300",
    my: "4px"
  });
};

const MenuItemOrGroupOrSubMenu = item => {
  const {
    renderItem: contextRenderItem = identity,
    omitPropKeys
  } = useContext(MenuContext);
  const {
      children: itemChildren,
      label,
      type,
      renderItem = contextRenderItem
    } = item,
    restProps = __rest(item, ["children", "label", "type", "renderItem"]);
  const passThroughProps = omit(restProps, omitPropKeys !== null && omitPropKeys !== void 0 ? omitPropKeys : []);
  const internalRenderItem = () => {
    if (type === 'divider') {
      return jsx(Divider, {
        item: item
      }, item.index);
    }
    if (itemChildren === null || itemChildren === void 0 ? void 0 : itemChildren.length) {
      const parentType = type !== null && type !== void 0 ? type : 'submenu';
      return /*#__PURE__*/React__default.createElement(parentType === 'group' ? ItemGroup : SubMenu, Object.assign(Object.assign({
        item,
        key: item.index
      }, passThroughProps), {
        title: label
      }), itemChildren === null || itemChildren === void 0 ? void 0 : itemChildren.map(item => (/*#__PURE__*/createElement$2(MenuItemOrGroupOrSubMenu, Object.assign({}, item, {
        parentType: parentType,
        key: item.index
      })))));
    }
    return jsx(MenuItem, Object.assign({
      item: item
    }, passThroughProps, {
      label: label
    }), item.index);
  };
  const renderedItem = internalRenderItem();
  return renderItem(renderedItem, item) || null;
};
/**
 * Menu
 */
const Menu = props => {
  const {
    variant = 'dropdown',
    defaultOpenKeys,
    defaultSelectedKeys
  } = props;
  const [stateSelectedKeys, setSelectedKeys] = React__default.useState(defaultSelectedKeys !== null && defaultSelectedKeys !== void 0 ? defaultSelectedKeys : []);
  const [stateOpenKeys, setOpenKeys] = React__default.useState(defaultOpenKeys !== null && defaultOpenKeys !== void 0 ? defaultOpenKeys : []);
  const mergedProps = useMemo(() => {
    const uncontrolledProps = {
      selectedKeys: stateSelectedKeys,
      openKeys: stateOpenKeys,
      onOpenChange: setOpenKeys,
      onSelect: params => setSelectedKeys(params.selectedKeys),
      onDeselect: params => setSelectedKeys(difference$1(stateSelectedKeys, params.selectedKeys))
    };
    return defaults(Object.assign({}, props), defaultPropsByVariant$5[variant], uncontrolledProps);
  }, [props, stateOpenKeys, stateSelectedKeys, variant]);
  const {
      items,
      children,
      renderItem,
      renderLabel,
      onCollapseChange,
      openKeys,
      onOpenChange,
      $collapsed,
      onMenuItemClick,
      omitPropKeys: propOmitPropKeys
    } = mergedProps,
    restProps = __rest(mergedProps, ["items", "children", "renderItem", "renderLabel", "onCollapseChange", "openKeys", "onOpenChange", "$collapsed", "onMenuItemClick", "omitPropKeys"]);
  const omitPropKeys = useMemo(() => union$1(propOmitPropKeys, ['badge', 'collapsedBadge', 'renderLabel', 'renderItem', 'parentType', 'hideIfNoChildrenRendered']), [propOmitPropKeys]);
  const onSubMenuTitleClick = useCallback(params => {
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(union$1(openKeys, [params.key]));
    onCollapseChange === null || onCollapseChange === void 0 ? void 0 : onCollapseChange(false);
  }, [openKeys, onOpenChange, onCollapseChange]);
  // Debounce collapsed state to prevent menu from flickering when expanding
  const debouncedCollapsed = useDebounce($collapsed, {
    wait: 500
  });
  const contextValue = useMemo(() => {
    var _a, _b, _c, _d, _e;
    return Object.assign(Object.assign({}, mergedProps), {
      renderItem: (_a = mergedProps.renderItem) !== null && _a !== void 0 ? _a : identity,
      renderLabel: (_b = mergedProps.renderLabel) !== null && _b !== void 0 ? _b : identity,
      variant,
      $colorTheme: (_c = mergedProps.$colorTheme) !== null && _c !== void 0 ? _c : 'light',
      selectedKeys: (_d = mergedProps.selectedKeys) !== null && _d !== void 0 ? _d : [],
      openKeys: (_e = mergedProps.openKeys) !== null && _e !== void 0 ? _e : [],
      omitPropKeys,
      debouncedCollapsed,
      onSubMenuTitleClick
    });
  }, [variant, mergedProps, onSubMenuTitleClick, debouncedCollapsed, omitPropKeys]);
  if (!(items === null || items === void 0 ? void 0 : items.length) && !children) {
    throw new Error('[Menu] must provide either items or children');
  }
  if (!(items === null || items === void 0 ? void 0 : items.length)) {
    return jsx(Menu, Object.assign({}, props));
  }
  return jsx(MenuContext.Provider, {
    value: contextValue,
    children: jsx(MenuS.Menu, Object.assign({
      openKeys: openKeys,
      onOpenChange: onOpenChange,
      "$collapsed": $collapsed
    }, restProps, {
      children: items.map(item => (/*#__PURE__*/createElement$2(MenuItemOrGroupOrSubMenu, Object.assign({}, item, {
        key: item.index
      }))))
    }))
  });
};
Menu.Item = MenuItem;
/** Must use a tag to expand the clickable area automatically. */
Menu.ItemLabel = props =>
// eslint-disable-next-line jsx-a11y/anchor-has-content
jsx("a", Object.assign({}, props));
Menu.ItemGroup = ItemGroup;
Menu.SubMenu = SubMenu;
Menu.Divider = Divider;

/**
 * Dropdown, children is the trigger to dropdown, overlay or menu as the popped-up content
 */
const Dropdown = props => {
  var _a;
  const {
      menu,
      overlay,
      children
    } = props,
    restProps = __rest(props, ["menu", "overlay", "children"]);
  if (!overlay && !((_a = menu === null || menu === void 0 ? void 0 : menu.items) === null || _a === void 0 ? void 0 : _a.length)) {
    throw new Error('[Dropdown] must provide either overlay or menu');
  }
  if (!children || !React__default.Children.only(children)) {
    throw new Error('[Dropdown] must have only one child as the trigger');
  }
  return jsx(_Dropdown, Object.assign({
    overlay: overlay !== null && overlay !== void 0 ? overlay : jsx(Menu, Object.assign({
      variant: "dropdown"
    }, menu))
  }, restProps, {
    children: children
  }));
};

const FormItem$1 = /*#__PURE__*/styled(FlexBox).attrs({
  column: true,
  width: '100%'
}).withConfig({
  displayName: "form-itemstyled__FormItem",
  componentId: "sc-fb189i-0"
})([""]);
const S$7 = {
  FormItem: FormItem$1
};

/**
 * FormItem
 *
 * This is an unstable component. It's only used in login route for now
 */
const FormItem = props => {
  const {
      error,
      id,
      label,
      children,
      required,
      labelProps,
      helpTextProps
    } = props,
    restProps = __rest(props, ["error", "id", "label", "children", "required", "labelProps", "helpTextProps"]);
  return jsxs(S$7.FormItem, Object.assign({
    mb: error ? 0 : 24
  }, restProps, {
    children: [label && jsxs(Typography, Object.assign({
      mb: "8px",
      variant: "body",
      htmlFor: id,
      color: error ? 'textError' : 'textPrimary'
    }, labelProps, {
      children: [label, required != null && jsx(Typography, {
        color: "textSecondary",
        ml: "1em",
        children: required ? 'required' : 'optional'
      })]
    })), children && /*#__PURE__*/React__default.cloneElement(children, {
      id,
      required
    }), error && jsx(Typography, Object.assign({
      mt: "4px",
      variant: "body",
      color: "textError"
    }, helpTextProps, {
      children: error === null || error === void 0 ? void 0 : error.message
    }))]
  }));
};

var classof$3 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$1 = Array.isArray || function isArray(argument) {
  return classof$3(argument) === 'Array';
};

var DESCRIPTORS$2 = descriptors;
var isArray = isArray$1;

var $TypeError$8 = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS$2 && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor$1(O, 'length').writable) {
    throw new $TypeError$8('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var $TypeError$7 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$1 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$7('Maximum allowed index exceeded');
  return it;
};

var $$d = _export;
var toObject = toObject$5;
var lengthOfArrayLike$1 = lengthOfArrayLike$3;
var setArrayLength = arraySetLength;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$1;
var fails$3 = fails$o;

var INCORRECT_TO_LENGTH = fails$3(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$$d({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike$1(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});

const gridTemplateCssFromProps = (template, theme) => {
  if (Array.isArray(template)) {
    return template.map(theme.getSpacing).join(' ');
  }
  if (typeof template !== 'object') {
    return template;
  }
  const {
    trackSizes,
    lineNames = [],
    repeat
  } = template;
  const trackSizesCss = trackSizes.map(trackSize => trackSize ? theme.getSpacing(trackSize) : 'auto');
  const lineNamesCss = lineNames.map(lineName => {
    if (isEmpty(lineName)) return '';
    if (Array.isArray(lineName)) {
      return `[${lineName.join(' ')}]`;
    }
    return `[${lineName}]`;
  });
  const cssFragment = [];
  for (let i = 0; i < Math.max(trackSizesCss.length, lineNamesCss.length); i += 1) {
    if (lineNamesCss[i]) {
      cssFragment.push(lineNamesCss[i]);
    }
    if (trackSizesCss[i]) {
      cssFragment.push(trackSizesCss[i]);
    }
  }
  const cssStr = cssFragment.join(' ');
  if (repeat) {
    return `repeat(${repeat},${cssStr})`;
  }
  return cssStr;
};
const Grid = /*#__PURE__*/styled(Box).attrs({
  display: 'grid'
}).withConfig({
  displayName: "grid__Grid",
  componentId: "sc-1ubazkv-0"
})(props => {
  var _a, _b, _c, _d, _e;
  const {
    theme: propTheme,
    templateColumns,
    templateRows,
    areas,
    area,
    column = [],
    columnStart = column[0],
    columnEnd = (_a = column[1]) !== null && _a !== void 0 ? _a : column[0],
    row = [],
    rowStart = row[0],
    rowEnd = (_b = row[1]) !== null && _b !== void 0 ? _b : row[0],
    placeItems = [],
    justifyItems = placeItems[0],
    alignItems = (_c = placeItems[1]) !== null && _c !== void 0 ? _c : placeItems[0],
    placeContent = [],
    justifyContent = placeContent[0],
    alignContent = (_d = placeContent[1]) !== null && _d !== void 0 ? _d : placeContent[0],
    placeSelf = [],
    justifySelf = placeSelf[0],
    alignSelf = (_e = placeSelf[1]) !== null && _e !== void 0 ? _e : placeSelf[0],
    gap,
    columnGap = gap,
    rowGap = gap,
    autoFlow,
    autoColumns,
    autoRows
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return css(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], templateColumns && mapResponsiveStyleProp(templateColumns, v => `
        grid-template-columns: ${gridTemplateCssFromProps(v, theme$1)};
      `), templateRows && mapResponsiveStyleProp(templateRows, v => `
        grid-template-rows: ${gridTemplateCssFromProps(v, theme$1)};
      `), areas && `grid-template-areas: ${areas.map(area => `"${area.join(' ')}"`).join('\n')};`, area && `grid-area: ${area};`, columnStart != null && `grid-column-start: ${columnStart};`, columnEnd != null && `grid-column-end: ${columnEnd};`, rowStart != null && `grid-row-start: ${rowStart};`, rowEnd != null && `grid-row-end: ${rowEnd};`, justifyItems && mapResponsiveStyleProp(justifyItems, v => `justify-items: ${v};`), alignItems && mapResponsiveStyleProp(alignItems, v => `align-items: ${v};`), justifyContent && mapResponsiveStyleProp(justifyContent, v => `justify-content: ${v};`), alignContent && mapResponsiveStyleProp(alignContent, v => `align-content: ${v};`), justifySelf && mapResponsiveStyleProp(justifySelf, v => `justify-self: ${v};`), alignSelf && mapResponsiveStyleProp(alignSelf, v => `align-self: ${v};`), columnGap && mapResponsiveStyleProp(columnGap, v => `column-gap: ${theme$1.getSpacing(v)};`), rowGap && mapResponsiveStyleProp(rowGap, v => `row-gap: ${theme$1.getSpacing(v)};`), autoFlow && `grid-auto-flow: ${autoFlow};`, autoColumns && `grid-auto-columns: ${theme$1.getSpacing(autoColumns)};`, autoRows && `grid-auto-rows: ${theme$1.getSpacing(autoRows)};`);
});

var global$7 = global$o;
var classof$2 = classofRaw$2;

var engineIsNode = classof$2(global$7.process) === 'process';

var getBuiltIn$4 = getBuiltIn$9;
var defineBuiltInAccessor = defineBuiltInAccessor$2;
var wellKnownSymbol$5 = wellKnownSymbol$i;
var DESCRIPTORS$1 = descriptors;

var SPECIES$2 = wellKnownSymbol$5('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$4(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$1 && Constructor && !Constructor[SPECIES$2]) {
    defineBuiltInAccessor(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf$1 = objectIsPrototypeOf;

var $TypeError$6 = TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf$1(Prototype, it)) return it;
  throw new $TypeError$6('Incorrect invocation');
};

var uncurryThis$5 = functionUncurryThis;
var fails$2 = fails$o;
var isCallable$4 = isCallable$o;
var classof$1 = classof$7;
var getBuiltIn$3 = getBuiltIn$9;
var inspectSource$1 = inspectSource$3;

var noop = function () { /* empty */ };
var construct = getBuiltIn$3('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$5(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$4(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$4(argument)) return false;
  switch (classof$1(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$2(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor = isConstructor$1;
var tryToString$2 = tryToString$4;

var $TypeError$5 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError$5(tryToString$2(argument) + ' is not a constructor');
};

var anObject$5 = anObject$f;
var aConstructor = aConstructor$1;
var isNullOrUndefined$1 = isNullOrUndefined$5;
var wellKnownSymbol$4 = wellKnownSymbol$i;

var SPECIES$1 = wellKnownSymbol$4('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$5(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$1(S = anObject$5(C)[SPECIES$1]) ? defaultConstructor : aConstructor(S);
};

var classofRaw = classofRaw$2;
var uncurryThis$4 = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$4(fn);
};

var uncurryThis$3 = functionUncurryThisClause;
var aCallable$6 = aCallable$9;
var NATIVE_BIND = functionBindNative;

var bind$4 = uncurryThis$3(uncurryThis$3.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$6(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$4(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var uncurryThis$2 = functionUncurryThis;

var arraySlice$1 = uncurryThis$2([].slice);

var $TypeError$4 = TypeError;

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw new $TypeError$4('Not enough arguments');
  return passed;
};

var userAgent$2 = engineUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var global$6 = global$o;
var apply = functionApply;
var bind$3 = functionBindContext;
var isCallable$3 = isCallable$o;
var hasOwn = hasOwnProperty_1;
var fails$1 = fails$o;
var html = html$2;
var arraySlice = arraySlice$1;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set = global$6.setImmediate;
var clear = global$6.clearImmediate;
var process$2 = global$6.process;
var Dispatch = global$6.Dispatch;
var Function$1 = global$6.Function;
var MessageChannel = global$6.MessageChannel;
var String$1 = global$6.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails$1(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$6.location;
});

var run = function (id) {
  if (hasOwn(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global$6.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$3(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue$2[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$3(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$6.addEventListener &&
    isCallable$3(global$6.postMessage) &&
    !global$6.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails$1(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global$6.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var global$5 = global$o;
var DESCRIPTORS = descriptors;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn$1 = function (name) {
  if (!DESCRIPTORS) return global$5[name];
  var descriptor = getOwnPropertyDescriptor(global$5, name);
  return descriptor && descriptor.value;
};

var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};

Queue$2.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue$2;

var userAgent$1 = engineUserAgent;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && typeof Pebble != 'undefined';

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$4 = global$o;
var safeGetBuiltIn = safeGetBuiltIn$1;
var bind$2 = functionBindContext;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver = global$4.MutationObserver || global$4.WebKitMutationObserver;
var document$2 = global$4.document;
var process$1 = global$4.process;
var Promise$1 = global$4.Promise;
var microtask$1 = safeGetBuiltIn('queueMicrotask');
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$1) {
  var queue = new Queue$1();

  var flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$1.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$2(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$2(macrotask, global$4);
    notify$1 = function () {
      macrotask(flush);
    };
  }

  microtask$1 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}

var microtask_1 = microtask$1;

var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var global$3 = global$o;

var promiseNativeConstructor = global$3.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$1 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1
  && typeof window == 'object'
  && typeof document == 'object';

var global$2 = global$o;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$2 = isCallable$o;
var isForced = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$3 = wellKnownSymbol$i;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES = wellKnownSymbol$3('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$2(global$2.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$5 = aCallable$9;

var $TypeError$3 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError$3('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$5(resolve);
  this.reject = aCallable$5(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$c = _export;
var IS_NODE = engineIsNode;
var global$1 = global$o;
var call$7 = functionCall;
var defineBuiltIn$1 = defineBuiltIn$7;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$4;
var setSpecies = setSpecies$1;
var aCallable$4 = aCallable$9;
var isCallable$1 = isCallable$o;
var isObject$1 = isObject$d;
var anInstance = anInstance$1;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$1 = global$1.TypeError;
var document$1 = global$1.document;
var process = global$1.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$1.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable$1 = function (it) {
  var then;
  return isObject$1(it) && isCallable$1(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable$1(result)) {
        call$7(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$1['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$7(task, global$1, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$7(task, global$1, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$1 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError$1("Promise can't be resolved itself");
    var then = isThenable$1(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$7(then, value,
            bind$1(internalResolve, wrapper, state),
            bind$1(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable$4(executor);
    call$7(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$1(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$1(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$1(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve, state);
    this.reject = bind$1(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$1(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$1(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$7(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$c({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var wellKnownSymbol$2 = wellKnownSymbol$i;
var Iterators$1 = iterators;

var ITERATOR$2 = wellKnownSymbol$2('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$2] === it);
};

var classof = classof$7;
var getMethod$1 = getMethod$4;
var isNullOrUndefined = isNullOrUndefined$5;
var Iterators = iterators;
var wellKnownSymbol$1 = wellKnownSymbol$i;

var ITERATOR$1 = wellKnownSymbol$1('iterator');

var getIteratorMethod$2 = function (it) {
  if (!isNullOrUndefined(it)) return getMethod$1(it, ITERATOR$1)
    || getMethod$1(it, '@@iterator')
    || Iterators[classof(it)];
};

var call$6 = functionCall;
var aCallable$3 = aCallable$9;
var anObject$4 = anObject$f;
var tryToString$1 = tryToString$4;
var getIteratorMethod$1 = getIteratorMethod$2;

var $TypeError$2 = TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$3(iteratorMethod)) return anObject$4(call$6(iteratorMethod, argument));
  throw new $TypeError$2(tryToString$1(argument) + ' is not iterable');
};

var call$5 = functionCall;
var anObject$3 = anObject$f;
var getMethod = getMethod$4;

var iteratorClose$3 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$3(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$5(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$3(innerResult);
  return value;
};

var bind = functionBindContext;
var call$4 = functionCall;
var anObject$2 = anObject$f;
var tryToString = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike = lengthOfArrayLike$3;
var isPrototypeOf = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose$2 = iteratorClose$3;

var $TypeError$1 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$4 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose$2(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$2(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError$1(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$4(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$2(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol = wellKnownSymbol$i;

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$b = _export;
var call$3 = functionCall;
var aCallable$2 = aCallable$9;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$3 = iterate$4;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$b({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$2(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$3(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$3($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$a = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$2 = getBuiltIn$9;
var isCallable = isCallable$o;
var defineBuiltIn = defineBuiltIn$7;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$a({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn$2('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$9 = _export;
var call$2 = functionCall;
var aCallable$1 = aCallable$9;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate$2 = iterate$4;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$9({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      iterate$2(iterable, function (promise) {
        call$2($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$8 = _export;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$8({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});

var anObject$1 = anObject$f;
var isObject = isObject$d;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$1(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$7 = _export;
var getBuiltIn$1 = getBuiltIn$9;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn$1('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$7({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

const fixedColumnBasis = 68;
const defaultPropsByVariant$4 = {
  app: {
    width: '100%',
    bgColor: 'gray100',
    fixedColumnBasis: {
      ps: 0,
      ds: 68
    },
    minHeight: '100vh',
    fixedColumnProps: {
      position: 'sticky',
      top: 0,
      maxHeight: '100vh',
      zIndex: 'drawer'
    },
    flexColumnProps: {
      alignItems: 'stretch'
    }
  },
  sidebar: {
    width: '100%',
    height: '100vh',
    fixedColumnBasis: 62,
    innerScroll: true,
    fixedColumnProps: {
      position: 'sticky',
      top: 0,
      maxHeight: '100vh',
      backgroundColor: 'white',
      zIndex: 'appBar',
      shrink: 0
    },
    flexColumnProps: {
      flexDirection: 'column'
    },
    minHeight: '100vh'
  },
  page: {
    width: '100%',
    flexDirection: 'column',
    fixedColumnBasis: 62,
    fixedColumnProps: {
      position: 'sticky',
      top: 0,
      maxHeight: '100vh',
      backgroundColor: 'white',
      zIndex: 'appBar'
    },
    minHeight: '100vh'
  },
  layout1: {
    width: '100%',
    maxWidth: breakpointByName['desktopLarge'].width - fixedColumnBasis,
    marginX: 'auto',
    paddingExceptLeft: {
      ps: 20,
      ds: 32
    },
    paddingLeft: {
      ps: 20,
      ds: 40
    },
    gap: {
      ds: 20
    },
    fixedColumnBasis: {
      ps: 0,
      ds: 340
    },
    fixedColumnProps: {
      position: 'sticky',
      top: 100,
      maxHeight: 'calc(100vh - 132px)',
      alignSelf: 'flex-start',
      style: {
        overflowY: 'auto'
      }
    }
  },
  layout2: {
    width: '100%',
    maxWidth: breakpointByName['desktopLarge'].width - fixedColumnBasis,
    marginX: 'auto',
    paddingExceptLeft: {
      ps: 20,
      ds: 32
    },
    paddingLeft: {
      ps: 20,
      ds: 40
    },
    showFixedColumn: false
  },
  layout3: {
    width: '100%',
    maxWidth: breakpointByName['desktopLarge'].width,
    marginX: 'auto',
    alignItems: 'flex-start',
    paddingExceptLeft: {
      ps: 20,
      ds: 40
    },
    paddingLeft: {
      ps: 20,
      ds: 40
    },
    gap: {
      ds: 20
    },
    fixedColumnBasis: {
      ps: 0,
      ds: 260
    },
    fixedColumnProps: {
      position: 'sticky',
      top: 108,
      maxHeight: 'calc(100vh - 148px)',
      alignSelf: 'flex-start',
      style: {
        overflowY: 'auto'
      }
    }
  }
};

const S$6 = {
  Layout: styled(FlexBox).withConfig({
    displayName: "layout__Layout",
    componentId: "sc-1jtn3lk-0"
  })(props => {
    const {
      innerScroll
    } = props;
    return css(["", ""], innerScroll && 'overflow: hidden auto;');
  }),
  FixedColumn: styled(FlexBox).withConfig({
    displayName: "layout__FixedColumn",
    componentId: "sc-1jtn3lk-1"
  })(props => {
    return css([""]);
  })
};
const Layout = props => {
  const variant = props.variant || 'layout1';
  const defaultProps = defaultPropsByVariant$4[variant];
  const mergedProps = defaults(Object.assign({}, props), defaultProps);
  const {
      children: childOrChildren,
      showFixedColumn = true,
      fixedColumnBasis,
      fixedColumnProps,
      flexColumnProps
    } = mergedProps,
    restProps = __rest(mergedProps, ["children", "showFixedColumn", "fixedColumnBasis", "fixedColumnProps", "flexColumnProps"]);
  const children = React__default.Children.toArray(childOrChildren);
  const [first, second = first] = children;
  return jsxs(S$6.Layout, Object.assign({
    bgColor: "gray100",
    variant: variant
  }, restProps, {
    children: [showFixedColumn && children.length > 1 && jsx(FlexBox, Object.assign({
      display: "block",
      basis: fixedColumnBasis,
      position: "sticky"
    }, fixedColumnProps, {
      children: first
    })), jsx(FlexBox, Object.assign({
      flex: 1
    }, flexColumnProps, {
      children: second
    }))]
  }));
};

const getTheme = theme$1 => {
  return isEmpty(theme$1) ? theme : theme$1;
};
const LeftNavigation$1 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "left-navigationstyle__LeftNavigation",
  componentId: "sc-1k15u2t-0"
})(props => {
  const {
    colorTheme,
    theme: propTheme,
    collapsed
  } = props;
  const theme = getTheme(propTheme);
  return css(["flex-direction:column;position:relative;width:", "px;transition:all 0.2s ease-in-out;background-color:", ";> *{color:inherit;background-color:inherit;border-right:1px solid ", ";}box-shadow:0px 1px 1px 0px rgba(0,0,0,0.2);.ant4-menu-root.LeftNavigation-main-menu{padding-top:20px;flex:1;}"], collapsed ? 68 : 240, theme.getColor(colorTheme === 'dark' ? 'gray900' : 'white'), theme.getColor(colorTheme === 'dark' ? 'gray900' : 'gray400'));
});
const HeaderLogoBanner$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "left-navigationstyle__HeaderLogoBanner",
  componentId: "sc-1k15u2t-1"
})(props => {
  const {
    collapsed,
    colorTheme,
    theme: propTheme
  } = props;
  const theme = getTheme(propTheme);
  return css(["color:inherit;display:flex;justify-content:", ";align-items:center;gap:8px;padding:0 16px;height:100%;border-bottom:1px solid ", ";.LeftNavigation-collapse-button{> svg{transition:all 0.3s ease-in;}&.btn-hovered-enter-active > svg{transition:all 0.05s ease-out;transform:translateX(", ");}}"], collapsed ? 'center' : 'space-between', colorTheme === 'dark' ? theme.getColor('gray800') : theme.getColor('gray300'), collapsed ? '5px' : '-5px');
});
const FooterButtonBanner = /*#__PURE__*/styled.div.withConfig({
  displayName: "left-navigationstyle__FooterButtonBanner",
  componentId: "sc-1k15u2t-2"
})(props => {
  const {
    colorTheme,
    theme: propTheme
  } = props;
  const theme = getTheme(propTheme);
  return css(["display:flex;align-items:center;position:sticky;bottom:0;left:0;right:0;height:62px;overflow:hidden;background-color:inherit;color:inherit;border-top:1px solid ", ";> .ant4-menu-root{padding-top:0 !important;padding-bottom:0 !important;&,& > .ant4-menu-item{height:100% !important;}}"], colorTheme === 'dark' ? theme.getColor('gray800') : theme.getColor('gray300'));
});
const LeftNavigationS = {
  LeftNavigation: LeftNavigation$1,
  HeaderLogoBanner: HeaderLogoBanner$1,
  FooterButtonBanner
};

const blueBackgroundBlob = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMzEuNDUzIDUuNzIyQTUuODI4IDUuODI4IDAgMCAwIDI2LjI3NS41NDZhOTYuODM0IDk2LjgzNCAwIDAgMC0yMC41NDQgMEE1LjgyOSA1LjgyOSAwIDAgMCAuNTQ2IDUuNzIyYTk2LjgxMyA5Ni44MTMgMCAwIDAgMCAyMC41NDIgNS44MjggNS44MjggMCAwIDAgNS4xNzggNS4xODcgOTYuMzcgOTYuMzcgMCAwIDAgMjAuNTQ0IDAgNS44MyA1LjgzIDAgMCAwIDUuMTg1LTUuMTggOTYuNjggOTYuNjggMCAwIDAgMC0yMC41NDlaIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPgo=';
const WsLogo$1 = /*#__PURE__*/styled(Box).withConfig({
  displayName: "ws-logostyle__WsLogo",
  componentId: "sc-19e6f6-0"
})(props => {
  const {
    theme: propTheme,
    $size = 32
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return css(["width:", ";height:", ";position:relative;display:flex;align-items:center;justify-content:center;&::before{content:' ';position:absolute;left:10%;top:10%;bottom:10%;right:10%;z-index:-1;background-color:", ";mask:url('", "');mask-size:contain;mask-repeat:no-repeat;}"], theme$1.getSpacing($size), theme$1.getSpacing($size), theme$1.colors.blue400, blueBackgroundBlob);
});
const WsLogoS = {
  WsLogo: WsLogo$1
};

var loadingAnimation = {
  v: '5.9.0',
  fr: 29.9700012207031,
  ip: 0,
  op: 149.000006068894,
  w: 500,
  h: 500,
  nm: 'Comp 1',
  ddd: 0,
  assets: [{
    id: 'comp_0',
    nm: 'Blue+Color',
    fr: 29.9700012207031,
    layers: [{
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Capa 12 Outlines',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [245.776, 163.3, 0],
          ix: 2,
          l: 2
        },
        a: {
          a: 0,
          k: [25.734, 6.743, 0],
          ix: 1,
          l: 2
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
          l: 2
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[2.982, -0.313], [3.121, -3.084], [1.053, 1.066], [-1.066, 1.053], [-4.517, 0.474], [-4.436, -2.844], [-2.982, 0.314], [-3.121, 3.084], [-1.054, -1.067], [1.066, -1.054], [4.518, -0.475], [4.437, 2.844]],
              o: [[-2.982, 0.313], [-1.067, 1.055], [-1.054, -1.067], [3.749, -3.704], [4.517, -0.476], [3.694, 2.368], [2.982, -0.313], [1.067, -1.054], [1.053, 1.066], [-3.748, 3.704], [-4.517, 0.475], [-3.694, -2.368]],
              v: [[-11.439, -0.618], [-20.591, 4.296], [-24.43, 4.273], [-24.408, 0.435], [-12.006, -6.017], [1.465, -2.286], [11.439, 0.618], [20.591, -4.296], [24.431, -4.273], [24.408, -0.434], [12.006, 6.018], [-1.465, 2.286]],
              c: true
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'fl',
          c: {
            a: 0,
            k: [0.992156922583, 0.992156922583, 0.992156922583, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          bm: 0,
          nm: 'Fill 1',
          mn: 'ADBE Vector Graphic - Fill',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [25.734, 6.743],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    }, {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: 'Capa 13 Outlines',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [245.776, 144.849, 0],
          ix: 2,
          l: 2
        },
        a: {
          a: 0,
          k: [25.734, 6.743, 0],
          ix: 1,
          l: 2
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
          l: 2
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[2.982, -0.313], [3.121, -3.085], [1.053, 1.066], [-1.066, 1.054], [-4.517, 0.475], [-4.436, -2.844], [-2.982, 0.314], [-3.121, 3.084], [-1.054, -1.067], [1.066, -1.054], [4.518, -0.475], [4.437, 2.844]],
              o: [[-2.982, 0.313], [-1.067, 1.053], [-1.054, -1.067], [3.749, -3.703], [4.517, -0.475], [3.694, 2.368], [2.982, -0.313], [1.067, -1.054], [1.053, 1.066], [-3.748, 3.704], [-4.517, 0.475], [-3.694, -2.368]],
              v: [[-11.439, -0.618], [-20.591, 4.297], [-24.43, 4.273], [-24.408, 0.434], [-12.006, -6.018], [1.465, -2.286], [11.439, 0.618], [20.591, -4.296], [24.431, -4.273], [24.408, -0.434], [12.006, 6.018], [-1.465, 2.286]],
              c: true
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'fl',
          c: {
            a: 0,
            k: [0.992156922583, 0.992156922583, 0.992156922583, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          bm: 0,
          nm: 'Fill 1',
          mn: 'ADBE Vector Graphic - Fill',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [25.734, 6.743],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    }, {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: 'Capa 14 Outlines',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [245.82, 154.001, 0],
          ix: 2,
          l: 2
        },
        a: {
          a: 0,
          k: [50.82, 50.821, 0],
          ix: 1,
          l: 2
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
          l: 2
        }
      },
      ao: 0,
      shapes: [{
        ty: 'gr',
        it: [{
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [[2.278, 21.346], [2.944, 2.943], [4.139, 0.441], [21.339, -2.277], [2.948, -2.944], [0.443, -4.142], [-2.277, -21.338], [-2.945, -2.949], [-4.145, -0.442], [-21.338, 2.288], [-2.948, 2.945], [-0.441, 4.144]],
              o: [[-0.443, -4.139], [-2.944, -2.943], [-21.339, -2.277], [-4.143, 0.436], [-2.949, 2.943], [-2.277, 21.338], [0.436, 4.146], [2.944, 2.95], [21.339, 2.288], [4.145, -0.436], [2.949, -2.946], [2.278, -21.345]],
              v: [[48.292, -32.12], [43.057, -43.064], [32.111, -48.294], [-32.089, -48.294], [-43.049, -43.07], [-48.292, -32.12], [-48.292, 32.075], [-43.068, 43.04], [-32.111, 48.283], [32.087, 48.283], [43.051, 43.056], [48.292, 32.098]],
              c: true
            },
            ix: 2
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false
        }, {
          ty: 'fl',
          c: {
            a: 0,
            k: [0.270588235294, 0.486274539723, 1, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          bm: 0,
          nm: 'Fill 1',
          mn: 'ADBE Vector Graphic - Fill',
          hd: false
        }, {
          ty: 'tr',
          p: {
            a: 0,
            k: [50.819, 50.821],
            ix: 2
          },
          a: {
            a: 0,
            k: [0, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [100, 100],
            ix: 3
          },
          r: {
            a: 0,
            k: 0,
            ix: 6
          },
          o: {
            a: 0,
            k: 100,
            ix: 7
          },
          sk: {
            a: 0,
            k: 0,
            ix: 4
          },
          sa: {
            a: 0,
            k: 0,
            ix: 5
          },
          nm: 'Transform'
        }],
        nm: 'Group 1',
        np: 2,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: 'ADBE Vector Group',
        hd: false
      }],
      ip: 0,
      op: 150.000006109625,
      st: 0,
      bm: 0
    }]
  }],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 0,
    nm: 'Blue+Color',
    refId: 'comp_0',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 1,
        k: [{
          i: {
            x: [0],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 63,
          s: [-45]
        }, {
          t: 88.0000035843135,
          s: [0]
        }],
        ix: 10
      },
      p: {
        a: 0,
        k: [250, 250, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [246, 154, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0, 0, 0.833],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 63,
          s: [0, 0, 100]
        }, {
          t: 88.0000035843135,
          s: [398.168, 398.168, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 492,
    h: 308,
    ip: 63.0000025660426,
    op: 213.000008675668,
    st: 63.0000025660426,
    bm: 0
  }, {
    ddd: 0,
    ind: 2,
    ty: 0,
    nm: 'Blue+Color',
    refId: 'comp_0',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 1,
        k: [{
          i: {
            x: [0],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 29,
          s: [0]
        }, {
          t: 54.0000021994651,
          s: [-45]
        }],
        ix: 10
      },
      p: {
        a: 0,
        k: [250, 250, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [246, 154, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 29,
          s: [398.168, 398.168, 100]
        }, {
          t: 54.0000021994651,
          s: [0, 0, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    tm: {
      a: 1,
      k: [{
        i: {
          x: [0.833],
          y: [0.833]
        },
        o: {
          x: [0.167],
          y: [0.167]
        },
        t: 28,
        s: [0.934]
      }, {
        t: 150.000006109625,
        s: [5.005]
      }],
      ix: 2
    },
    w: 492,
    h: 308,
    ip: 0,
    op: 150.000006109625,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 4,
    ty: 4,
    nm: 'Shape Layer 3',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [433.529, 250, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [183.529, -49.916, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0]],
            o: [[0, 0], [0, 0]],
            v: [[-334.79, -49.916], [701.849, -49.916]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 154,
            s: [0]
          }, {
            t: 171.000006964973,
            s: [100]
          }],
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 148,
            s: [0]
          }, {
            t: 162.000006598395,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.847045898438, 0.549011230469, 0.603912353516, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 30,
          ix: 5
        },
        lc: 2,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, -6],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 154.000006272549,
    op: 298.000012137789,
    st: 148.000006028164,
    bm: 0
  }, {
    ddd: 0,
    ind: 5,
    ty: 4,
    nm: 'Shape Layer 2',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [433.529, 330, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [183.529, -49.916, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0]],
            o: [[0, 0], [0, 0]],
            v: [[-334.79, -49.916], [701.849, -49.916]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 157,
            s: [0]
          }, {
            t: 174.000007087165,
            s: [20]
          }],
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 151,
            s: [0]
          }, {
            t: 165.000006720588,
            s: [20]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.270599365234, 0.486267089844, 1, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 30,
          ix: 5
        },
        lc: 2,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 157.000006394741,
    op: 301.000012259981,
    st: 151.000006150356,
    bm: 0
  }, {
    ddd: 0,
    ind: 6,
    ty: 4,
    nm: 'Shape Layer 1',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [433.529, 150, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [183.529, -49.916, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0]],
            o: [[0, 0], [0, 0]],
            v: [[-334.79, -49.916], [701.849, -49.916]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 154,
            s: [0]
          }, {
            t: 171.000006964973,
            s: [50]
          }],
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 148,
            s: [0]
          }, {
            t: 162.000006598395,
            s: [50]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.968627929688, 0.725494384766, 0.313720703125, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 30,
          ix: 5
        },
        lc: 2,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 154.000006272549,
    op: 298.000012137789,
    st: 148.000006028164,
    bm: 0
  }, {
    ddd: 0,
    ind: 7,
    ty: 3,
    nm: 'Null 7',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 0,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [250, 250, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [50, 50, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [70, 70, 100],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    ip: 0,
    op: 180.00000733155,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 8,
    ty: 4,
    nm: 'Shape Layer 7',
    parent: 7,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [50, 50, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [27, -13, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0, 0, 0.833],
            y: [1, 1, 1]
          },
          o: {
            x: [0.167, 0.167, 0.167],
            y: [0, 0, 0]
          },
          t: 32,
          s: [0, 0, 100]
        }, {
          i: {
            x: [0.833, 0.833, 0.833],
            y: [1, 1, 1]
          },
          o: {
            x: [0.167, 0.167, 0.167],
            y: [0, 0, 0]
          },
          t: 42.238,
          s: [100, 100, 100]
        }, {
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 56.571,
          s: [100, 100, 100]
        }, {
          t: 75.0000030548126,
          s: [0, 0, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        d: 1,
        ty: 'el',
        s: {
          a: 0,
          k: [506, 506],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        nm: 'Ellipse Path 1',
        mn: 'ADBE Vector Shape - Ellipse',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.270599365234, 0.486267089844, 1, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 60,
          ix: 5
        },
        lc: 2,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [27, -13],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Ellipse 1',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'tm',
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.833],
            y: [1]
          },
          o: {
            x: [0.167],
            y: [0]
          },
          t: 42.921,
          s: [0]
        }, {
          i: {
            x: [0.667],
            y: [0.975]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 49.653,
          s: [0]
        }, {
          t: 56.5712523041942,
          s: [49.815]
        }],
        ix: 1
      },
      e: {
        a: 1,
        k: [{
          i: {
            x: [0.667],
            y: [0.985]
          },
          o: {
            x: [0.333],
            y: [0.015]
          },
          t: 42.921,
          s: [0.057]
        }, {
          t: 56.5712523041942,
          s: [49.943]
        }],
        ix: 2
      },
      o: {
        a: 1,
        k: [{
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 42.238,
          s: [0]
        }, {
          t: 57.253752331993,
          s: [180]
        }],
        ix: 3
      },
      m: 1,
      ix: 2,
      nm: 'Trim Paths 1',
      mn: 'ADBE Vector Filter - Trim',
      hd: false
    }],
    ip: 30.0000012219251,
    op: 102.000004154545,
    st: 47.0000019143492,
    bm: 0
  }, {
    ddd: 0,
    ind: 9,
    ty: 4,
    nm: 'Shape Layer 6',
    parent: 7,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 90,
        ix: 10
      },
      p: {
        a: 0,
        k: [50, 50, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [27, -13, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0, 0, 0.833],
            y: [1, 1, 1]
          },
          o: {
            x: [0.167, 0.167, 0.167],
            y: [0, 0, 0]
          },
          t: 33.365,
          s: [0, 0, 100]
        }, {
          i: {
            x: [0.833, 0.833, 0.833],
            y: [1, 1, 1]
          },
          o: {
            x: [0.167, 0.167, 0.167],
            y: [0, 0, 0]
          },
          t: 42.238,
          s: [100, 100, 100]
        }, {
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 56.571,
          s: [100, 100, 100]
        }, {
          t: 75.0000030548126,
          s: [0, 0, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        d: 1,
        ty: 'el',
        s: {
          a: 0,
          k: [506, 506],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        nm: 'Ellipse Path 1',
        mn: 'ADBE Vector Shape - Ellipse',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.968597412109, 0.725463867188, 0.313720703125, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 60,
          ix: 5
        },
        lc: 2,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [27, -13],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Ellipse 1',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'tm',
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.833],
            y: [1]
          },
          o: {
            x: [0.167],
            y: [0]
          },
          t: 42.921,
          s: [0]
        }, {
          i: {
            x: [0.667],
            y: [0.975]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 49.653,
          s: [0]
        }, {
          t: 56.5712523041942,
          s: [49.815]
        }],
        ix: 1
      },
      e: {
        a: 1,
        k: [{
          i: {
            x: [0.667],
            y: [0.985]
          },
          o: {
            x: [0.333],
            y: [0.015]
          },
          t: 42.921,
          s: [0.057]
        }, {
          t: 56.5712523041942,
          s: [49.943]
        }],
        ix: 2
      },
      o: {
        a: 1,
        k: [{
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 42.238,
          s: [0]
        }, {
          t: 57.253752331993,
          s: [180]
        }],
        ix: 3
      },
      m: 1,
      ix: 2,
      nm: 'Trim Paths 1',
      mn: 'ADBE Vector Filter - Trim',
      hd: false
    }],
    ip: 30.0000012219251,
    op: 102.000004154545,
    st: 47.0000019143492,
    bm: 0
  }, {
    ddd: 0,
    ind: 10,
    ty: 4,
    nm: 'Shape Layer 8',
    parent: 7,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 180,
        ix: 10
      },
      p: {
        a: 0,
        k: [50, 50, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [27, -13, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0, 0, 0.833],
            y: [1, 1, 1]
          },
          o: {
            x: [0.167, 0.167, 0.167],
            y: [0, 0, 0]
          },
          t: 34.73,
          s: [0, 0, 100]
        }, {
          i: {
            x: [0.833, 0.833, 0.833],
            y: [1, 1, 1]
          },
          o: {
            x: [0.167, 0.167, 0.167],
            y: [0, 0, 0]
          },
          t: 42.238,
          s: [100, 100, 100]
        }, {
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 56.571,
          s: [100, 100, 100]
        }, {
          t: 75.0000030548126,
          s: [0, 0, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        d: 1,
        ty: 'el',
        s: {
          a: 0,
          k: [506, 506],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        nm: 'Ellipse Path 1',
        mn: 'ADBE Vector Shape - Ellipse',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.274509803922, 0.301960784314, 0.364705882353, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 60,
          ix: 5
        },
        lc: 2,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [27, -13],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Ellipse 1',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'tm',
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.833],
            y: [1]
          },
          o: {
            x: [0.167],
            y: [0]
          },
          t: 42.921,
          s: [0]
        }, {
          i: {
            x: [0.667],
            y: [0.975]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 49.653,
          s: [0]
        }, {
          t: 56.5712523041942,
          s: [49.815]
        }],
        ix: 1
      },
      e: {
        a: 1,
        k: [{
          i: {
            x: [0.667],
            y: [0.985]
          },
          o: {
            x: [0.333],
            y: [0.015]
          },
          t: 42.921,
          s: [0.057]
        }, {
          t: 56.5712523041942,
          s: [49.943]
        }],
        ix: 2
      },
      o: {
        a: 1,
        k: [{
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 42.238,
          s: [0]
        }, {
          t: 57.253752331993,
          s: [180]
        }],
        ix: 3
      },
      m: 1,
      ix: 2,
      nm: 'Trim Paths 1',
      mn: 'ADBE Vector Filter - Trim',
      hd: false
    }],
    ip: 30.0000012219251,
    op: 102.000004154545,
    st: 47.0000019143492,
    bm: 0
  }, {
    ddd: 0,
    ind: 11,
    ty: 4,
    nm: 'Shape Layer 5',
    parent: 7,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: -90,
        ix: 10
      },
      p: {
        a: 0,
        k: [50, 50, 0],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [27, -13, 0],
        ix: 1,
        l: 2
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0, 0, 0.833],
            y: [1, 1, 1]
          },
          o: {
            x: [0.167, 0.167, 0.167],
            y: [0, 0, 0]
          },
          t: 36.095,
          s: [0, 0, 100]
        }, {
          i: {
            x: [0.833, 0.833, 0.833],
            y: [1, 1, 1]
          },
          o: {
            x: [0.167, 0.167, 0.167],
            y: [0, 0, 0]
          },
          t: 42.238,
          s: [100, 100, 100]
        }, {
          i: {
            x: [0, 0, 0.667],
            y: [1, 1, 1]
          },
          o: {
            x: [0.333, 0.333, 0.333],
            y: [0, 0, 0]
          },
          t: 56.571,
          s: [100, 100, 100]
        }, {
          t: 75.0000030548126,
          s: [0, 0, 100]
        }],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        d: 1,
        ty: 'el',
        s: {
          a: 0,
          k: [506, 506],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        nm: 'Ellipse Path 1',
        mn: 'ADBE Vector Shape - Ellipse',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.847015380859, 0.548980712891, 0.603881835938, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 60,
          ix: 5
        },
        lc: 2,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [27, -13],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Ellipse 1',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'tm',
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.833],
            y: [1]
          },
          o: {
            x: [0.167],
            y: [0]
          },
          t: 42.921,
          s: [0]
        }, {
          i: {
            x: [0.667],
            y: [0.975]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 49.653,
          s: [0]
        }, {
          t: 56.5712523041942,
          s: [49.815]
        }],
        ix: 1
      },
      e: {
        a: 1,
        k: [{
          i: {
            x: [0.667],
            y: [0.985]
          },
          o: {
            x: [0.333],
            y: [0.015]
          },
          t: 42.921,
          s: [0.057]
        }, {
          t: 56.5712523041942,
          s: [49.943]
        }],
        ix: 2
      },
      o: {
        a: 1,
        k: [{
          i: {
            x: [0.667],
            y: [1]
          },
          o: {
            x: [0.333],
            y: [0]
          },
          t: 42.238,
          s: [0]
        }, {
          t: 57.253752331993,
          s: [180]
        }],
        ix: 3
      },
      m: 1,
      ix: 2,
      nm: 'Trim Paths 1',
      mn: 'ADBE Vector Filter - Trim',
      hd: false
    }],
    ip: 30.0000012219251,
    op: 102.000004154545,
    st: 47.0000019143492,
    bm: 0
  }],
  markers: []
};

/** Default duration of the animation is 3000ms, double-check this value when the animation json is changed */
const defaultDuration$1 = 3000;
const WsSpinLogo = props => {
  const {
      $size = 100,
      loop = true,
      spinDuration = defaultDuration$1
    } = props,
    restProps = __rest(props, ["$size", "loop", "spinDuration"]);
  const {
    View: spinningLogoElement,
    setSpeed
  } = useLottie({
    animationData: loadingAnimation,
    loop
  });
  useEffect(() => {
    if (!spinDuration) return;
    setSpeed(defaultDuration$1 / spinDuration);
  }, [setSpeed, spinDuration]);
  return jsx(Box, Object.assign({
    width: $size
  }, restProps, {
    children: spinningLogoElement
  }));
};
/**
 * WsLogo
 */
const WsLogo = props => {
  const {
    color = 'gray100',
    spinning,
    $size = 32,
    loop
  } = props;
  if (spinning) {
    return jsx(WsSpinLogo, {
      "$size": $size,
      loop: loop
    });
  }
  return jsx(WsLogoS.WsLogo, Object.assign({
    "$size": $size
  }, props, {
    children: jsx(WorkstreamLogo, {
      color: color,
      size: "56%"
    })
  }));
};

var wsLogoWorkstreamSvg = "data:image/svg+xml,%3Csvg%20width%3D%22264%22%20height%3D%2256%22%20viewBox%3D%220%200%20264%2056%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url%28%23clip0_2923_11514%29%22%3E%3Cpath%20d%3D%22M259.264%2036.7282L259.187%2026.2853C259.187%2025.6997%20259.129%2025.1531%20258.996%2024.6261C258.861%2024.0991%20258.517%2023.5915%20257.961%2023.1036C257.406%2022.6156%20256.659%2022.3618%20255.72%2022.3618C255.624%2022.3618%20255.491%2022.3618%20255.337%2022.3813C255.184%2022.4009%20254.896%2022.4985%20254.475%2022.6741C254.054%2022.8498%20253.69%2023.1036%20253.383%2023.4159C253.077%2023.7282%20252.79%2024.2162%20252.521%2024.8798C252.253%2025.5435%20252.119%2026.3243%20252.119%2027.2417V36.7478H247.484V26.2658C247.484%2025.6802%20247.427%2025.1336%20247.292%2024.6066C247.158%2024.0795%20246.813%2023.5721%20246.258%2023.0841C245.702%2022.596%20244.955%2022.3423%20244.017%2022.3423C243.921%2022.3423%20243.787%2022.3423%20243.634%2022.3618C243.481%2022.3813%20243.193%2022.4789%20242.772%2022.6546C242.351%2022.8303%20241.987%2023.0841%20241.68%2023.3964C241.373%2023.7087%20241.086%2024.1967%20240.818%2024.8603C240.55%2025.524%20240.416%2026.3048%20240.416%2027.2222V36.7282H235.781V18.536H240.052L240.454%2020.5465C241.527%2019.024%20243.213%2018.2627%20245.511%2018.2627C246.354%2018.2627%20247.12%2018.4189%20247.81%2018.7312C248.499%2019.0435%20249.054%2019.4143%20249.476%2019.8633C249.897%2020.3122%20250.223%2020.7027%20250.453%2021.054C250.682%2021.4054%20250.855%2021.6981%20250.951%2021.9324C252.119%2019.4925%20254.168%2018.2627%20257.099%2018.2627C261.62%2018.2627%20263.88%2020.976%20263.88%2026.4219V36.7282H259.264Z%22%20fill%3D%22%23353A46%22%2F%3E%3Cpath%20d%3D%22M228.125%2027.6712L228.106%2027.6907C228.106%2027.3784%20228.087%2027.0856%20228.049%2026.8123C228.01%2026.5391%20227.895%2026.1096%20227.704%2025.524C227.512%2024.9384%20227.225%2024.431%20226.861%2024.021C226.497%2023.6111%20225.941%2023.2402%20225.194%2022.9084C224.447%2022.5766%20223.528%2022.4009%20222.455%2022.4009C221.44%2022.4009%20220.578%2022.5766%20219.889%2022.9279C219.199%2023.2793%20218.701%2023.7672%20218.395%2024.3724C218.088%2024.9775%20217.897%2025.5436%20217.801%2026.0706C217.705%2026.5976%20217.648%2027.1442%20217.648%2027.7102C217.648%2028.2763%20217.705%2028.8033%20217.801%2029.3109C217.897%2029.8183%20218.107%2030.3844%20218.414%2030.9895C218.72%2031.5946%20219.218%2032.0826%20219.908%2032.434C220.597%2032.7853%20221.46%2032.961%20222.474%2032.961C223.547%2032.961%20224.467%2032.7853%20225.214%2032.4535C225.96%2032.1217%20226.516%2031.7508%20226.88%2031.3604C227.244%2030.97%20227.531%2030.4625%20227.723%2029.8574C227.914%2029.2523%20228.029%2028.8229%20228.068%2028.5496C228.106%2028.2763%20228.125%2027.9835%20228.125%2027.6712ZM232.722%2018.575V36.7673H228.604L228.336%2034.8154C226.976%2036.3184%20224.83%2037.0601%20221.9%2037.0406C219.18%2037.0406%20216.996%2036.2208%20215.368%2034.6007C213.74%2032.9805%20212.917%2030.6772%20212.917%2027.6907C212.917%2024.7042%20213.74%2022.4009%20215.368%2020.7613C216.996%2019.1216%20219.18%2018.3018%20221.9%2018.3018C224.83%2018.3018%20226.976%2019.0435%20228.336%2020.5465L228.604%2018.575H232.722Z%22%20fill%3D%22%23353A46%22%2F%3E%3Cpath%20d%3D%22M211.237%2027.6515L211.218%2029.4668H197.809C198.02%2030.5404%20198.461%2031.3798%20199.112%2031.9849C199.763%2032.59%20200.855%2032.9023%20202.368%2032.9023C204.15%2032.9023%20205.567%2032.2191%20206.64%2030.8723L210.087%2032.9414C209.378%2034.2882%20208.344%2035.3032%20206.984%2035.9669C205.624%2036.6306%20204.092%2036.9624%20202.368%2036.9624C202.138%2036.9624%20201.89%2036.9624%20201.602%2036.9429C201.314%2036.9234%20200.855%2036.8648%20200.204%2036.7477C199.553%2036.6306%20198.94%2036.4549%20198.384%2036.2402C197.828%2036.0254%20197.216%2035.6936%20196.546%2035.2446C195.875%2034.7957%20195.3%2034.2492%20194.841%2033.6246C194.381%2032.9999%20193.978%2032.1801%20193.653%2031.1846C193.327%2030.1891%20193.155%2029.057%20193.155%2027.7882C193.155%2024.8407%20193.978%2022.4788%20195.645%2020.7221C197.312%2018.9653%20199.553%2018.0869%20202.387%2018.0869C203.977%2018.0869%20205.356%2018.3797%20206.525%2018.9653C207.693%2019.5509%20208.574%2020.2341%20209.149%2021.0149C209.723%2021.7957%20210.183%2022.6936%20210.528%2023.7086C210.873%2024.7236%20211.083%2025.5044%20211.141%2026.0704C211.198%2026.6365%20211.237%2027.1636%20211.237%2027.6515ZM202.196%2022.2055H202.177C199.782%2022.2055%20198.327%2023.3963%20197.809%2025.7972H206.601C206.046%2023.3963%20204.571%2022.2055%20202.196%2022.2055Z%22%20fill%3D%22%23353A46%22%2F%3E%3Cpath%20d%3D%22M184.46%2018.536L184.843%2020.2732C185.13%2019.8243%20185.686%2019.3753%20186.51%2018.9264C187.333%2018.4774%20188.406%2018.2432%20189.727%2018.2432C190.724%2018.2432%20191.643%2018.3798%20192.505%2018.6336L191.873%2022.6351C190.896%2022.4204%20189.977%2022.3228%20189.096%2022.3228C188.08%2022.3228%20187.123%2022.6351%20186.203%2023.2792C185.284%2023.9234%20184.824%2024.997%20184.824%2026.5V36.7283H180.189V18.536H184.46Z%22%20fill%3D%22%23353A46%22%2F%3E%3Cpath%20d%3D%22M165.671%2022.6156V18.536H169.138V11.021H173.754V18.536H177.911V22.6156H173.754V36.7283H169.138V22.6156H165.671Z%22%20fill%3D%22%23353A46%22%2F%3E%3Cpath%20d%3D%22M154.175%2023.6501L154.195%2023.7282C154.195%2024.3138%20154.539%2024.7823%20155.229%2025.1141C155.919%2025.4459%20156.762%2025.7192%20157.757%2025.934C158.753%2026.1487%20159.75%2026.4414%20160.726%2026.7928C161.703%2027.1441%20162.546%2027.7297%20163.236%2028.5495C163.925%2029.3694%20164.27%2030.4039%20164.27%2031.6727C164.27%2032.1607%20164.155%2032.6682%20163.925%2033.1952C163.696%2033.7223%20163.331%2034.3079%20162.814%2034.9325C162.297%2035.5571%20161.473%2036.0646%20160.343%2036.455C159.213%2036.8454%20157.873%2037.0406%20156.321%2037.0406C154.999%2037.0406%20153.85%2036.8649%20152.893%2036.5135C151.934%2036.1622%20151.207%2035.6742%20150.689%2035.0496C150.173%2034.425%20149.809%2033.8784%20149.578%2033.3904C149.349%2032.9024%20149.157%2032.3559%20149.004%2031.7508L152.777%2031.0286C152.931%2031.7508%20153.295%2032.3168%20153.888%2032.7268C154.482%2033.1367%20155.018%2033.3709%20155.517%2033.4294L156.264%2033.4685C157.413%2033.4685%20158.237%2033.2928%20158.753%2032.9415C159.271%2032.5901%20159.52%2032.1607%20159.52%2031.6727C159.52%2031.1456%20159.175%2030.7357%20158.485%2030.443C157.796%2030.1501%20156.953%2029.8964%20155.976%2029.6622C154.999%2029.428%20154.023%2029.1351%20153.026%2028.7838C152.03%2028.4325%20151.187%2027.8273%20150.498%2026.9684C149.809%2026.1096%20149.464%2025.0165%20149.464%2023.7087C149.464%2023.2597%20149.559%2022.7717%20149.732%2022.2642C149.904%2021.7567%20150.23%2021.1712%20150.709%2020.527C151.187%2019.8829%20151.934%2019.3558%20152.969%2018.9264C154.003%2018.4969%20155.248%2018.2822%20156.704%2018.2822C157.873%2018.2822%20158.926%2018.4579%20159.845%2018.8093C160.764%2019.1606%20161.473%2019.6096%20161.971%2020.1756C162.47%2020.7417%20162.853%2021.2492%20163.101%2021.6982C163.351%2022.1471%20163.542%2022.5961%20163.676%2023.045L160.152%2023.9625C159.826%2023.3573%20159.386%2022.8694%20158.83%2022.518C158.275%2022.1667%20157.777%2021.9714%20157.355%2021.9519L156.723%2021.8738C155.784%2021.8738%20155.133%2022.0495%20154.75%2022.4204C154.367%2022.7913%20154.175%2023.2012%20154.175%2023.6501Z%22%20fill%3D%22%23353A46%22%2F%3E%3Cpath%20d%3D%22M148.474%2018.536L141.961%2025.5435L148.742%2036.7282H143.532L138.782%2028.9009L135.296%2032.6096V36.7282H130.66V9.7522H135.296V25.8168L142.114%2018.536H148.474Z%22%20fill%3D%22%23353A46%22%2F%3E%3Cpath%20d%3D%22M120.605%2018.536L120.988%2020.2732C121.275%2019.8243%20121.831%2019.3753%20122.655%2018.9264C123.478%2018.4774%20124.551%2018.2432%20125.872%2018.2432C126.869%2018.2432%20127.788%2018.3798%20128.65%2018.6336L128.018%2022.6351C127.041%2022.4204%20126.122%2022.3228%20125.241%2022.3228C124.226%2022.3228%20123.268%2022.6351%20122.348%2023.2792C121.429%2023.9234%20120.969%2024.997%20120.969%2026.5V36.7283H116.334V18.536H120.605Z%22%20fill%3D%22%23353A46%22%2F%3E%3Cpath%20d%3D%22M109.679%2027.6517H109.66C109.66%2026.6561%20109.506%2025.7973%20109.2%2025.075C108.893%2024.3528%20108.568%2023.8258%20108.204%2023.4939C107.84%2023.1621%20107.399%2022.8889%20106.882%2022.6936C106.365%2022.4985%20105.982%2022.3813%20105.733%2022.3618C105.484%2022.3423%20105.235%2022.3228%20105.005%2022.3228C104.776%2022.3228%20104.526%2022.3423%20104.277%2022.3618C104.029%2022.3813%20103.645%2022.4985%20103.147%2022.6936C102.649%2022.8889%20102.209%2023.1621%20101.845%2023.4939C101.481%2023.8258%20101.155%2024.3528%20100.849%2025.075C100.542%2025.7973%20100.389%2026.6561%20100.389%2027.6517C100.389%2028.8423%20100.6%2029.8378%20101.002%2030.6381C101.404%2031.4384%20101.921%2031.985%20102.553%2032.2583C103.186%2032.5316%20103.684%2032.7072%20104.029%2032.7853C104.373%2032.8633%20104.699%2032.9024%20105.005%2032.9024C105.311%2032.9024%20105.656%2032.8633%20106.02%2032.7853C106.384%2032.7072%20106.882%2032.5316%20107.515%2032.2583C108.146%2031.985%20108.664%2031.4384%20109.066%2030.6381C109.468%2029.8378%20109.679%2028.8423%20109.679%2027.6517ZM95.6582%2027.6517C95.6582%2024.9384%2096.52%2022.6936%2098.2437%2020.9174C99.9674%2019.1411%20102.228%2018.2627%20105.024%2018.2627C107.802%2018.2627%20110.043%2019.1411%20111.767%2020.9174C113.49%2022.6936%20114.352%2024.9384%20114.352%2027.6517C114.352%2030.3649%20113.49%2032.6096%20111.767%2034.3664C110.043%2036.1232%20107.802%2037.0015%20105.024%2037.0015C102.228%2037.0015%2099.9674%2036.1232%2098.2437%2034.3664C96.52%2032.6096%2095.6582%2030.3649%2095.6582%2027.6517Z%22%20fill%3D%22%23353A46%22%2F%3E%3Cpath%20d%3D%22M82.711%2018.5359L87.0969%2030.1305L90.8707%2018.5359H95.3911L89.338%2036.7281H85.0669L80.7952%2025.5434L76.5051%2036.7281H72.2334L66.2%2018.5359H70.7012L74.4745%2030.1305L78.861%2018.5359H82.711Z%22%20fill%3D%22%23353A46%22%2F%3E%3Cpath%20d%3D%22M28.12%2056C43.584%2056%2056.12%2043.464%2056.12%2028C56.12%2012.536%2043.584%200%2028.12%200C12.656%200%200.119995%2012.536%200.119995%2028C0.119995%2043.464%2012.656%2056%2028.12%2056Z%22%20fill%3D%22%23457CFF%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M21.572%2022.8923C19.8174%2023.0767%2018.0246%2023.9764%2016.1904%2025.8091C15.5637%2026.4354%2014.5523%2026.4281%2013.9315%2025.7928C13.3107%2025.1576%2013.3154%2024.135%2013.9422%2023.5087C16.145%2021.3076%2018.5767%2019.9585%2021.2343%2019.6792C23.8919%2019.3999%2026.551%2020.214%2029.1632%2021.9089C31.3384%2023.3203%2033.2791%2023.8275%2035.0336%2023.6431C36.7882%2023.4587%2038.5811%2022.5591%2040.4153%2020.7263C41.042%2020.1%2042.0534%2020.1073%2042.6742%2020.7425C43.295%2021.3778%2043.2902%2022.4004%2042.6635%2023.0267C40.4607%2025.2278%2038.029%2026.5768%2035.3714%2026.8562C32.7138%2027.1355%2030.0547%2026.3215%2027.4425%2024.6265C25.2673%2023.2151%2023.3266%2022.7079%2021.572%2022.8923Z%22%20fill%3D%22%23FDFDFD%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M21.572%2032.6406C19.8174%2032.825%2018.0246%2033.7247%2016.1904%2035.5574C15.5637%2036.1837%2014.5523%2036.1764%2013.9315%2035.5412C13.3107%2034.9059%2013.3154%2033.8833%2013.9422%2033.257C16.145%2031.056%2018.5767%2029.7068%2021.2343%2029.4275C23.8919%2029.1482%2026.551%2029.9622%2029.1632%2031.6572C31.3384%2033.0686%2033.2791%2033.5758%2035.0336%2033.3914C36.7882%2033.207%2038.5811%2032.3074%2040.4152%2030.4746C41.042%2029.8483%2042.0534%2029.8556%2042.6742%2030.4908C43.295%2031.1261%2043.2902%2032.1487%2042.6635%2032.775C40.4607%2034.976%2038.029%2036.3251%2035.3714%2036.6045C32.7138%2036.8838%2030.0547%2036.0698%2027.4425%2034.3748C25.2673%2032.9634%2023.3266%2032.4562%2021.572%2032.6406Z%22%20fill%3D%22%23FDFDFD%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_2923_11514%22%3E%3Crect%20width%3D%22263.76%22%20height%3D%2256%22%20fill%3D%22white%22%20transform%3D%22translate%280.119995%29%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var wsLogoPoweredByWorkstreamSvg = "6868f6521f2e89b9.svg";

const WsLogoWorkstream = () => {
  return jsx("img", {
    src: wsLogoWorkstreamSvg,
    alt: "Workstream Logo"
  });
};
const WsLogoPoweredByWorkstream = () => {
  return jsx("img", {
    src: wsLogoPoweredByWorkstreamSvg,
    alt: "Powered by Workstream"
  });
};

const HeaderLogoBanner = props => {
  const {
    title,
    collapsed,
    onCollapseClick,
    homeAnchorProps,
    colorTheme,
    collapseButton
  } = props;
  const nodeRef = useRef(null);
  const [showTogglerWhenCollapsed, setShowTogglerWhenCollapsed] = useState(false);
  const [hovered, setHovered] = useState(false);
  const CollapseToggleIcon = collapsed ? Expand : Collapse;
  const handleCollapseClick = () => {
    onCollapseClick === null || onCollapseClick === void 0 ? void 0 : onCollapseClick();
    setShowTogglerWhenCollapsed(false);
  };
  return jsxs(LeftNavigationS.HeaderLogoBanner, {
    collapsed: collapsed,
    colorTheme: colorTheme,
    children: [jsx(Box, Object.assign({
      as: "a",
      href: "/#/",
      position: collapsed ? 'absolute' : 'unset',
      zIndex: 1,
      style: {
        opacity: showTogglerWhenCollapsed ? 0 : 1
      },
      onMouseEnter: () => collapsed && setShowTogglerWhenCollapsed(true),
      "data-testid": "left-navigation-logo",
      className: "LeftNavigation-logo",
      marginX: -2,
      "$color": homeAnchorProps === null || homeAnchorProps === void 0 ? void 0 : homeAnchorProps.color
    }, omit(homeAnchorProps, 'color'), {
      children: jsx(WsLogo, {
        "$size": 36
      })
    })), !collapsed && jsx(Typography, {
      className: "LeftNavigation-title",
      "data-testid": "left-navigation-title",
      variant: "body",
      color: "gray500",
      fontWeight: "semibold",
      style: {
        flex: 1
      },
      letterSpacing: 2.4,
      children: title
    }), collapseButton !== null && collapseButton !== void 0 ? collapseButton : jsx(CSSTransition, {
      nodeRef: nodeRef,
      in: hovered,
      timeout: 50,
      classNames: "btn-hovered",
      children: jsx(Box, {
        ref: nodeRef,
        position: collapsed ? 'absolute' : 'unset',
        zIndex: showTogglerWhenCollapsed ? 2 : 0,
        padding: 10,
        backgroundColor: "transparent",
        style: {
          cursor: 'pointer'
        },
        "data-testid": "left-navigation-collapse-button",
        className: "LeftNavigation-collapse-button",
        onMouseEnter: () => setHovered(true),
        onMouseLeave: () => {
          setHovered(false);
          setShowTogglerWhenCollapsed(false);
        },
        onClick: handleCollapseClick,
        children: jsx(CollapseToggleIcon, {
          size: 20,
          color: "inherit",
          style: {
            margin: '0 auto'
          }
        })
      })
    })]
  });
};

/**
 * LeftNavigation
 */
const LeftNavigation = props => {
  const [stateCollapsed, setStateCollapsed] = useState(false);
  const {
      title,
      colorTheme,
      collapsed = stateCollapsed,
      onCollapsedChange = setStateCollapsed,
      menuItems,
      mainMenuProps,
      headerLogoBannerProps,
      footerMenuItemProps
    } = props,
    restProps = __rest(props, ["title", "colorTheme", "collapsed", "onCollapsedChange", "menuItems", "mainMenuProps", "headerLogoBannerProps", "footerMenuItemProps"]);
  const styleProps = {
    collapsed,
    colorTheme
  };
  const color = colorTheme === 'dark' ? {
    ps: 'gray500',
    t: 'white'
  } : 'gray800';
  return jsxs(LeftNavigationS.LeftNavigation, Object.assign({
    variant: "sidebar",
    color: color
  }, styleProps, restProps, {
    children: [jsx(HeaderLogoBanner, Object.assign({
      title: title,
      onCollapseClick: () => onCollapsedChange === null || onCollapsedChange === void 0 ? void 0 : onCollapsedChange(!collapsed)
    }, styleProps, headerLogoBannerProps)), jsxs(Fragment, {
      children: [jsx(Menu, Object.assign({
        variant: "navigation",
        className: "LeftNavigation-main-menu",
        inlineCollapsed: collapsed,
        "$colorTheme": colorTheme,
        items: menuItems,
        "$collapsed": collapsed,
        onCollapseChange: onCollapsedChange,
        "$selectedBackgroundShape": "chip"
      }, mainMenuProps)), footerMenuItemProps && jsx(LeftNavigationS.FooterButtonBanner, Object.assign({}, styleProps, {
        children: jsx(Menu, {
          variant: "navigation",
          "data-testid": "left-navigation-footer-menu",
          className: "LeftNavigation-footer-menu",
          inlineCollapsed: collapsed,
          selectedKeys: [],
          "$colorTheme": colorTheme,
          items: [footerMenuItemProps],
          "$collapsed": collapsed
        })
      }))]
    })]
  }));
};

const LoadingPage$1 = /*#__PURE__*/styled(FlexBox).attrs({
  zIndex: 'modal',
  gap: 20,
  direction: 'column',
  align: 'center',
  justify: 'center'
}).withConfig({
  displayName: "loading-pagestyle__LoadingPage",
  componentId: "sc-1blq0w0-0"
})(props => {
  const {
    variant = 'dark',
    theme: propTheme,
    transitionStatus
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return css(["position:fixed;top:0;left:0;bottom:0;right:0;transition:all 0.225s ease;background-color:", ";", ""], variant === 'dark' ? theme$1.colors.gray900 : '#fff', transitionStatus === 'entering' ? `opacity: 1; visibility: visible;` : `opacity: 0; visibility: hidden;`);
});
const S$5 = {
  LoadingPage: LoadingPage$1
};

const defaultDuration = 2000;
const LoadingPage = props => {
  const {
      message = 'Switching your experience...',
      variant,
      visible,
      duration = defaultDuration,
      onAnimationEnd
    } = props,
    restProps = __rest(props, ["message", "variant", "visible", "duration", "onAnimationEnd"]);
  const propsRef = useRef(props);
  propsRef.current = props;
  const [animation, setAnimation] = useState(false);
  const nodeRef = useRef(null);
  useEffect(() => {
    if (animation) {
      const timeoutId = setTimeout(() => {
        var _a, _b;
        setAnimation(false);
        (_b = (_a = propsRef.current).onAnimationEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
      }, duration);
      return () => clearTimeout(timeoutId);
    }
    return;
  }, [animation, duration]);
  useEffect(() => {
    if (visible) {
      setAnimation(true);
    }
  }, [visible, variant]);
  return jsx(Transition, {
    nodeRef: nodeRef,
    in: animation,
    timeout: duration,
    children: transitionStatus => {
      return jsxs(S$5.LoadingPage, Object.assign({
        ref: nodeRef,
        "data-testid": "LoadingPage-root",
        transitionStatus: transitionStatus
      }, restProps, {
        variant: variant,
        children: [jsx(WsSpinLogo, {
          "$size": 100,
          spinDuration: duration,
          loop: false
        }, `${variant}-${animation ? 'visible' : 'hidden'}`), jsx(Typography, {
          variant: "h2",
          color: variant === 'dark' ? 'white' : '#000',
          children: message
        })]
      }));
    }
  });
};

const getBgColor = (propTheme, bgColor) => {
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return bgColor ? theme$1.getColor(bgColor) : 'rgba(35, 39, 47, 0.45)';
};
const maskStyle = /*#__PURE__*/css(["position:absolute;top:0;bottom:0;left:0;right:0;background-color:", ";", ";"], ({
  theme,
  bgColor
}) => getBgColor(theme, bgColor), ({
  onClick,
  maskClickable: _maskClickable = !!onClick
}) => _maskClickable ? onClick && css(["cursor:pointer;"]) : css(["cursor:not-allowed;"]));
/**
 * mask is used to create Modal-ish components
 *
 * usage:
 * const Modal = style.div`
 *  ${mask}
 * `;
 */
const mask = /*#__PURE__*/css(["position:relative;&::before{content:' ';z-index:0;", ";}> *{z-index:1;}"], maskStyle);
/**
 * Mask is used to render a gray layer over any element with position: relative
 *
 * usage:
 * <ModalRoot>
 *   <Mask />
 *   <ModalContent />
 * </ModalRoot>
 *
 */
const Mask = /*#__PURE__*/styled.div.withConfig({
  displayName: "mask__Mask",
  componentId: "sc-195ybbw-0"
})(["", ""], maskStyle);

var uncurryThis$1 = functionUncurryThis;

// eslint-disable-next-line es/no-set -- safe
var SetPrototype$1 = Set.prototype;

var setHelpers = {
  // eslint-disable-next-line es/no-set -- safe
  Set: Set,
  add: uncurryThis$1(SetPrototype$1.add),
  has: uncurryThis$1(SetPrototype$1.has),
  remove: uncurryThis$1(SetPrototype$1['delete']),
  proto: SetPrototype$1
};

var has$5 = setHelpers.has;

// Perform ? RequireInternalSlot(M, [[SetData]])
var aSet$7 = function (it) {
  has$5(it);
  return it;
};

var call$1 = functionCall;

var iterateSimple$7 = function (record, fn, ITERATOR_INSTEAD_OF_RECORD) {
  var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
  var next = record.next;
  var step, result;
  while (!(step = call$1(next, iterator)).done) {
    result = fn(step.value);
    if (result !== undefined) return result;
  }
};

var uncurryThis = functionUncurryThis;
var iterateSimple$6 = iterateSimple$7;
var SetHelpers$5 = setHelpers;

var Set$3 = SetHelpers$5.Set;
var SetPrototype = SetHelpers$5.proto;
var forEach = uncurryThis(SetPrototype.forEach);
var keys = uncurryThis(SetPrototype.keys);
var next = keys(new Set$3()).next;

var setIterate = function (set, fn, interruptible) {
  return interruptible ? iterateSimple$6({ iterator: keys(set), next: next }, fn) : forEach(set, fn);
};

var SetHelpers$4 = setHelpers;
var iterate$1 = setIterate;

var Set$2 = SetHelpers$4.Set;
var add$3 = SetHelpers$4.add;

var setClone = function (set) {
  var result = new Set$2();
  iterate$1(set, function (it) {
    add$3(result, it);
  });
  return result;
};

var uncurryThisAccessor = functionUncurryThisAccessor;
var SetHelpers$3 = setHelpers;

var setSize = uncurryThisAccessor(SetHelpers$3.proto, 'size', 'get') || function (set) {
  return set.size;
};

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
var getIteratorDirect$1 = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};

var aCallable = aCallable$9;
var anObject = anObject$f;
var call = functionCall;
var toIntegerOrInfinity = toIntegerOrInfinity$5;
var getIteratorDirect = getIteratorDirect$1;

var INVALID_SIZE = 'Invalid size';
var $RangeError = RangeError;
var $TypeError = TypeError;
var max = Math.max;

var SetRecord = function (set, intSize) {
  this.set = set;
  this.size = max(intSize, 0);
  this.has = aCallable(set.has);
  this.keys = aCallable(set.keys);
};

SetRecord.prototype = {
  getIterator: function () {
    return getIteratorDirect(anObject(call(this.keys, this.set)));
  },
  includes: function (it) {
    return call(this.has, this.set, it);
  }
};

// `GetSetRecord` abstract operation
// https://tc39.es/proposal-set-methods/#sec-getsetrecord
var getSetRecord$7 = function (obj) {
  anObject(obj);
  var numSize = +obj.size;
  // NOTE: If size is undefined, then numSize will be NaN
  // eslint-disable-next-line no-self-compare -- NaN check
  if (numSize !== numSize) throw new $TypeError(INVALID_SIZE);
  var intSize = toIntegerOrInfinity(numSize);
  if (intSize < 0) throw new $RangeError(INVALID_SIZE);
  return new SetRecord(obj, intSize);
};

var aSet$6 = aSet$7;
var SetHelpers$2 = setHelpers;
var clone$2 = setClone;
var size$4 = setSize;
var getSetRecord$6 = getSetRecord$7;
var iterateSet$2 = setIterate;
var iterateSimple$5 = iterateSimple$7;

var has$4 = SetHelpers$2.has;
var remove$1 = SetHelpers$2.remove;

// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
var setDifference = function difference(other) {
  var O = aSet$6(this);
  var otherRec = getSetRecord$6(other);
  var result = clone$2(O);
  if (size$4(O) <= otherRec.size) iterateSet$2(O, function (e) {
    if (otherRec.includes(e)) remove$1(result, e);
  });
  else iterateSimple$5(otherRec.getIterator(), function (e) {
    if (has$4(O, e)) remove$1(result, e);
  });
  return result;
};

var getBuiltIn = getBuiltIn$9;

var createSetLike = function (size) {
  return {
    size: size,
    has: function () {
      return false;
    },
    keys: function () {
      return {
        next: function () {
          return { done: true };
        }
      };
    }
  };
};

var setMethodAcceptSetLike$7 = function (name) {
  var Set = getBuiltIn('Set');
  try {
    new Set()[name](createSetLike(0));
    try {
      // late spec change, early WebKit ~ Safari 17.0 beta implementation does not pass it
      // https://github.com/tc39/proposal-set-methods/pull/88
      new Set()[name](createSetLike(-1));
      return false;
    } catch (error2) {
      return true;
    }
  } catch (error) {
    return false;
  }
};

var $$6 = _export;
var difference = setDifference;
var setMethodAcceptSetLike$6 = setMethodAcceptSetLike$7;

// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
$$6({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike$6('difference') }, {
  difference: difference
});

var aSet$5 = aSet$7;
var SetHelpers$1 = setHelpers;
var size$3 = setSize;
var getSetRecord$5 = getSetRecord$7;
var iterateSet$1 = setIterate;
var iterateSimple$4 = iterateSimple$7;

var Set$1 = SetHelpers$1.Set;
var add$2 = SetHelpers$1.add;
var has$3 = SetHelpers$1.has;

// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
var setIntersection = function intersection(other) {
  var O = aSet$5(this);
  var otherRec = getSetRecord$5(other);
  var result = new Set$1();

  if (size$3(O) > otherRec.size) {
    iterateSimple$4(otherRec.getIterator(), function (e) {
      if (has$3(O, e)) add$2(result, e);
    });
  } else {
    iterateSet$1(O, function (e) {
      if (otherRec.includes(e)) add$2(result, e);
    });
  }

  return result;
};

var $$5 = _export;
var fails = fails$o;
var intersection = setIntersection;
var setMethodAcceptSetLike$5 = setMethodAcceptSetLike$7;

var INCORRECT = !setMethodAcceptSetLike$5('intersection') || fails(function () {
  // eslint-disable-next-line es/no-array-from, es/no-set -- testing
  return String(Array.from(new Set([1, 2, 3]).intersection(new Set([3, 2])))) !== '3,2';
});

// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
$$5({ target: 'Set', proto: true, real: true, forced: INCORRECT }, {
  intersection: intersection
});

var aSet$4 = aSet$7;
var has$2 = setHelpers.has;
var size$2 = setSize;
var getSetRecord$4 = getSetRecord$7;
var iterateSet = setIterate;
var iterateSimple$3 = iterateSimple$7;
var iteratorClose$1 = iteratorClose$3;

// `Set.prototype.isDisjointFrom` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
var setIsDisjointFrom = function isDisjointFrom(other) {
  var O = aSet$4(this);
  var otherRec = getSetRecord$4(other);
  if (size$2(O) <= otherRec.size) return iterateSet(O, function (e) {
    if (otherRec.includes(e)) return false;
  }, true) !== false;
  var iterator = otherRec.getIterator();
  return iterateSimple$3(iterator, function (e) {
    if (has$2(O, e)) return iteratorClose$1(iterator, 'normal', false);
  }) !== false;
};

var $$4 = _export;
var isDisjointFrom = setIsDisjointFrom;
var setMethodAcceptSetLike$4 = setMethodAcceptSetLike$7;

// `Set.prototype.isDisjointFrom` method
// https://github.com/tc39/proposal-set-methods
$$4({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike$4('isDisjointFrom') }, {
  isDisjointFrom: isDisjointFrom
});

var aSet$3 = aSet$7;
var size$1 = setSize;
var iterate = setIterate;
var getSetRecord$3 = getSetRecord$7;

// `Set.prototype.isSubsetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
var setIsSubsetOf = function isSubsetOf(other) {
  var O = aSet$3(this);
  var otherRec = getSetRecord$3(other);
  if (size$1(O) > otherRec.size) return false;
  return iterate(O, function (e) {
    if (!otherRec.includes(e)) return false;
  }, true) !== false;
};

var $$3 = _export;
var isSubsetOf = setIsSubsetOf;
var setMethodAcceptSetLike$3 = setMethodAcceptSetLike$7;

// `Set.prototype.isSubsetOf` method
// https://github.com/tc39/proposal-set-methods
$$3({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike$3('isSubsetOf') }, {
  isSubsetOf: isSubsetOf
});

var aSet$2 = aSet$7;
var has$1 = setHelpers.has;
var size = setSize;
var getSetRecord$2 = getSetRecord$7;
var iterateSimple$2 = iterateSimple$7;
var iteratorClose = iteratorClose$3;

// `Set.prototype.isSupersetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
var setIsSupersetOf = function isSupersetOf(other) {
  var O = aSet$2(this);
  var otherRec = getSetRecord$2(other);
  if (size(O) < otherRec.size) return false;
  var iterator = otherRec.getIterator();
  return iterateSimple$2(iterator, function (e) {
    if (!has$1(O, e)) return iteratorClose(iterator, 'normal', false);
  }) !== false;
};

var $$2 = _export;
var isSupersetOf = setIsSupersetOf;
var setMethodAcceptSetLike$2 = setMethodAcceptSetLike$7;

// `Set.prototype.isSupersetOf` method
// https://github.com/tc39/proposal-set-methods
$$2({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike$2('isSupersetOf') }, {
  isSupersetOf: isSupersetOf
});

var aSet$1 = aSet$7;
var SetHelpers = setHelpers;
var clone$1 = setClone;
var getSetRecord$1 = getSetRecord$7;
var iterateSimple$1 = iterateSimple$7;

var add$1 = SetHelpers.add;
var has = SetHelpers.has;
var remove = SetHelpers.remove;

// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
var setSymmetricDifference = function symmetricDifference(other) {
  var O = aSet$1(this);
  var keysIter = getSetRecord$1(other).getIterator();
  var result = clone$1(O);
  iterateSimple$1(keysIter, function (e) {
    if (has(O, e)) remove(result, e);
    else add$1(result, e);
  });
  return result;
};

var $$1 = _export;
var symmetricDifference = setSymmetricDifference;
var setMethodAcceptSetLike$1 = setMethodAcceptSetLike$7;

// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
$$1({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike$1('symmetricDifference') }, {
  symmetricDifference: symmetricDifference
});

var aSet = aSet$7;
var add = setHelpers.add;
var clone = setClone;
var getSetRecord = getSetRecord$7;
var iterateSimple = iterateSimple$7;

// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
var setUnion = function union(other) {
  var O = aSet(this);
  var keysIter = getSetRecord(other).getIterator();
  var result = clone(O);
  iterateSimple(keysIter, function (it) {
    add(result, it);
  });
  return result;
};

var $ = _export;
var union = setUnion;
var setMethodAcceptSetLike = setMethodAcceptSetLike$7;

// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('union') }, {
  union: union
});

const zoomAnimationStyle = /*#__PURE__*/css(["&.ws-modal-new-unstable-zoom-enter,&.ws-modal-new-unstable-zoom-appear{opacity:0;animation-duration:0.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(0.08,0.82,0.17,1);animation-play-state:paused;}&.ws-modal-new-unstable-zoom-leave{animation-duration:0.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(0.6,0.04,0.98,0.34);animation-play-state:paused;}&.ws-modal-new-unstable-zoom-enter.ws-modal-new-unstable-zoom-enter-active,&.ws-modal-new-unstable-zoom-appear.ws-modal-new-unstable-zoom-appear-active{animation-name:wsModalZoomIn;animation-play-state:running;}&.ws-modal-new-unstable-zoom-leave.ws-modal-new-unstable-zoom-leave-active{animation-name:wsModalZoomOut;animation-play-state:running;}@keyframes wsModalZoomIn{0%{opacity:0;transform:scale(0,0);}100%{opacity:1;transform:scale(1,1);}}@keyframes wsModalZoomOut{0%{transform:scale(1,1);}100%{opacity:0;transform:scale(0,0);}}"]);
const fadeAnimationStyle = /*#__PURE__*/css([".ws-modal-new-unstable-fade-enter,.ws-modal-new-unstable-fade-appear{opacity:0;animation-duration:0.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(0.55,0,0.55,0.2);animation-play-state:paused;}.ws-modal-new-unstable-fade-leave{animation-duration:0.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(0.55,0,0.55,0.2);animation-play-state:paused;}.ws-modal-new-unstable-fade-enter.ws-modal-new-unstable-fade-enter-active,.ws-modal-new-unstable-fade-appear.ws-modal-new-unstable-fade-appear-active{animation-name:wsModalFadeIn;animation-play-state:running;}.ws-modal-new-unstable-fade-leave.ws-modal-new-unstable-fade-leave-active{animation-name:wsModalFadeOut;animation-play-state:running;}@keyframes wsModalFadeIn{0%{opacity:0;}100%{opacity:1;}}@keyframes wsModalFadeOut{0%{opacity:1;}100%{opacity:0;}}"]);
const slideUpAnimationStyle = /*#__PURE__*/css([".ws-modal-new-unstable-slide-up-enter,.ws-modal-new-unstable-slide-up-appear{transform:translateY(100%);animation-duration:0.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(0.55,0,0.55,0.2);animation-play-state:paused;}.ws-modal-new-unstable-slide-up-leave{animation-duration:0.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(0.55,0,0.55,0.2);animation-play-state:paused;}.ws-modal-new-unstable-slide-up-enter.ws-modal-new-unstable-slide-up-enter-active,.ws-modal-new-unstable-slide-up-appear.ws-modal-new-unstable-slide-up-appear-active{animation-name:wsModalSlideUpIn;animation-play-state:running;}.ws-modal-new-unstable-slide-up-leave.ws-modal-new-unstable-slide-up-leave-active{animation-name:wsModalSlideUpOut;animation-play-state:running;}@keyframes wsModalSlideUpIn{0%{transform:translateY(100%);}100%{transform:translateY(0);}}@keyframes wsModalSlideUpOut{0%{transform:translateY(0);}100%{transform:translateY(100%);}}"]);
/** Global style code coverage is ignored by jest somehow */
const WsModalGlobalStyle = /*#__PURE__*/createGlobalStyle(({
  theme: propTheme
}) => {
  /* istanbul ignore next */
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  /* istanbul ignore next */
  return css([".ws-modal-new-unstable-mask{position:fixed;top:0;right:0;left:0;bottom:0;background-color:", ";height:100%;filter:opacity(0.45);z-index:", ";}.ws-modal-new-unstable-mask-hidden{display:none;}.ws-modal-new-unstable-wrap{position:fixed;overflow:auto;top:0;right:0;bottom:0;left:0;z-index:", ";-webkit-overflow-scrolling:touch;outline:0;display:flex;justify-content:center;align-items:center;}", " ", " ", ""], theme$1.colors.gray1000, theme$1.zIndex.modal, theme$1.zIndex.modal, zoomAnimationStyle, fadeAnimationStyle, slideUpAnimationStyle);
});
const ModalNew$2 = /*#__PURE__*/styled(Dialog).withConfig({
  displayName: "modal-newstyle__ModalNew",
  componentId: "sc-1tqv8bs-0"
})(props => {
  const {
    $type,
    paddingX = 20,
    paddingY = 20,
    contentGap = 20,
    headerBorder,
    headerShadow,
    footerBorder,
    footerShadow,
    contentCentered,
    theme: propTheme,
    height,
    $width = 760,
    $maxHeight,
    contentBgColor = 'white',
    animation,
    hideHeader = false,
    closable = false
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return css(["", " .ws-modal-new-unstable-close{position:absolute;background-color:transparent;", " ", " z-index:2;cursor:pointer;}.ws-modal-new-unstable-content{", " display:flex;flex-direction:column;", " position:relative;background-color:", ";border-radius:", ";", " overflow:hidden;box-shadow:0 3px 9px #00000080;background-clip:padding-box;outline:0;.ws-modal-new-unstable-header,.ws-modal-new-unstable-footer{width:100%;flex:0 0 auto;background-color:white;}.ws-modal-new-unstable-header{", "}.ws-modal-new-unstable-title{", "}.ws-modal-new-unstable-body{width:100%;flex:1 1 auto;overflow-y:auto;display:flex;}", " ", " ", " ", " .ws-modal-new-unstable-header{", " ", " z-index:1;}.ws-modal-new-unstable-footer{", " ", " z-index:1;}}"], $type === 'wizard' ? css(["position:fixed;top:20px;right:0;bottom:0;left:0;overflow:hidden;z-index:", ";"], theme$1.zIndex.modal) : css(["position:relative;", ""], mapResponsiveStyleProp($width, v => `width: ${theme$1.getSpacing(v)};`)), mapResponsiveStyleProp(paddingY, v => `top: ${theme$1.getSpacing(v)};`), mapResponsiveStyleProp(paddingX, v => `right: ${theme$1.getSpacing(v)};`), height != null && `height: 100%;`, $maxHeight != null && mapResponsiveStyleProp($maxHeight, v => `max-height: ${theme$1.getSpacing(v)};`), theme$1.getColor(contentBgColor), theme$1.borderRadius.containers, animation === 'slide-up' && css(["border-bottom-left-radius:0;border-bottom-right-radius:0;"]), hideHeader && `display: none;`, closable && `padding-right: 36px;`, contentCentered && css(["display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;.ws-modal-new-unstable-header,.ws-modal-new-unstable-body,.ws-modal-new-unstable-footer,.ws-modal-new-unstable-title{display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;gap:20px;}"]), mapResponsiveStyleProp(paddingX, v => `
            .ws-modal-new-unstable-header,
            .ws-modal-new-unstable-footer {
              padding-left: ${theme$1.getSpacing(v)};
              padding-right: ${theme$1.getSpacing(v)};
            }
          `), mapResponsiveStyleProp(paddingY, v => `
            .ws-modal-new-unstable-header {
              padding-top: ${theme$1.getSpacing(v)};
            }
            .ws-modal-new-unstable-footer {
              padding-bottom: ${theme$1.getSpacing(v)};
            }
          `), mapResponsiveStyleProp(contentGap, v => `
            .ws-modal-new-unstable-header {
              padding-bottom: ${theme$1.getSpacing(v)};
            }
            .ws-modal-new-unstable-footer {
              padding-top: ${theme$1.getSpacing(v)};
            }
          `), headerBorder && `border-bottom: 1px solid ${theme$1.colors.gray400};`, headerShadow && `box-shadow: ${theme$1.boxShadows.tmp_modalHeader};`, footerBorder && `border-top: 1px solid ${theme$1.colors.gray400};`, footerShadow && `box-shadow: ${theme$1.boxShadows.tmp_modalFooter};`);
});
const ModalNewActions = /*#__PURE__*/styled(FlexBox).attrs({
  alignItems: 'center',
  flexDirection: 'row-reverse',
  gap: 20
}).withConfig({
  displayName: "modal-newstyle__ModalNewActions",
  componentId: "sc-1tqv8bs-1"
})([""]);
const ModalNewS = {
  ModalNew: ModalNew$2,
  ModalNewActions,
  WsModalGlobalStyle
};

var _a, _b;
// Copied from rc-util https://www.npmjs.com/package/rc-util#domcanusedom
/* istanbul ignore next */
function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
const defaultPropsByVariant$3 = {
  task: {
    width: 760,
    headerBorder: true,
    showNext: true,
    showPrev: true,
    showCancel: true,
    closable: true,
    animation: 'zoom',
    maskAnimation: 'fade',
    $maxHeight: '84vh'
  },
  confirm: {
    width: 620,
    height: 440,
    paddingX: 40,
    paddingY: 32,
    showOk: true,
    contentCentered: true,
    closable: true,
    animation: 'zoom',
    maskAnimation: 'fade',
    // This height is still debatable
    $maxHeight: '84vh'
  },
  'quick-action': {
    width: 600,
    paddingX: 40,
    paddingY: 32,
    showOk: true,
    showCancel: true,
    actionsJustifyContent: 'flex-start',
    closable: true,
    animation: 'zoom',
    maskAnimation: 'fade',
    // This height is still debatable
    $maxHeight: '84vh'
  },
  'task-wizard': {
    $type: 'wizard',
    width: '100vw',
    height: '100%',
    paddingX: 40,
    paddingY: 17,
    actionsPosition: 'header-right',
    showOk: true,
    showCancel: true,
    okText: 'Confirm',
    titleVariant: 'h1',
    contentBgColor: 'surfaceBackground',
    animation: 'slide-up',
    maskAnimation: 'fade',
    maskClosable: false
  }
};
let mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
const getClickPosition = e => {
  mousePosition = {
    x: e.pageX,
    y: e.pageY
  };
  // 100ms 内发生过点击事件，则从点击位置动画展示
  // 否则直接 zoom 展示
  // 这样可以兼容非点击方式展开
  setTimeout(() => {
    /* istanbul ignore next */
    mousePosition = null;
  }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
/* istanbul ignore next */
if (canUseDom()) {
  (_b = (_a = window.document.documentElement) === null || _a === void 0 ? void 0 : _a.addEventListener) === null || _b === void 0 ? void 0 : _b.call(_a, 'click', getClickPosition, true);
}

const DEFAULT_HEIGHT_TRANSITION = 'height 0.3s ease-in-out';
const HeightTransitionWrapper = ({
  children,
  enabled,
  transition: _transition = DEFAULT_HEIGHT_TRANSITION
}) => {
  var _a;
  const ref = useRef(null);
  const size = useSize(ref);
  if (!enabled) {
    return children;
  }
  return jsx("div", {
    style: {
      height: (_a = size === null || size === void 0 ? void 0 : size.height) !== null && _a !== void 0 ? _a : 'auto',
      transition: _transition
    },
    children: jsx("div", {
      ref: ref,
      children: children
    })
  });
};

function isThenable(thing) {
  return !!(thing && !!thing.then);
}
const ActionButton = props => {
  const [loading, setLoading] = React__default.useState(false);
  const handleClick = e => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const possiblePromise = (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
    if (typeof possiblePromise !== 'object' || !isThenable(possiblePromise)) {
      return;
    }
    setLoading(true);
    yield possiblePromise;
    setLoading(false);
  });
  return jsx(ButtonNew
  // pseudo element :before is not testable in jest, add this attribute to test loading state
  , Object.assign({
    "data-loading": loading,
    minWidth: 100,
    loading: loading
  }, props, {
    onClick: handleClick
  }));
};

const useScrollStatus = props => {
  var _a, _b;
  useStaticPropsGuard(props, ['ref'], 'useScrollStatus');
  const borderOffset = (_a = props === null || props === void 0 ? void 0 : props.borderOffset) !== null && _a !== void 0 ? _a : 5;
  // props.ref is guaranteed to be defined/undefined by the useStaticPropsGuard
  /* eslint-disable-next-line react-hooks/rules-of-hooks */
  const elementRef = (_b = props === null || props === void 0 ? void 0 : props.ref) !== null && _b !== void 0 ? _b : useRef(null);
  const [hasScrollbarX, setHasScrollbarX] = useState(false);
  const [hasScrollbarY, setHasScrollbarY] = useState(false);
  const [scrollbarAtTop, setScrollbarAtTop] = useState(true);
  const [scrollbarAtBottom, setScrollbarAtBottom] = useState(false);
  const [scrollbarAtLeft, setScrollbarAtLeft] = useState(true);
  const [scrollbarAtRight, setScrollbarAtRight] = useState(false);
  const checkScrollStatus = useCallback(() => {
    const element = elementRef.current;
    if (element) {
      setHasScrollbarX(element.scrollWidth > element.clientWidth);
      setHasScrollbarY(element.scrollHeight > element.clientHeight);
      setScrollbarAtTop(element.scrollTop < borderOffset);
      setScrollbarAtBottom(element.scrollHeight - element.scrollTop <= element.clientHeight + borderOffset);
      setScrollbarAtLeft(element.scrollLeft < borderOffset);
      setScrollbarAtRight(element.scrollWidth - element.scrollLeft <= element.clientWidth + borderOffset);
    }
  }, [borderOffset, elementRef]);
  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    checkScrollStatus();
    const resizeObserver = new ResizeObserver(checkScrollStatus);
    element.addEventListener('scroll', checkScrollStatus);
    resizeObserver.observe(element);
    return () => {
      resizeObserver.unobserve(element);
      element.removeEventListener('scroll', checkScrollStatus);
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [checkScrollStatus, elementRef.current]);
  const refCallback = useCallback(node => {
    if (node) {
      elementRef.current = node;
      checkScrollStatus();
    }
  }, [checkScrollStatus, elementRef]);
  return {
    ref: refCallback,
    hasX: hasScrollbarX,
    hasY: hasScrollbarY,
    hasScrollbar: hasScrollbarX || hasScrollbarY,
    atTop: scrollbarAtTop,
    atBottom: scrollbarAtBottom,
    atLeft: scrollbarAtLeft,
    atRight: scrollbarAtRight
  };
};

/**
 * ModalNew
 */
const ModalNew$1 = props => {
  var _a, _b, _c, _d, _e, _f, _g;
  const [stateVisible, setStateVisible] = React__default.useState(props.initialVisible);
  const {
    variant = 'confirm',
    $type = 'modal'
  } = props;
  const contentRef = React__default.useRef(null);
  const scrollStatus = useScrollStatus({
    ref: contentRef
  });
  const mergedProps = defaults(Object.assign({}, props), defaultPropsByVariant$3[variant]);
  const {
      visible = stateVisible,
      onVisibleChange = setStateVisible,
      onClose,
      title,
      subtitle,
      message,
      trigger,
      okText = 'Submit',
      cancelText = 'Cancel',
      prevText = 'Back',
      nextText = 'Next',
      okButton,
      cancelButton,
      prevButton,
      nextButton,
      onOk,
      okButtonProps,
      onCancel,
      cancelButtonProps,
      onPrev,
      prevButtonProps,
      onNext,
      nextButtonProps,
      showOk = !!onOk || !!okButton || !!okButtonProps,
      showCancel = !!onCancel || !!cancelButton || !!cancelButtonProps,
      showPrev = !!onPrev || !!prevButton || !!prevButtonProps,
      showNext = !!onNext || !!nextButton || !!nextButtonProps,
      children,
      actionsPosition = 'footer',
      titleVariant = 'h3',
      header,
      hideHeader = false,
      formProps,
      formId = formProps === null || formProps === void 0 ? void 0 : formProps.id,
      onSubmit,
      asForm = !!formId,
      contentMaxHeight,
      contentProps,
      isHeightTransitionEnabled = false
    } = mergedProps,
    styleProps = __rest(mergedProps, ["visible", "onVisibleChange", "onClose", "title", "subtitle", "message", "trigger", "okText", "cancelText", "prevText", "nextText", "okButton", "cancelButton", "prevButton", "nextButton", "onOk", "okButtonProps", "onCancel", "cancelButtonProps", "onPrev", "prevButtonProps", "onNext", "nextButtonProps", "showOk", "showCancel", "showPrev", "showNext", "children", "actionsPosition", "titleVariant", "header", "hideHeader", "formProps", "formId", "onSubmit", "asForm", "contentMaxHeight", "contentProps", "isHeightTransitionEnabled"]);
  const handleCloseMarkClick = e => __awaiter(void 0, void 0, void 0, function* () {
    const newVisible = yield onClose === null || onClose === void 0 ? void 0 : onClose(e);
    onVisibleChange(!!newVisible);
  });
  const handleCancelButtonClick = e => __awaiter(void 0, void 0, void 0, function* () {
    var _h;
    const newVisible = yield (_h = onCancel !== null && onCancel !== void 0 ? onCancel : cancelButtonProps === null || cancelButtonProps === void 0 ? void 0 : cancelButtonProps.onClick) === null || _h === void 0 ? void 0 : _h(e);
    onVisibleChange(!!newVisible);
  });
  const handleOkButtonClick = e => __awaiter(void 0, void 0, void 0, function* () {
    var _j;
    const newVisible = yield (_j = onOk !== null && onOk !== void 0 ? onOk : okButtonProps === null || okButtonProps === void 0 ? void 0 : okButtonProps.onClick) === null || _j === void 0 ? void 0 : _j(e);
    onVisibleChange(!!newVisible);
  });
  const {
    contentCentered,
    actionsJustifyContent,
    closable
  } = styleProps;
  const actionsElement = jsxs(ModalNewS.ModalNewActions, {
    justifyContent: actionsJustifyContent !== null && actionsJustifyContent !== void 0 ? actionsJustifyContent : contentCentered ? 'center' : 'space-between',
    children: [jsxs(FlexBox, {
      gap: 12,
      children: [(_a = showPrev && prevButton) !== null && _a !== void 0 ? _a : jsx(ActionButton, Object.assign({
        variant: "secondary"
      }, prevButtonProps, {
        onClick: onPrev !== null && onPrev !== void 0 ? onPrev : prevButtonProps === null || prevButtonProps === void 0 ? void 0 : prevButtonProps.onClick,
        children: prevText
      })), (_b = showNext && nextButton) !== null && _b !== void 0 ? _b : jsx(ActionButton, Object.assign({
        variant: "primary"
      }, asForm ? {
        htmlType: 'submit',
        form: formId
      } : {}, nextButtonProps, {
        onClick: onNext !== null && onNext !== void 0 ? onNext : nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.onClick,
        children: nextText
      })), (_c = showOk && okButton) !== null && _c !== void 0 ? _c : jsx(ActionButton, Object.assign({
        variant: "primary"
      }, asForm ? {
        htmlType: 'submit',
        form: formId
      } : {}, okButtonProps, {
        onClick: handleOkButtonClick,
        children: okText
      }))]
    }), (_d = showCancel && cancelButton) !== null && _d !== void 0 ? _d : jsx(ActionButton, Object.assign({
      variant: "secondary"
    }, cancelButtonProps, {
      onClick: handleCancelButtonClick,
      children: cancelText
    }))]
  });
  return jsxs(Fragment, {
    children: [trigger && /*#__PURE__*/React__default.cloneElement(trigger, {
      onClick: () => {
        var _a, _b;
        onVisibleChange(!visible);
        (_b = (_a = trigger.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
      }
    }), jsx(ModalNewS.ModalNew, Object.assign({
      visible: visible,
      onClose: handleCloseMarkClick,
      variant: variant,
      "$type": $type,
      // Use ws-modal-new-unstable because ws-modal is used by modal.css
      // TODO: change to ws-modal when modal.css is removed
      prefixCls: "ws-modal-new-unstable",
      title: header !== undefined ? header : jsxs(Fragment, {
        children: [variant === 'confirm' && jsx(FlexBox, {
          align: "center",
          justify: "center",
          width: 60,
          height: 60,
          borderRadius: "chips",
          bgColor: "green200",
          marginY: 20,
          children: jsx(Checkmark, {
            color: "green600"
          })
        }), jsxs(FlexBox, {
          justifyContent: "space-between",
          align: "center",
          children: [jsxs("div", {
            children: [jsx(Typography, {
              variant: titleVariant,
              children: title
            }), subtitle && jsx(Typography, {
              variant: "body",
              color: "textSecondary",
              children: subtitle
            })]
          }), actionsPosition === 'header-right' && actionsElement]
        })]
      }),
      closeIcon: closable && jsx(Cross, {
        color: "iconDefault"
      }),
      footer: actionsPosition === 'footer' && actionsElement,
      mousePosition: mousePosition
    }, styleProps, {
      headerShadow: (_e = styleProps.headerShadow) !== null && _e !== void 0 ? _e : scrollStatus.hasY && !scrollStatus.atTop,
      footerShadow: (_f = styleProps.footerShadow) !== null && _f !== void 0 ? _f : scrollStatus.hasY && !scrollStatus.atBottom,
      hideHeader: hideHeader,
      children: jsx(FlexBox, Object.assign({
        ref: scrollStatus.ref,
        style: {
          overflowY: 'auto'
        },
        flex: "1 1 auto",
        width: "100%",
        column: true,
        px: (_g = styleProps.paddingX) !== null && _g !== void 0 ? _g : 20
      }, asForm ? Object.assign({
        as: 'form',
        id: formId,
        onSubmit
      }, omit(formProps, ['formId', 'color'])) : {}, contentProps, {
        maxHeight: contentMaxHeight !== null && contentMaxHeight !== void 0 ? contentMaxHeight : contentProps === null || contentProps === void 0 ? void 0 : contentProps.maxHeight,
        children: jsx(HeightTransitionWrapper, {
          enabled: isHeightTransitionEnabled,
          children: children !== null && children !== void 0 ? children : message && jsx(Typography, {
            variant: "body",
            marginY: 20,
            textWrap: "balance",
            children: message
          })
        })
      }))
    })), jsx(ModalNewS.WsModalGlobalStyle, {})]
  });
};

const destroyFuncSet = new Set();
function modalConfirm(modalFuncOptions) {
  let promiseResolve = () => {
    /* istanbul ignore next */
    throw new Error('[modalConfirm] promiseResolve is called before initialized');
  };
  const promise = new Promise(resolve => {
    promiseResolve = resolve;
  });
  const container = document.createDocumentFragment();
  let currentOptions = Object.assign(Object.assign({
    variant: 'quick-action'
  }, modalFuncOptions), {
    onClose: e => {
      var _a;
      setVisibleFalse();
      promiseResolve === null || promiseResolve === void 0 ? void 0 : promiseResolve(false);
      return (_a = modalFuncOptions.onClose) === null || _a === void 0 ? void 0 : _a.call(modalFuncOptions, e);
    },
    onOk: e => {
      var _a;
      promiseResolve === null || promiseResolve === void 0 ? void 0 : promiseResolve(true);
      return (_a = modalFuncOptions.onOk) === null || _a === void 0 ? void 0 : _a.call(modalFuncOptions, e);
    },
    onCancel: e => {
      var _a;
      promiseResolve === null || promiseResolve === void 0 ? void 0 : promiseResolve(false);
      return (_a = modalFuncOptions.onCancel) === null || _a === void 0 ? void 0 : _a.call(modalFuncOptions, e);
    },
    initialVisible: true
  });
  function destroy(destroyOptions) {
    var _a;
    if (destroyOptions.triggerCancel) {
      (_a = modalFuncOptions.onCancel) === null || _a === void 0 ? void 0 : _a.call(modalFuncOptions, destroyOptions.event);
    }
    if (destroyFuncSet.has(setVisibleFalse)) {
      destroyFuncSet.delete(setVisibleFalse);
      return;
    }
    unmount(container);
  }
  let timeoutId;
  function render$1(props) {
    clearTimeout(timeoutId);
    /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */
    timeoutId = setTimeout(() => {
      render(jsx(ThemeProvider, {
        theme: theme,
        children: jsx(ModalNew$1, Object.assign({}, props))
      }), container);
    });
  }
  function setVisibleFalse(destroyOptions = {}) {
    currentOptions = Object.assign(Object.assign({}, currentOptions), {
      visible: false,
      afterClose: () => {
        var _a;
        (_a = modalFuncOptions.afterClose) === null || _a === void 0 ? void 0 : _a.call(modalFuncOptions);
        destroy.call(this, destroyOptions);
      }
    });
    render$1(currentOptions);
  }
  function updateOptions(configUpdate) {
    if (typeof configUpdate === 'function') {
      currentOptions = configUpdate(currentOptions);
    } else {
      currentOptions = Object.assign(Object.assign({}, currentOptions), configUpdate);
    }
    render$1(currentOptions);
  }
  render$1(currentOptions);
  destroyFuncSet.add(setVisibleFalse);
  Object.assign(promise, {
    destroy: setVisibleFalse,
    update: updateOptions
  });
  return promise;
}

const ModalNew = ModalNew$1;
ModalNew.confirm = modalConfirm;

const defaultPropsByVariant$2 = {
  primary: {
    size: 'large',
    tabBarGutter: 20
  },
  secondary: {
    size: 'small',
    tabBarGutter: 0
  }
};
const navButtonSize = 30;
const navButtonIconSize = 19.5;

const Tabs$1 = /*#__PURE__*/styled(FlexBox).withConfig({
  displayName: "tabsstyle__Tabs",
  componentId: "sc-1wjzzgw-0"
})(props => {
  const {
    theme: propTheme
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return css(["width:100%;.Tabs-nav-list{width:100%;position:relative;.Tabs-nav-scroller{width:100%;overflow:auto hidden;white-space:nowrap;::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;}.Tabs-nav-buttons-left,.Tabs-nav-buttons-right{position:absolute;top:50%;transform:translateY(-50%);z-index:1;height:100%;background:white;color:", ";display:flex;cursor:pointer;align-items:center;> button{transform:translateY(-1px);width:", "px;height:", "px;border-radius:500px;box-shadow:0px 1px 4px rgba(0,0,0,0.18),0px 2px 8px rgba(0,0,0,0.08);display:flex;align-items:center;justify-content:center;}}.Tabs-nav-buttons-left{left:0;}.Tabs-nav-buttons-right{right:0;}}"], theme$1.colors.gray800, navButtonSize, navButtonSize);
});
const TabNode$1 = /*#__PURE__*/styled(FlexBox).withConfig({
  displayName: "tabsstyle__TabNode",
  componentId: "sc-1wjzzgw-1"
})(props => {
  const {
    size = 'large',
    active,
    theme: propTheme,
    disabled,
    hovered,
    focused
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  const cssStyleByStatus = {
    active: css(["border-color:", ";color:", ";"], theme$1.colors.blue500, theme$1.getColor('textPrimary')),
    hovered: css(["color:", ";"], theme$1.getColor('textPrimary')),
    disabled: css(["&,&:hover{cursor:not-allowed;color:", ";}"], theme$1.colors.gray400),
    focused: css(["color:", ";background:", ";"], theme$1.colors.gray600, theme$1.colors.gray300)
  };
  return css(["flex-shrink:0;display:inline-block;width:fit-content;padding:", ";min-width:", ";border-bottom:4px solid transparent;text-align:center;cursor:pointer;color:", ";transition-timing-function:ease;transition-property:color,border-color;transition-duration:0.2s,0.3s;> span{display:block;}", " &:focus{", "}", " ", " &:hover{", "}", " &:disabled{", "}"], size === 'large' ? '17px 20px 14px' : '15px 20px 11px', size === 'large' ? '100px' : '80px', theme$1.getColor('textSecondary'), focused === true && cssStyleByStatus.focused, focused !== false && cssStyleByStatus.focused, active && cssStyleByStatus.active, hovered && cssStyleByStatus.hovered, hovered !== false && cssStyleByStatus.hovered, disabled && cssStyleByStatus.disabled, cssStyleByStatus.disabled);
});
const S$4 = {
  Tabs: Tabs$1,
  TabNode: TabNode$1
};

/**
 * TabNode
 */
const TabNode = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      children,
      onClick
    } = props,
    restProps = __rest(props, ["children", "onClick"]);
  const {
    size,
    disabled,
    active
  } = restProps;
  return jsx(S$4.TabNode, Object.assign({}, restProps, {
    as: "button",
    ref: ref,
    onClick: onClick,
    tabIndex: disabled ? undefined : 0,
    role: "tab",
    "aria-selected": active,
    "aria-disabled": disabled,
    onKeyDown: e => {
      // Space or Enter
      if ([' ', 'Enter'].includes(e.key)) {
        e.preventDefault();
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
      }
    },
    children: jsx(Typography, {
      variant: "body",
      fontSize: size === 'large' ? 18 : 14,
      lineHeight: size === 'large' ? '25px' : '20px',
      color: "inherit",
      fontWeight: "semibold",
      children: children
    })
  }));
});

/**
 * TabPanel
 */
const TabPanel = props => {
  throw new Error("[Tabs]: don't call TabPanel without Tabs wrapped.");
};

/**
 * useTabs
 */
const useTabs = props => {
  var _a, _b;
  const {
    variant = 'primary',
    id: propId,
    showNavButtons
  } = props;
  const id = useMemo(() => propId !== null && propId !== void 0 ? propId : v4().slice(-4), [propId]);
  const mergedProps = Object.assign(Object.assign({}, defaultPropsByVariant$2[variant]), props);
  const {
    children: childOrChildren,
    size = 'large'
  } = mergedProps;
  const [usingKeyboard, setUsingKeyboard] = useState(false);
  const children = (Array.isArray(childOrChildren) ? childOrChildren : [childOrChildren]).filter(child => /*#__PURE__*/isValidElement(child) && child.type === TabPanel);
  const tabs = (props.tabs || map(children, ({
    props,
    key
  }) => {
    const tabKey = key;
    return Object.assign(Object.assign({}, props), {
      tabKey,
      size,
      aria: {
        tabId: id && `tabs-${id}-tab-${tabKey}`,
        tabPaneId: id && `tabs-${id}-panel-${tabKey}`
      }
    });
  })).map((_a, index) => {
    var {
        tabKey
      } = _a,
      rest = __rest(_a, ["tabKey"]);
    return Object.assign(Object.assign({}, rest), {
      tabKey: tabKey !== null && tabKey !== void 0 ? tabKey : String(index)
    });
  });
  const defaultActiveKey = (_a = props.defaultActiveKey) !== null && _a !== void 0 ? _a : String(get$1(tabs[0], 'tabKey'));
  const [innerActiveKey, setInnerActiveKey] = useState(defaultActiveKey);
  const activeKey = (_b = props.activeKey) !== null && _b !== void 0 ? _b : innerActiveKey;
  const onChange = key => {
    var _a;
    setInnerActiveKey(key);
    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, key);
  };
  const [navButtonsVisibility, setNavButtonsVisibility] = useState({
    start: false,
    end: false
  });
  const navScrollerRef = useRef(null);
  const [getTabNodeRef] = useRefs();
  const updateNavButtonsVisibility = useCallback(() => {
    if (!showNavButtons || !navScrollerRef.current) return;
    const {
      scrollLeft,
      scrollWidth,
      clientWidth
    } = navScrollerRef.current;
    setNavButtonsVisibility({
      start: scrollLeft !== 0,
      end: scrollWidth - clientWidth - scrollLeft > 0.5
    });
  }, [showNavButtons]);
  useEffect(() => {
    if (!showNavButtons) return;
    updateNavButtonsVisibility();
  }, [showNavButtons, updateNavButtonsVisibility]);
  const debouncedUpdateNavButtonsVisibility = useMemo(() => debounce(updateNavButtonsVisibility, 50), [updateNavButtonsVisibility]);
  const onTabScroll = () => {
    var _a;
    (_a = props.onTabScroll) === null || _a === void 0 ? void 0 : _a.call(props);
    if (!showNavButtons) return;
    debouncedUpdateNavButtonsVisibility();
  };
  const scrollTo = scrollValueOrRange => {
    var _a, _b;
    if (!navScrollerRef.current) return;
    const scrollValue = isNumber(scrollValueOrRange) ? scrollValueOrRange : clamp(navScrollerRef.current.scrollLeft, ...scrollValueOrRange);
    (_b = (_a = navScrollerRef.current).scrollTo) === null || _b === void 0 ? void 0 : _b.call(_a, {
      left: scrollValue,
      behavior: 'smooth'
    });
  };
  const onNavButtonClick = position => {
    if (!navScrollerRef.current) return;
    const {
      scrollLeft,
      clientWidth
    } = navScrollerRef.current;
    if (position === 'start') {
      scrollTo(scrollLeft - clientWidth);
    } else {
      scrollTo(scrollLeft + clientWidth);
    }
  };
  const scrollToTab = useRef((key = activeKey) => {
    const tabNode = getTabNodeRef(key).current;
    if (!tabNode || !navScrollerRef.current) return;
    const {
      clientWidth: scrollWindowWidth,
      scrollWidth
    } = navScrollerRef.current;
    const {
      offsetLeft,
      clientWidth
    } = tabNode;
    scrollTo([Math.max(0, offsetLeft + clientWidth - scrollWindowWidth + navButtonSize), Math.min(scrollWidth, offsetLeft - navButtonSize)]);
  }).current;
  useLayoutEffect(() => {
    scrollToTab();
  }, [scrollToTab]);
  const onTabClick = (tabKey, event) => {
    var _a;
    scrollToTab(tabKey);
    onChange(tabKey);
    (_a = props.onTabClick) === null || _a === void 0 ? void 0 : _a.call(props, tabKey, event);
    if (event.type === 'click') {
      setUsingKeyboard(false);
    }
    if (event.type === 'keyDown') {
      setUsingKeyboard(true);
    }
  };
  return Object.assign(Object.assign({}, mergedProps), {
    id,
    variant,
    activeKey,
    onChange,
    navButtonsVisibility,
    onTabClick,
    tabs,
    navScrollerRef,
    getTabNodeRef,
    onNavButtonClick,
    usingKeyboard,
    setUsingKeyboard,
    onTabScroll
  });
};

/**
 * Tabs
 */
const Tabs = props => {
  useStaticPropsGuard(props, ['variant'], 'Tabs');
  const hookProps = useTabs(props);
  const {
      id,
      className,
      tabs,
      activeKey,
      onChange,
      showNavButtons,
      onTabClick,
      getTabNodeRef,
      navButtonsVisibility,
      navScrollerRef,
      onTabScroll,
      onNavButtonClick,
      usingKeyboard,
      setUsingKeyboard,
      tabBarGutter,
      tabNodeProps: sharedTabNodeProps,
      tabPanelProps: sharedTabPanelProps,
      navScrollerProps,
      contentProps
    } = hookProps,
    restProps = __rest(hookProps, ["id", "className", "tabs", "activeKey", "onChange", "showNavButtons", "onTabClick", "getTabNodeRef", "navButtonsVisibility", "navScrollerRef", "onTabScroll", "onNavButtonClick", "usingKeyboard", "setUsingKeyboard", "tabBarGutter", "tabNodeProps", "tabPanelProps", "navScrollerProps", "contentProps"]);
  return jsxs(S$4.Tabs, Object.assign({
    className: classNames('Tabs', className),
    role: "tablist",
    onKeyDown: e => {
      // Space or Enter
      if (['Tab'].includes(e.key)) {
        setUsingKeyboard(true);
      }
    },
    column: true
  }, restProps, {
    children: [jsxs("div", {
      className: "Tabs-nav-list",
      children: [showNavButtons && navButtonsVisibility.start && jsx("div", {
        className: "Tabs-nav-buttons-left",
        children: jsx("button", {
          onClick: () => onNavButtonClick('start'),
          "data-testid": `tabs-${id}-nav-to-start-btn`,
          children: jsx(ChevronLeft, {
            size: navButtonIconSize
          })
        })
      }), showNavButtons && navButtonsVisibility.end && jsx("div", {
        className: "Tabs-nav-buttons-right",
        onClick: () => onNavButtonClick('end'),
        children: jsx("button", {
          "data-testid": `tabs-${id}-nav-to-end-btn`,
          children: jsx(ChevronRight, {
            size: navButtonIconSize
          })
        })
      }), jsx(FlexBox, Object.assign({
        className: "Tabs-nav-scroller",
        "data-testid": `tabs-${id}-nav-scroller`,
        ref: navScrollerRef,
        onScroll: onTabScroll,
        gap: tabBarGutter
      }, navScrollerProps, {
        children: tabs.map(_a => {
          var {
              tabKey,
              tab,
              aria
            } = _a,
            tabNodeProps = __rest(_a, ["tabKey", "tab", "aria"]);
          return jsx(TabNode, Object.assign({
            active: activeKey === tabKey,
            focused: usingKeyboard === false ? false : undefined,
            id: aria === null || aria === void 0 ? void 0 : aria.tabId,
            "aria-controls": aria === null || aria === void 0 ? void 0 : aria.tabPanelId,
            ref: getTabNodeRef(tabKey)
          }, sharedTabNodeProps, tabNodeProps, {
            onClick: e => {
              var _a;
              onTabClick(tabKey, e);
              (_a = tabNodeProps === null || tabNodeProps === void 0 ? void 0 : tabNodeProps.onClick) === null || _a === void 0 ? void 0 : _a.call(tabNodeProps, e);
            },
            children: tab
          }), tabKey);
        })
      }))]
    }), tabs.some(({
      children
    }) => !!children) && jsx(FlexBox, Object.assign({}, contentProps, {
      children: tabs.map(({
        children,
        tabKey,
        aria
      }) => {
        const active = activeKey === tabKey;
        return jsx(FlexBox, Object.assign({
          id: aria === null || aria === void 0 ? void 0 : aria.tabPanelId,
          role: "tabpanel",
          tabIndex: active ? 0 : -1,
          style: active ? undefined : {
            display: 'none'
          },
          "aria-labelledby": aria === null || aria === void 0 ? void 0 : aria.tabId,
          "aria-hidden": !active,
          display: "block",
          width: "100%",
          py: 20
        }, sharedTabPanelProps, {
          children: active && children
        }), tabKey);
      })
    }))]
  }));
};
Tabs.TabPanel = TabPanel;
Tabs.Tab = TabNode;

const TopNavigation$1 = /*#__PURE__*/styled(Box).withConfig({
  displayName: "top-navigationstyle__TopNavigation",
  componentId: "sc-150ds7y-0"
})(props => {
  const {
    theme: propTheme,
    $shadow
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return css(["width:100%;display:flex;align-items:center;justify-content:space-between;color:", ";background-color:white;height:62px;border-bottom:1px solid ", ";transition:box-shadow 0.3s ease;", ""], theme$1.getColor('textPrimary'), theme$1.colors.gray300, $shadow && `box-shadow: ${theme$1.boxShadows.e3}`);
});
const TopNavigationTitle = /*#__PURE__*/styled.div.withConfig({
  displayName: "top-navigationstyle__TopNavigationTitle",
  componentId: "sc-150ds7y-1"
})(["display:flex;align-items:center;"]);
const TopNavigationBackBtn = /*#__PURE__*/styled.a.withConfig({
  displayName: "top-navigationstyle__TopNavigationBackBtn",
  componentId: "sc-150ds7y-2"
})(props => {
  const {
    theme: propTheme
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return css(["display:flex;align-items:center;justify-content:center;color:", ";&:hover{color:", ";}"], theme$1.colors.gray800, theme$1.colors.gray800);
});
const Action = /*#__PURE__*/styled.div.withConfig({
  displayName: "top-navigationstyle__Action",
  componentId: "sc-150ds7y-3"
})(props => {
  const {
    theme: propTheme
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return css(["width:40px;height:40px;display:flex;border-radius:50%;align-items:center;justify-content:center;&:hover{background-color:", ";}"], theme$1.getColor('gray200'));
});
const ProfileAvatar = /*#__PURE__*/styled.div.withConfig({
  displayName: "top-navigationstyle__ProfileAvatar",
  componentId: "sc-150ds7y-4"
})(props => {
  const {
    theme: propTheme
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return css(["width:30px;height:30px;border-radius:50%;color:white;background:", ";display:flex;align-items:center;justify-content:center;"], theme$1.getColor('gray600'));
});
const TopNavigationS = {
  TopNavigation: TopNavigation$1,
  TopNavigationTitle,
  TopNavigationBackBtn,
  ProfileAvatar,
  Action
};

/**
 * TopNavigation
 */
const TopNavigation = props => {
  const {
      title,
      extra,
      helpMenuItems,
      profileMenuItems,
      helpMenu,
      profileMenu,
      helpDropdown,
      profileDropdown,
      profileTitle,
      backToUrl
    } = props,
    restProps = __rest(props, ["title", "extra", "helpMenuItems", "profileMenuItems", "helpMenu", "profileMenu", "helpDropdown", "profileDropdown", "profileTitle", "backToUrl"]);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);
  return jsxs(TopNavigationS.TopNavigation, Object.assign({
    px: {
      ps: 20,
      t: 34
    },
    "$shadow": scrolled
  }, restProps, {
    children: [jsxs(TopNavigationS.TopNavigationTitle, {
      children: [backToUrl && typeof backToUrl === 'string' && jsx(TopNavigationS.Action, {
        "data-testid": "top-navigation-back-button",
        children: jsx(TopNavigationS.TopNavigationBackBtn, {
          href: backToUrl,
          children: jsx(IconChevronLeft, {})
        })
      }), typeof title === 'string' ? jsx(Typography, {
        variant: "h1",
        children: title
      }) : title]
    }), jsxs(FlexBox, {
      gap: "4px",
      flexDirection: "row-reverse",
      children: [jsx(Dropdown, Object.assign({}, profileDropdown, {
        menu: Object.assign(Object.assign({
          $width: 240,
          $itemBaseHeight: 40,
          style: {
            marginTop: '6px'
          }
        }, profileMenu), {
          items: profileMenuItems
        }),
        children: jsx(TopNavigationS.Action, {
          "data-testid": "top-navigation-menu-trigger-profile",
          children: jsx(TopNavigationS.ProfileAvatar, {
            children: jsx(Typography, {
              variant: "caption",
              color: "inherit",
              fontWeight: "semibold",
              children: profileTitle
            })
          })
        })
      })), jsx(Dropdown, Object.assign({}, helpDropdown, {
        menu: Object.assign(Object.assign({
          $width: 240,
          $itemBaseHeight: 40,
          style: {
            marginTop: '6px'
          }
        }, helpMenu), {
          items: helpMenuItems
        }),
        children: jsx(TopNavigationS.Action, {
          "data-testid": "top-navigation-menu-trigger-help",
          children: jsx(IconQuestionInfo, {})
        })
      })), React__default.Children.map(ReactIs.isFragment(extra) ? extra.props.children : extra, (child, index) => jsx(TopNavigationS.Action, {
        "data-testid": "top-navigation-menu-trigger-extra",
        children: child
      }, index))]
    })]
  }));
};

const omitPropKeys = ['featureFlag', 'functionModule', 'userPermission', 'renderWsLayoutMenuItem', 'hideWhenConditionMatch', 'upsellOnLite'];
const alwaysTruthy = () => true;
const toArray = function toArray(x) {
  if (typeof x === 'undefined') return [];
  return Array.isArray(x) ? x : [x];
};
const createRenderMenuItem = options => {
  const {
    isFeatureFlagOn = alwaysTruthy,
    companyHasFunctionModule = alwaysTruthy,
    userHasPermission = alwaysTruthy
  } = options;
  return (originalElement, item) => {
    var _a;
    const wsLayoutMenuItemProps = item;
    const renderWsLayoutMenuItem = (_a = wsLayoutMenuItemProps.renderWsLayoutMenuItem) !== null && _a !== void 0 ? _a : options.renderWsLayoutMenuItem;
    const userPermissionKeys = toArray(wsLayoutMenuItemProps.userPermission);
    const functionModuleKeys = toArray(wsLayoutMenuItemProps.functionModule);
    const featureFlagIds = toArray(wsLayoutMenuItemProps.featureFlag);
    const conditionMatch = userPermissionKeys.every(userHasPermission) && functionModuleKeys.every(companyHasFunctionModule) && featureFlagIds.every(isFeatureFlagOn);
    const element = (wsLayoutMenuItemProps.hideWhenConditionMatch ? !conditionMatch : conditionMatch) ? originalElement : null;
    if (!renderWsLayoutMenuItem) return element;
    const featureFlags = mapValues(invert(featureFlagIds), (_index, key) => isFeatureFlagOn(key));
    const functionModules = mapValues(invert(functionModuleKeys), (_index, key) => companyHasFunctionModule(key));
    const userPermissions = mapValues(invert(userPermissionKeys), (_index, key) => userHasPermission(key));
    return renderWsLayoutMenuItem(element, item, {
      originalElement,
      userPermissions,
      functionModules,
      featureFlags
    }) || null;
  };
};

let _ = t => t,
  _t;
const PageLayout = /*#__PURE__*/styled(Layout).attrs({
  variant: 'page'
}).withConfig({
  displayName: "ws-layoutstyle__PageLayout",
  componentId: "sc-1al7e61-0"
})(props => {
  const {
    collapsed,
    $leftNavigationWidth = collapsed ? 68 : 240
  } = props;
  return css(["max-width:100vw;transition:max-width 0.2s ease-in-out;", ""], media.desktopSmall(_t || (_t = _`
      max-width: calc(100vw - ${0}px);
    `), $leftNavigationWidth));
});
const S$3 = {
  PageLayout
};

/**
 * WsLayout
 */
const WsLayout = props => {
  var _a;
  const {
      initialVariant = 'team',
      showLoadingPage = true,
      children,
      leftNavigation,
      topNavigation,
      user,
      isFeatureFlagOn = () => true,
      companyHasFunctionModule = () => true,
      notificationsButton,
      userHasPermission = () => true,
      adminMenuItems,
      teamMenuItems,
      helpMenuItems,
      profileMenuItems,
      renderWsLayoutMenuItem,
      appLayoutProps,
      pageLayoutProps,
      topNavigationProps,
      leftNavigationProps: propLeftNavigationProps,
      loadingPageProps,
      menuItemRenderLabel,
      variant: propVariant,
      onVariantChange: propOnVariantChange,
      $leftNavigationWidth,
      collapsed,
      onCollapsedChange
    } = props,
    restProps = __rest(props, ["initialVariant", "showLoadingPage", "children", "leftNavigation", "topNavigation", "user", "isFeatureFlagOn", "companyHasFunctionModule", "notificationsButton", "userHasPermission", "adminMenuItems", "teamMenuItems", "helpMenuItems", "profileMenuItems", "renderWsLayoutMenuItem", "appLayoutProps", "pageLayoutProps", "topNavigationProps", "leftNavigationProps", "loadingPageProps", "menuItemRenderLabel", "variant", "onVariantChange", "$leftNavigationWidth", "collapsed", "onCollapsedChange"]);
  const _theme = /*#__PURE__*/useTheme();
  const theme$1 = isEmpty(_theme) ? theme : _theme;
  const [stateVariant, setVariant] = useState(initialVariant);
  const targetVariant = propVariant !== null && propVariant !== void 0 ? propVariant : stateVariant;
  const onVariantChange = propOnVariantChange !== null && propOnVariantChange !== void 0 ? propOnVariantChange : setVariant;
  const [loading, setLoading] = useState(false);
  const debouncedVariant = useDebounce(targetVariant, {
    wait: 1000
  });
  // Delay 1000 seconds when loading to hide the left nav flickering behind the loading page
  const variant = loading ? debouncedVariant : targetVariant;
  const profileTitle = [user.first_name, user.last_name].filter(x => x).map(x => {
    var _a;
    return (_a = x === null || x === void 0 ? void 0 : x[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase();
  }).join('');
  const renderItem = useMemo(() => createRenderMenuItem({
    isFeatureFlagOn,
    companyHasFunctionModule,
    userHasPermission,
    renderWsLayoutMenuItem
  }), [companyHasFunctionModule, isFeatureFlagOn, userHasPermission, renderWsLayoutMenuItem]);
  const renderLabel = menuItemRenderLabel;
  const leftNavigationProps = Object.assign(Object.assign({
    collapsed,
    onCollapsedChange,
    menuItems: variant === 'team' ? teamMenuItems : adminMenuItems,
    title: variant === 'admin' ? 'ADMIN' : undefined,
    colorTheme: variant === 'team' ? 'dark' : 'light',
    footerMenuItemProps: {
      index: 'footer-switch-button',
      icon: variant === 'team' ? jsx(Settings, {}) :
      // wrap a div to avoid size to be overwritten by the class name .ant4-menu-item-icon
      // The icon itself has a small offset to the left, so we need to offset it back to the right
      jsx(Box, {
        marginX: "-2px",
        zIndex: 1,
        children: jsx(WsLogo, {
          "$size": 24
        })
      }),
      label: `Switch to ${variant === 'team' ? 'admin' : 'team'} view`,
      onClick: () => {
        setLoading(true);
        onVariantChange(variant === 'team' ? 'admin' : 'team');
      },
      renderLabel
    }
  }, propLeftNavigationProps), {
    mainMenuProps: Object.assign({
      omitPropKeys,
      renderLabel,
      renderItem
    }, propLeftNavigationProps === null || propLeftNavigationProps === void 0 ? void 0 : propLeftNavigationProps.mainMenuProps)
  });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const {
    matches: isMobile
  } = useMediaQuery({
    max: 'desktopSmall'
  });
  return jsxs(Fragment, {
    children: [jsxs(Layout, Object.assign({
      variant: "app"
    }, restProps, appLayoutProps, {
      children: [leftNavigation !== null && leftNavigation !== void 0 ? leftNavigation : jsx(LeftNavigation, Object.assign({
        "data-testid": "left-navigation-sidebar"
      }, leftNavigationProps, {
        display: {
          ps: 'none',
          t: 'flex'
        }
      })), jsxs(S$3.PageLayout, Object.assign({
        collapsed: collapsed,
        flexColumnProps: {
          width: '100%',
          style: {
            overflowX: 'auto'
          }
        },
        "$leftNavigationWidth": leftNavigation !== false ? $leftNavigationWidth : 0
      }, pageLayoutProps, {
        children: [topNavigation !== null && topNavigation !== void 0 ? topNavigation : jsx(TopNavigation, Object.assign({
          "data-testid": "top-navigation",
          helpMenuItems: helpMenuItems,
          profileTitle: profileTitle,
          profileMenuItems: profileMenuItems,
          profileDropdown: {
            overlayStyle: {
              zIndex: theme$1.zIndex.appBar + 1
            }
          },
          profileMenu: {
            renderLabel,
            renderItem
          },
          helpMenu: {
            renderLabel,
            renderItem
          },
          extra: notificationsButton,
          helpDropdown: {
            overlayStyle: {
              zIndex: theme$1.zIndex.appBar + 1
            }
          }
        }, topNavigationProps, {
          title: jsxs(FlexBox, {
            align: "center",
            gap: "6px",
            children: [jsx(FlexBox, {
              "data-testid": "left-navigation-drawer-toggle-btn",
              width: 40,
              height: 40,
              alignItems: "center",
              justifyContent: "center",
              display: {
                ps: 'flex',
                t: 'none'
              },
              onClick: () => setDrawerOpen(true),
              children: jsx(Hamburger, {})
            }), jsx(Typography, {
              variant: "h1",
              ellipsis: 1,
              children: (_a = topNavigationProps === null || topNavigationProps === void 0 ? void 0 : topNavigationProps.title) !== null && _a !== void 0 ? _a : 'Home'
            })]
          })
        })), children]
      }))]
    })), isMobile && jsx(Drawer, {
      visible: drawerOpen,
      width: 240,
      bodyStyle: {
        padding: 0
      },
      onClose: () => setDrawerOpen(false),
      zIndex: theme$1.zIndex.drawer,
      children: jsx(LeftNavigation, Object.assign({
        "data-testid": "left-navigation-drawer"
      }, leftNavigationProps, {
        mainMenuProps: Object.assign(Object.assign({}, leftNavigationProps === null || leftNavigationProps === void 0 ? void 0 : leftNavigationProps.mainMenuProps), {
          onMenuItemClick: () => setDrawerOpen(false)
        }),
        collapsed: false,
        display: {
          ps: 'flex',
          t: 'none'
        },
        headerLogoBannerProps: {
          collapseButton: jsx(Cross, {
            "data-testid": "left-navigation-drawer-close-btn",
            size: 32,
            color: "gray500",
            onClick: () => setDrawerOpen(false)
          })
        },
        color: {
          ps: 'gray500',
          t: 'white'
        }
      }))
    }), showLoadingPage && jsx(LoadingPage, Object.assign({
      visible: loading,
      variant: targetVariant === 'admin' ? 'light' : 'dark',
      onAnimationEnd: () => setLoading(false)
    }, loadingPageProps))]
  });
};

const defaultColorsByStatus = {
  default: {
    borderColor: 'gray600',
    bgColor: 'gray600',
    color: 'textPrimary'
  },
  disabled: {
    borderColor: 'gray400',
    bgColor: 'gray400',
    color: 'textDisabled'
  },
  error: {
    borderColor: 'red500',
    bgColor: 'red500',
    color: 'textPrimary'
  }
};
const Radio$2 = /*#__PURE__*/styled(Box).withConfig({
  displayName: "radiostyles__Radio",
  componentId: "sc-hjgl19-0"
})(props => {
  const {
    theme: propTheme,
    borderColor,
    bgColor,
    color,
    disabled,
    error
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  const status = error ? 'error' : disabled ? 'disabled' : 'default';
  const defaultColors = defaultColorsByStatus[status];
  return css(["display:flex;align-items:center;column-gap:8px;height:20px;display:flex;align-items:flex-start;> input{width:20px;height:20px;appearance:none;margin:0;border:1px solid ", ";border-radius:50%;transition:all 0.1s ease-in-out;cursor:", ";position:relative;&::after{content:'';display:block;border-radius:50%;width:18px;height:18px;margin:0;top:0;left:0;transform:scale(0.5);}&:checked::after{background-color:", ";}}> label{cursor:", ";line-height:20px;color:", ";display:flex;flex-direction:column;row-gap:4px;}"], borderColor !== null && borderColor !== void 0 ? borderColor : theme$1.getColor(defaultColors.borderColor), disabled ? 'not-allowed' : 'pointer', bgColor !== null && bgColor !== void 0 ? bgColor : theme$1.getColor(defaultColors.bgColor), disabled ? 'not-allowed' : 'pointer', color !== null && color !== void 0 ? color : theme$1.getColor(defaultColors.color));
});
const S$2 = {
  Radio: Radio$2
};

const RadioGroupContext = /*#__PURE__*/createContext(null);
const RadioGroupContextProvider = RadioGroupContext.Provider;

const Radio$1 = props => {
  var _a, _b;
  const {
      label,
      labelProps,
      error,
      defaultChecked,
      disabled: propDisabled,
      checked: propChecked,
      name: propName,
      id: propId,
      value,
      description,
      descriptionProps,
      onChange: propsOnChange,
      inputProps,
      wrapperProps
    } = props,
    restProps = __rest(props, ["label", "labelProps", "error", "defaultChecked", "disabled", "checked", "name", "id", "value", "description", "descriptionProps", "onChange", "inputProps", "wrapperProps"]);
  const propsRef = useRef(props);
  propsRef.current = props;
  const id = useMemo(() => propId !== null && propId !== void 0 ? propId : v4(), [propId]);
  const groupContext = useContext(RadioGroupContext);
  const name = (_a = groupContext === null || groupContext === void 0 ? void 0 : groupContext.name) !== null && _a !== void 0 ? _a : propName;
  const checked = groupContext ? (groupContext === null || groupContext === void 0 ? void 0 : groupContext.value) === value : propChecked;
  const disabled = (_b = groupContext === null || groupContext === void 0 ? void 0 : groupContext.disabled) !== null && _b !== void 0 ? _b : propDisabled;
  const onChange = useCallback(e => {
    var _a, _b;
    if (groupContext === null || groupContext === void 0 ? void 0 : groupContext.onChange) {
      groupContext === null || groupContext === void 0 ? void 0 : groupContext.onChange(value);
    }
    (_b = (_a = propsRef.current).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, e);
  }, [value, groupContext]);
  return jsxs(S$2.Radio, Object.assign({
    disabled: disabled,
    error: error
  }, restProps, {
    children: [jsx("input", Object.assign({
      type: "radio",
      disabled: disabled,
      checked: checked,
      defaultChecked: defaultChecked,
      name: name,
      id: id,
      onChange: onChange,
      value: value
    }, inputProps)), jsxs(ConditionalRenderer, {
      wrapper: children => jsx(FlexBox, Object.assign({
        as: "label",
        htmlFor: id
      }, omit(wrapperProps, 'color'), {
        "$color": wrapperProps === null || wrapperProps === void 0 ? void 0 : wrapperProps.color,
        column: true,
        children: children
      })),
      condition: !!label,
      children: [typeof label === 'string' ? jsx(Typography, Object.assign({
        variant: "body",
        disabled: disabled
      }, labelProps, {
        children: label
      })) : label, description && jsx(Typography, Object.assign({
        color: disabled ? 'textDisabled' : 'textSecondary',
        fontSize: 14,
        lineHeight: 20,
        fontWeight: 400
      }, descriptionProps, {
        children: description
      }))]
    })]
  }));
};

const RadioGroup = props => {
  const {
      layout,
      flexDirection,
      gap,
      options,
      name,
      value,
      disabled,
      onChange,
      children: propsChildren
    } = props,
    restProps = __rest(props, ["layout", "flexDirection", "gap", "options", "name", "value", "disabled", "onChange", "children"]);
  const children = (options === null || options === void 0 ? void 0 : options.length) ? options === null || options === void 0 ? void 0 : options.map((option, index) => {
    var _a;
    if (typeof option === 'string' || typeof option === 'number') {
      return jsx(Radio$1, {
        value: option,
        label: jsx(Typography, {
          children: option
        })
      }, option);
    }
    return jsx(Radio$1, Object.assign({}, option), (_a = option.id) !== null && _a !== void 0 ? _a : index);
  }) : propsChildren;
  return jsx(FlexBox, Object.assign({
    flexDirection: flexDirection !== null && flexDirection !== void 0 ? flexDirection : layout === 'vertical' ? 'column' : 'row',
    gap: gap !== null && gap !== void 0 ? gap : layout === 'vertical' ? '12px' : '40px'
  }, restProps, {
    children: jsx(RadioGroupContextProvider, {
      value: {
        onChange,
        value,
        disabled,
        name
      },
      children: children
    })
  }));
};

const Radio = Radio$1;
Radio.Group = RadioGroup;

const duration = '0.3s';
const SwitchContainer = /*#__PURE__*/styled(FlexBox).attrs(props => {
  const {
    theme: propTheme
  } = props;
  const theme$1 = isEmpty(propTheme) ? theme : propTheme;
  return {
    theme: theme$1
  };
}).withConfig({
  displayName: "switchstyles__SwitchContainer",
  componentId: "sc-1reassu-0"
})(["column-gap:8px;align-items:flex-start;.rc-switch{position:relative;display:inline-block;box-sizing:border-box;width:40px;height:24px;line-height:24px;padding:0;vertical-align:middle;border-radius:12px;background-color:", ";cursor:pointer;transition:all ", " cubic-bezier(0.35,0,0.25,1);overflow:hidden;&:after{position:absolute;width:16px;height:16px;left:6px;top:4px;border-radius:50% 50%;background-color:#fff;content:' ';cursor:pointer;transform:scale(1);transition:left ", " cubic-bezier(0.35,0,0.25,1);animation-timing-function:cubic-bezier(0.35,0,0.25,1);animation-duration:", ";}&-checked{background-color:", ";&:after{left:18px;}}&-disabled{cursor:no-drop;background:", ";&:after{background:#fff;animation-name:none;cursor:no-drop;}&:hover:after{animation-name:none;}}}"], props => props.theme.colors.gray400, duration, duration, duration, props => props.theme.colors.blue500, props => props.theme.colors.gray300);
const S$1 = {
  SwitchContainer
};

const Switch = props => {
  const {
      label,
      rootProps,
      wrapperProps,
      labelProps,
      description,
      descriptionProps,
      disabled
    } = props,
    restProps = __rest(props, ["label", "rootProps", "wrapperProps", "labelProps", "description", "descriptionProps", "disabled"]);
  return jsxs(S$1.SwitchContainer, Object.assign({}, rootProps, {
    children: [jsx(RcSwitch, Object.assign({}, restProps, {
      disabled: disabled
    })), jsxs(ConditionalRenderer, {
      condition: !!label,
      wrapper: children => jsx(FlexBox, Object.assign({
        direction: "column",
        gap: "2px"
      }, wrapperProps, {
        children: children
      })),
      children: [typeof label === 'string' ? jsx(Typography, Object.assign({
        lineHeight: 24,
        color: disabled ? 'textDisabled' : 'textPrimary'
      }, labelProps, {
        children: label
      })) : label, description && jsx(Typography, Object.assign({
        color: disabled ? 'textDisabled' : 'textSecondary',
        fontSize: 14,
        lineHeight: 20,
        fontWeight: 400
      }, descriptionProps, {
        children: description
      }))]
    })]
  }));
};

const defaultPropsByVariant$1 = {
  default: {
    bgColor: 'surfaceBackground',
    borderColor: 'borderDefault',
    'data-testid': 'pill-default',
    indicatorBg: 'gray600'
  },
  primary: {
    bgColor: 'surfaceInfo',
    borderColor: 'blue300',
    'data-testid': 'pill-primary',
    indicatorBg: 'statusInfo'
  },
  warning: {
    bgColor: 'surfaceWarning',
    borderColor: 'gold300',
    'data-testid': 'pill-warning',
    indicatorBg: 'statusWarning'
  },
  error: {
    bgColor: 'surfaceError',
    borderColor: 'red300',
    'data-testid': 'pill-error',
    indicatorBg: 'statusError'
  },
  success: {
    bgColor: 'surfaceSuccess',
    borderColor: 'green300',
    'data-testid': 'pill-success',
    indicatorBg: 'statusSuccess'
  }
};

function Pill(props) {
  const {
      type,
      variant = type,
      showIndicator = true
    } = props,
    restProps = __rest(props, ["type", "variant", "showIndicator"]);
  const defaultProps = defaultPropsByVariant$1[variant !== null && variant !== void 0 ? variant : 'default'];
  const _a = Object.assign(Object.assign({}, defaultProps), restProps),
    {
      children,
      leftSection,
      rightSection,
      indicatorBg,
      innerWrapperProps
    } = _a,
    remainingProps = __rest(_a, ["children", "leftSection", "rightSection", "indicatorBg", "innerWrapperProps"]);
  return jsxs(FlexBox, Object.assign({
    borderRadius: "chips",
    justify: "flex-start",
    align: "center",
    gap: "8px",
    color: "textPrimary",
    px: "12px",
    py: "4px",
    width: "min-content",
    style: {
      whiteSpace: 'nowrap'
    }
  }, remainingProps, {
    children: [jsxs(FlexBox, Object.assign({
      gap: "4px",
      align: "center"
    }, innerWrapperProps, {
      children: [leftSection !== null && leftSection !== void 0 ? leftSection : showIndicator ? jsx(Box, {
        "data-testid": "pill-indicator",
        width: "8px",
        height: "8px",
        borderRadius: "chips",
        bgColor: indicatorBg
      }) : null, children]
    })), rightSection]
  }));
}

const buttonSizeStyleByVariant = {
  small: {
    minWidth: '80px',
    height: '36px'
  },
  medium: {
    minWidth: '120px',
    height: '40px'
  },
  large: {
    minWidth: '140px',
    height: '42px'
  }
};
const buttonSizeCssByVariant = {
  small: css(["font-size:14px;border-radius:6px;"]),
  medium: css(["font-size:16px;border-radius:8px;"]),
  large: css(["font-size:18px;border-radius:8px;"])
};
const buttonOnlyIconStyle = {
  small: css(["min-width:unset;width:36px;padding:initial;"]),
  medium: css(["min-width:unset;width:44px;padding:initial;"]),
  large: css(["min-width:unset;width:50px;padding:initial;"])
};
const transparent = 'rgba(0, 0, 0, 0)';
const buttonStyleByVariant = {
  primary: {
    textColor: colors.white,
    disabledTextColor: colors.gray100,
    bgColor: colors.blue500,
    borderColor: colors.blue500,
    hoverBgColor: colors.blue600,
    hoverBorderColor: colors.blue600,
    focusedBgColor: colors.blue600,
    focusedBorderColor: colors.blue600,
    pressedBgColor: colors.blue600,
    pressedBorderColor: colors.blue600,
    disabledBgColor: colors.blue200,
    disabledBorderColor: colors.blue200
  },
  secondary: {
    textColor: colors.gray800,
    disabledTextColor: colors.gray400,
    bgColor: colors.white,
    borderColor: colors.gray400,
    hoverBgColor: colors.gray100,
    hoverBorderColor: colors.gray400,
    focusedBgColor: colors.gray200,
    focusedBorderColor: colors.gray400,
    pressedBgColor: colors.gray200,
    pressedBorderColor: colors.gray400,
    disabledBgColor: colors.gray200,
    disabledBorderColor: colors.gray200
  },
  link: {
    textColor: colors.gray800,
    disabledTextColor: colors.gray400,
    bgColor: transparent,
    borderColor: transparent,
    hoverBgColor: transparent,
    hoverBorderColor: transparent,
    focusedBgColor: transparent,
    focusedBorderColor: transparent,
    pressedBgColor: transparent,
    pressedBorderColor: transparent,
    disabledBgColor: transparent,
    disabledBorderColor: transparent
  },
  danger: {
    textColor: colors.white,
    disabledTextColor: colors.gray100,
    bgColor: colors.red400,
    borderColor: colors.red400,
    hoverBgColor: colors.red500,
    hoverBorderColor: colors.red500,
    focusedBgColor: colors.red600,
    focusedBorderColor: colors.red600,
    pressedBgColor: colors.red600,
    pressedBorderColor: colors.red600,
    disabledBgColor: colors.red200,
    disabledBorderColor: colors.red200
  }
};
const buttonFullWidthStyle = /*#__PURE__*/css(["width:100%;"]);
const ButtonIcon = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: prop => !includes(['loading'], prop)
}).withConfig({
  displayName: "button-wrapper__ButtonIcon",
  componentId: "sc-q3jnwe-0"
})(["visibility:", ";"], props => props.loading ? 'hidden' : 'visible');
const generateButtonStyle = props => {
  const {
    size,
    className,
    onlyIcon
  } = props;
  const sizeStyle = buttonSizeCssByVariant[size || 'medium'];
  const isFullWidthBtn = className === null || className === void 0 ? void 0 : className.split(' ').includes('w-full');
  const btnOnlyIconStyle = buttonOnlyIconStyle[size || 'medium'];
  return css(["width:fit-content;position:relative;justify-content:center;font-family:'Plus Jakarta Sans','sans-serif';font-weight:600;border-radius:6px;", " ", " ", ""], sizeStyle, onlyIcon && btnOnlyIconStyle, isFullWidthBtn && buttonFullWidthStyle);
};
const BaseButton = /*#__PURE__*/styled(ButtonNew$1).withConfig({
  displayName: "button-wrapper__BaseButton",
  componentId: "sc-q3jnwe-1"
})(["", ""], props => generateButtonStyle(props));
const ButtonWrapper = props => {
  const {
      size: propSize = 'regular',
      loading = false,
      onlyIcon = false,
      icon,
      type = 'secondary',
      children,
      disabled = false,
      onClick,
      className
    } = props,
    restProps = __rest(props, ["size", "loading", "onlyIcon", "icon", "type", "children", "disabled", "onClick", "className"]);
  const classNameStr = classNames(className, 'btn');
  const size = useMemo(() => {
    switch (propSize) {
      case 'compact':
        return 'small';
      case 'regular':
        return 'medium';
      case 'large':
        return 'large';
      default:
        return size;
    }
  }, [propSize]);
  const buttonVariantStyles = buttonStyleByVariant[type];
  const buttonSizeStyles = buttonSizeStyleByVariant[size];
  return jsxs(BaseButton, Object.assign({
    type: type,
    size: size,
    iconPosition: "right",
    onClick: loading || disabled ? undefined : onClick,
    loading: loading,
    disabled: disabled,
    onlyIcon: onlyIcon,
    className: classNameStr
  }, buttonVariantStyles, buttonSizeStyles, restProps, {
    children: [onlyIcon && !loading ? icon : children, !onlyIcon && icon && jsx(ButtonIcon, {
      className: "btn_icon",
      loading: loading,
      children: icon
    })]
  }));
};

const fontWeightByName = {
  bold: 'bold',
  normal: 'normal',
  regular: 'normal',
  semibold: 600,
  inherit: 'inherit'
};
const defaultPropsByVariant = {
  default: {
    component: 'span',
    fontWeight: 'regular',
    fontSize: 14,
    lineHeight: '20px'
  },
  h1: {
    component: 'h1',
    fontWeight: 'bold',
    fontSize: 54,
    lineHeight: '67px'
  },
  h2: {
    component: 'h2',
    fontWeight: 'bold',
    fontSize: 32,
    lineHeight: '45px'
  },
  h3: {
    component: 'h3',
    fontWeight: 'bold',
    fontSize: 24,
    lineHeight: '34px'
  },
  h4: {
    component: 'h4',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: '28px'
  },
  h5: {
    component: 'h5',
    fontWeight: 'bold',
    fontSize: 16,
    lineHeight: '22px'
  },
  h6: {
    component: 'h6',
    fontWeight: 'semibold',
    fontSize: 12,
    lineHeight: '17px'
  },
  buttonLarge: {
    component: 'span',
    fontWeight: 'bold',
    fontSize: 18,
    lineHeight: '25px'
  },
  buttonDefault: {
    component: 'span',
    fontWeight: 'semibold',
    fontSize: 16,
    lineHeight: '22px'
  },
  buttonSmall: {
    component: 'span',
    fontWeight: 'semibold',
    fontSize: 14,
    lineHeight: '20px'
  },
  bodyLarge: {
    component: 'p',
    fontWeight: 'regular',
    fontSize: 16,
    lineHeight: '22px'
  },
  bodyDefault: {
    component: 'p',
    fontWeight: 'regular',
    fontSize: 14,
    lineHeight: '20px'
  },
  bodySmall: {
    component: 'p',
    fontWeight: 'regular',
    fontSize: 12,
    lineHeight: '17px'
  }
};

/**
 * Build typography style from style props
 */
const buildTextStyle = ({
  fontSize,
  fontWeight: _fontWeight = 'inherit',
  lineHeight,
  textAlign,
  color,
  ellipsis,
  id,
  maxCh,
  marginTop: _marginTop = 0,
  marginBottom: _marginBottom = 0
}) => css(["font-family:'Plus Jakarta Sans','Segoe UI',Arial,Helvetica,sans-serif;font-size:", ";line-height:", ";font-weight:", ";margin-top:", ";margin-bottom:", ";", " ", " ", " ", " ", ""], autoAddUnit(fontSize) || 'inherit', lineHeight ? typeof lineHeight === 'number' && lineHeight < 10 ? lineHeight : autoAddUnit(lineHeight) : 'inherit', fontWeightByName[_fontWeight] || _fontWeight, autoAddUnit(_marginTop), autoAddUnit(_marginBottom), textAlign && `text-align: ${textAlign};`, color && `color: ${getColor(color)};`, ellipsis && css(["display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:", ";"], ellipsis), id && 'scroll-margin-top: 100px;', maxCh && `max-width: ${maxCh}ch`);
const Text$1 = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: prop => !['color', 'fontSize', 'fontWeight'].includes(prop) && isPropValid(prop)
}).withConfig({
  displayName: "textstyle__Text",
  componentId: "sc-899a84-0"
})(["", ""], props => buildTextStyle(props));
const S = {
  Text: Text$1
};

const Text = props => {
  const variant = props.variant || 'default';
  const defaultProps = defaultPropsByVariant[variant];
  // Cannot use defaults(props, defaultProps) here;
  const mergedProps = defaults(Object.assign({}, props), defaultProps);
  return jsx(S.Text, Object.assign({
    variant: variant,
    as: mergedProps.component
  }, mergedProps));
};

const CardComponent = /*#__PURE__*/styled.div.withConfig({
  displayName: "card__CardComponent",
  componentId: "sc-b94ncy-0"
})(["display:flex;flex-direction:column;align-items:flex-start;border-radius:12px;padding:32px 40px;box-shadow:0px 1px 2px rgba(0,0,0,0.06),0px 1px 3px rgba(0,0,0,0.1);"]);
/**
 * Card
 */
const Card = _a => {
  var {
      className = '',
      header,
      description,
      children,
      testId
    } = _a,
    restProps = __rest(_a, ["className", "header", "description", "children", "testId"]);
  return jsxs(CardComponent, Object.assign({
    className: className
  }, restProps, {
    "data-testid": testId,
    children: [header != null && jsx(Text, {
      variant: "h3",
      children: header
    }), description != null && jsx(Text, {
      variant: "bodyDefault",
      color: "gray600",
      marginTop: 4,
      marginBottom: 32,
      children: description
    }), children]
  }));
};

const antd4CssPrefix = 'ant';
const diglogPrefixCls = `${antd4CssPrefix}-modal`;
const ModalStyleOverride = /*#__PURE__*/createGlobalStyle([".ws-modal > .", " > .", "-content .", "-header{padding:20px;height:auto;}.ws-modal > .", " > .", "-content .", "-footer{border-top:1px solid ", ";}.ws-modal > .", "{& > .", "-content{border-radius:12px;& .", "-close{height:64px;& .", "-close-x{display:flex;justify-content:center;align-items:center;}}& .", "-header{border-radius:12px 12px 0px 0px;height:64px;display:flex;align-items:center;& .", "-title{font-weight:700;}}& .", "-body{padding:20px;display:flex;}& .", "-footer{border-top:none;height:86px;display:flex;align-items:center;}}}"], diglogPrefixCls, diglogPrefixCls, diglogPrefixCls, diglogPrefixCls, diglogPrefixCls, diglogPrefixCls, getColor('gray300'), diglogPrefixCls, diglogPrefixCls, diglogPrefixCls, diglogPrefixCls, diglogPrefixCls, diglogPrefixCls, diglogPrefixCls, diglogPrefixCls);
function Modal(props) {
  const {
      wrapClassName,
      footer,
      footerRightAligned = true,
      confirmLoading,
      onOk,
      onCancel,
      okText = 'OK',
      cancelText = 'Cancel',
      okType = 'primary',
      okButtonProps,
      cancelButtonProps,
      hideFooter = false
    } = props,
    otherProps = __rest(props, ["wrapClassName", "footer", "footerRightAligned", "confirmLoading", "onOk", "onCancel", "okText", "cancelText", "okType", "okButtonProps", "cancelButtonProps", "hideFooter"]);
  function renderDefaultFooterContent() {
    return jsxs("div", {
      className: "actions",
      children: [jsx("div", {
        className: "action",
        children: jsx(ButtonWrapper, Object.assign({
          onClick: onCancel
        }, cancelButtonProps, {
          children: cancelText
        }))
      }), jsx("div", {
        className: "action",
        children: jsx(ButtonWrapper, Object.assign({
          type: okType,
          onClick: onOk,
          loading: confirmLoading
        }, okButtonProps, {
          children: okText
        }))
      })]
    });
  }
  let modalFooterContent = footer;
  let modalFooterClassName = 'ws-modal-footer';
  if (modalFooterContent == null) {
    modalFooterContent = renderDefaultFooterContent();
    modalFooterClassName = 'ws-modal-footer ws-modal-default-footer';
  }
  const modalFooter = hideFooter ? null : jsxs("div", {
    className: modalFooterClassName,
    children: [footerRightAligned && jsx("div", {
      className: "space"
    }), modalFooterContent]
  });
  const modalProps = Object.assign(Object.assign({}, otherProps), {
    wrapClassName: classNames('ws-modal', wrapClassName),
    closeIcon: jsx(Cross, {
      color: 'gray800'
    }),
    onCancel,
    footer: modalFooter
  });
  return jsxs(Fragment, {
    children: [jsx(ModalStyleOverride, {}), jsx(_Modal, Object.assign({}, modalProps))]
  });
}

export { Alert, Avatar, AvatarWithLabel, Box, ButtonWrapper as Button, ButtonNew, Card, Checkbox, ConditionalRenderer, Drawer, DrawerS, Dropdown, FlexBox, Grid, Alert as InlineNote, Layout, LeftNavigation, LeftNavigationS, Link, LoadingPage, Mask, Menu, MenuS, Modal, ModalNew, ModalNewS, Pill, Radio, Reflexbox4Box, Reflexbox4Flex, ConditionalRenderer as Render, Switch, Tabs, Text, ThemeUiFlex, TopNavigation, TopNavigationS, Typography, FormItem as UNSTABLE_FormItem, WsLayout, WsLogo, WsLogoPoweredByWorkstream, WsLogoS, WsLogoWorkstream, WsSpinLogo, mask, maskStyle, useMediaQuery, useRawMediaQuery, useRefs, useTabs, omitPropKeys as wsLayoutOmitPropKeys };
